{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "STATEFP": "36",
        "COUNTYFP": "105",
        "COUNTYNS": "00974150",
        "GEOIDFQ": "0500000US36105",
        "GEOID": "36105",
        "NAME": "Sullivan",
        "NAMELSAD": "Sullivan County",
        "STUSPS": "NY",
        "STATE_NAME": "New York",
        "LSAD": "06",
        "ALAND": 2507484144,
        "AWATER": 73737482
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -75.144744,
              41.851677
            ],
            [
              -75.029328,
              41.903972
            ],
            [
              -75.027113,
              41.90497
            ],
            [
              -75.003295,
              41.915655
            ],
            [
              -74.997252,
              41.918485
            ],
            [
              -74.985156,
              41.924007
            ],
            [
              -74.913218,
              41.956779
            ],
            [
              -74.908632,
              41.958755
            ],
            [
              -74.90805,
              41.959011
            ],
            [
              -74.852836,
              41.983446
            ],
            [
              -74.852022,
              41.983914
            ],
            [
              -74.847109,
              41.985837
            ],
            [
              -74.843928,
              41.987344
            ],
            [
              -74.800636,
              42.007133
            ],
            [
              -74.780693,
              42.016375
            ],
            [
              -74.749602,
              42.002937
            ],
            [
              -74.747123,
              42.002081
            ],
            [
              -74.742763,
              42.000089
            ],
            [
              -74.67402,
              41.971675
            ],
            [
              -74.670952,
              41.970382
            ],
            [
              -74.655032,
              41.963676
            ],
            [
              -74.601167,
              41.940684
            ],
            [
              -74.576557,
              41.92971
            ],
            [
              -74.453685,
              41.875595
            ],
            [
              -74.45382,
              41.875092
            ],
            [
              -74.483112,
              41.839817
            ],
            [
              -74.487829,
              41.834361
            ],
            [
              -74.490883,
              41.831316
            ],
            [
              -74.524531,
              41.797958
            ],
            [
              -74.525506,
              41.796817
            ],
            [
              -74.532956,
              41.789369
            ],
            [
              -74.543475,
              41.778933
            ],
            [
              -74.563193,
              41.757491
            ],
            [
              -74.570575,
              41.750091
            ],
            [
              -74.575086,
              41.745258
            ],
            [
              -74.56207,
              41.737772
            ],
            [
              -74.5569,
              41.734798
            ],
            [
              -74.53024,
              41.719448
            ],
            [
              -74.520697,
              41.71394
            ],
            [
              -74.491062,
              41.697185
            ],
            [
              -74.464778,
              41.682519
            ],
            [
              -74.455465,
              41.677327
            ],
            [
              -74.425354,
              41.660596
            ],
            [
              -74.421428,
              41.658506
            ],
            [
              -74.407597,
              41.651353
            ],
            [
              -74.395071,
              41.644876
            ],
            [
              -74.394373,
              41.642562
            ],
            [
              -74.392502,
              41.64124
            ],
            [
              -74.393242,
              41.640503
            ],
            [
              -74.39224,
              41.639295
            ],
            [
              -74.391551,
              41.637101
            ],
            [
              -74.391457,
              41.633455
            ],
            [
              -74.388303,
              41.629285
            ],
            [
              -74.386842,
              41.628239
            ],
            [
              -74.386314,
              41.626099
            ],
            [
              -74.387168,
              41.622661
            ],
            [
              -74.386203,
              41.620183
            ],
            [
              -74.38604,
              41.61824
            ],
            [
              -74.384008,
              41.615197
            ],
            [
              -74.380724,
              41.614125
            ],
            [
              -74.380841,
              41.611751
            ],
            [
              -74.37966,
              41.610744
            ],
            [
              -74.379549,
              41.607322
            ],
            [
              -74.37863,
              41.605545
            ],
            [
              -74.377494,
              41.605653
            ],
            [
              -74.375937,
              41.604574
            ],
            [
              -74.375332,
              41.602929
            ],
            [
              -74.376476,
              41.601772
            ],
            [
              -74.376138,
              41.598189
            ],
            [
              -74.375058,
              41.596886
            ],
            [
              -74.373073,
              41.596263
            ],
            [
              -74.370313,
              41.596507
            ],
            [
              -74.366086,
              41.595622
            ],
            [
              -74.365654,
              41.595092
            ],
            [
              -74.364486,
              41.593783
            ],
            [
              -74.368191,
              41.591353
            ],
            [
              -74.367055,
              41.590977
            ],
            [
              -74.36899,
              41.590258
            ],
            [
              -74.370089,
              41.58859
            ],
            [
              -74.377974,
              41.586385
            ],
            [
              -74.379951,
              41.587416
            ],
            [
              -74.380756,
              41.586158
            ],
            [
              -74.383515,
              41.583879
            ],
            [
              -74.386149,
              41.583132
            ],
            [
              -74.388452,
              41.583642
            ],
            [
              -74.389007,
              41.585295
            ],
            [
              -74.390613,
              41.586221
            ],
            [
              -74.391458,
              41.583704
            ],
            [
              -74.391305,
              41.582059
            ],
            [
              -74.393546,
              41.581958
            ],
            [
              -74.395429,
              41.580693
            ],
            [
              -74.396067,
              41.579139
            ],
            [
              -74.395788,
              41.577113
            ],
            [
              -74.397614,
              41.575094
            ],
            [
              -74.399345,
              41.575495
            ],
            [
              -74.401874,
              41.575332
            ],
            [
              -74.403836,
              41.57425
            ],
            [
              -74.404464,
              41.573101
            ],
            [
              -74.406952,
              41.572321
            ],
            [
              -74.408163,
              41.573805
            ],
            [
              -74.408278,
              41.575175
            ],
            [
              -74.409801,
              41.573291
            ],
            [
              -74.409786,
              41.5718
            ],
            [
              -74.411023,
              41.57123
            ],
            [
              -74.410222,
              41.570467
            ],
            [
              -74.408092,
              41.570394
            ],
            [
              -74.407625,
              41.568885
            ],
            [
              -74.409894,
              41.568217
            ],
            [
              -74.413026,
              41.568742
            ],
            [
              -74.41414,
              41.567803
            ],
            [
              -74.416274,
              41.568757
            ],
            [
              -74.416934,
              41.569821
            ],
            [
              -74.418399,
              41.569397
            ],
            [
              -74.417781,
              41.567911
            ],
            [
              -74.419321,
              41.565626
            ],
            [
              -74.418909,
              41.563586
            ],
            [
              -74.419733,
              41.562426
            ],
            [
              -74.42344,
              41.562643
            ],
            [
              -74.423307,
              41.559879
            ],
            [
              -74.426083,
              41.559268
            ],
            [
              -74.429959,
              41.557993
            ],
            [
              -74.429149,
              41.557009
            ],
            [
              -74.428662,
              41.55686
            ],
            [
              -74.427426,
              41.556601
            ],
            [
              -74.426896,
              41.556638
            ],
            [
              -74.426255,
              41.556485
            ],
            [
              -74.426216,
              41.556088
            ],
            [
              -74.426919,
              41.555925
            ],
            [
              -74.428865,
              41.556079
            ],
            [
              -74.430384,
              41.555916
            ],
            [
              -74.431417,
              41.554665
            ],
            [
              -74.43124,
              41.554322
            ],
            [
              -74.430416,
              41.554174
            ],
            [
              -74.430259,
              41.55407
            ],
            [
              -74.430359,
              41.553796
            ],
            [
              -74.43103,
              41.553721
            ],
            [
              -74.432021,
              41.553832
            ],
            [
              -74.432958,
              41.553736
            ],
            [
              -74.433893,
              41.553731
            ],
            [
              -74.434171,
              41.553541
            ],
            [
              -74.434393,
              41.552976
            ],
            [
              -74.434877,
              41.552166
            ],
            [
              -74.436152,
              41.550699
            ],
            [
              -74.435927,
              41.549704
            ],
            [
              -74.435036,
              41.548497
            ],
            [
              -74.434787,
              41.546688
            ],
            [
              -74.435089,
              41.54618
            ],
            [
              -74.435514,
              41.546117
            ],
            [
              -74.437078,
              41.546734
            ],
            [
              -74.438229,
              41.547441
            ],
            [
              -74.438616,
              41.54733
            ],
            [
              -74.438775,
              41.545046
            ],
            [
              -74.43789,
              41.543458
            ],
            [
              -74.439551,
              41.543023
            ],
            [
              -74.445176,
              41.544094
            ],
            [
              -74.445775,
              41.540873
            ],
            [
              -74.443787,
              41.540923
            ],
            [
              -74.443813,
              41.53862
            ],
            [
              -74.444602,
              41.537233
            ],
            [
              -74.447921,
              41.535379
            ],
            [
              -74.447939,
              41.534353
            ],
            [
              -74.450465,
              41.532955
            ],
            [
              -74.453527,
              41.53263
            ],
            [
              -74.45454,
              41.533369
            ],
            [
              -74.45604,
              41.531884
            ],
            [
              -74.45545,
              41.530112
            ],
            [
              -74.457462,
              41.529361
            ],
            [
              -74.456989,
              41.527784
            ],
            [
              -74.458792,
              41.526963
            ],
            [
              -74.46024,
              41.524656
            ],
            [
              -74.462356,
              41.523563
            ],
            [
              -74.465748,
              41.522862
            ],
            [
              -74.46484,
              41.519375
            ],
            [
              -74.465729,
              41.518326
            ],
            [
              -74.465616,
              41.516882
            ],
            [
              -74.468195,
              41.515886
            ],
            [
              -74.46889,
              41.514042
            ],
            [
              -74.472685,
              41.512443
            ],
            [
              -74.473336,
              41.511369
            ],
            [
              -74.476102,
              41.510239
            ],
            [
              -74.474055,
              41.508734
            ],
            [
              -74.473948,
              41.506899
            ],
            [
              -74.475811,
              41.505622
            ],
            [
              -74.475591,
              41.504334
            ],
            [
              -74.475619,
              41.503953
            ],
            [
              -74.483963,
              41.504256
            ],
            [
              -74.488518,
              41.503779
            ],
            [
              -74.491691,
              41.503495
            ],
            [
              -74.493801,
              41.504447
            ],
            [
              -74.496341,
              41.503669
            ],
            [
              -74.501171,
              41.503458
            ],
            [
              -74.504485,
              41.503465
            ],
            [
              -74.519529,
              41.502781
            ],
            [
              -74.529751,
              41.502394
            ],
            [
              -74.557366,
              41.50125
            ],
            [
              -74.56092,
              41.5006
            ],
            [
              -74.571897,
              41.500093
            ],
            [
              -74.575379,
              41.500093
            ],
            [
              -74.620472,
              41.498421
            ],
            [
              -74.740238,
              41.494139
            ],
            [
              -74.752399,
              41.493743
            ],
            [
              -74.753115,
              41.492389
            ],
            [
              -74.755008,
              41.491405
            ],
            [
              -74.760654,
              41.49079
            ],
            [
              -74.761715,
              41.489755
            ],
            [
              -74.762042,
              41.488065
            ],
            [
              -74.759741,
              41.485045
            ],
            [
              -74.759648,
              41.481856
            ],
            [
              -74.754495,
              41.478849
            ],
            [
              -74.754343,
              41.476294
            ],
            [
              -74.752344,
              41.472643
            ],
            [
              -74.752956,
              41.468087
            ],
            [
              -74.750853,
              41.465698
            ],
            [
              -74.750412,
              41.46433
            ],
            [
              -74.750832,
              41.463713
            ],
            [
              -74.753227,
              41.462398
            ],
            [
              -74.759897,
              41.460692
            ],
            [
              -74.75863,
              41.45429
            ],
            [
              -74.760017,
              41.452264
            ],
            [
              -74.7613,
              41.450012
            ],
            [
              -74.762466,
              41.449525
            ],
            [
              -74.762309,
              41.444352
            ],
            [
              -74.759483,
              41.442588
            ],
            [
              -74.758897,
              41.440743
            ],
            [
              -74.756578,
              41.436827
            ],
            [
              -74.756107,
              41.433947
            ],
            [
              -74.755087,
              41.433182
            ],
            [
              -74.752575,
              41.433241
            ],
            [
              -74.751868,
              41.432477
            ],
            [
              -74.752889,
              41.430302
            ],
            [
              -74.755479,
              41.429479
            ],
            [
              -74.756421,
              41.428009
            ],
            [
              -74.754708208531,
              41.424993374676497
            ],
            [
              -74.758587,
              41.423287
            ],
            [
              -74.763701,
              41.423612
            ],
            [
              -74.77065,
              41.42623
            ],
            [
              -74.773239,
              41.426352
            ],
            [
              -74.778029,
              41.425104
            ],
            [
              -74.784339,
              41.422397
            ],
            [
              -74.790417,
              41.42166
            ],
            [
              -74.793856,
              41.422671
            ],
            [
              -74.795396,
              41.42398
            ],
            [
              -74.799546,
              41.43129
            ],
            [
              -74.800095,
              41.432661
            ],
            [
              -74.80037,
              41.43606
            ],
            [
              -74.801225,
              41.4381
            ],
            [
              -74.805655,
              41.442101
            ],
            [
              -74.807582,
              41.442847
            ],
            [
              -74.812123,
              41.442982
            ],
            [
              -74.815770323292995,
              41.4414434407703
            ],
            [
              -74.817995,
              41.440505
            ],
            [
              -74.819620110928497,
              41.439269782624798
            ],
            [
              -74.82288,
              41.436792
            ],
            [
              -74.826031,
              41.431736
            ],
            [
              -74.828592,
              41.430698
            ],
            [
              -74.830671,
              41.430503
            ],
            [
              -74.834635,
              41.430796
            ],
            [
              -74.836915,
              41.431625
            ],
            [
              -74.845572,
              41.437577
            ],
            [
              -74.848602,
              41.440179
            ],
            [
              -74.8542,
              41.443166
            ],
            [
              -74.858578,
              41.444427
            ],
            [
              -74.864688,
              41.443993
            ],
            [
              -74.876721,
              41.440338
            ],
            [
              -74.888691,
              41.438259
            ],
            [
              -74.893913,
              41.43893
            ],
            [
              -74.896025,
              41.439987
            ],
            [
              -74.896399,
              41.442179
            ],
            [
              -74.894931,
              41.446099
            ],
            [
              -74.889075,
              41.451245
            ],
            [
              -74.889116,
              41.452534
            ],
            [
              -74.890358,
              41.455324
            ],
            [
              -74.892114,
              41.456959
            ],
            [
              -74.895069,
              41.45819
            ],
            [
              -74.904136776035998,
              41.4597948106532
            ],
            [
              -74.9042,
              41.459806
            ],
            [
              -74.906887,
              41.461131
            ],
            [
              -74.908103,
              41.464639
            ],
            [
              -74.908133,
              41.468117
            ],
            [
              -74.909181,
              41.472436
            ],
            [
              -74.909580875360902,
              41.472815857619501
            ],
            [
              -74.912517,
              41.475605
            ],
            [
              -74.912852983865207,
              41.475706253479601
            ],
            [
              -74.917282,
              41.477041
            ],
            [
              -74.923333814344204,
              41.477127200586096
            ],
            [
              -74.924092,
              41.477138
            ],
            [
              -74.926835,
              41.478327
            ],
            [
              -74.932317493769801,
              41.482137094800699
            ],
            [
              -74.932585,
              41.482323
            ],
            [
              -74.941798,
              41.483542
            ],
            [
              -74.945634,
              41.483213
            ],
            [
              -74.94808,
              41.480625
            ],
            [
              -74.956411,
              41.476735
            ],
            [
              -74.95826,
              41.476396
            ],
            [
              -74.965931422264305,
              41.477083505117299
            ],
            [
              -74.969887,
              41.477438
            ],
            [
              -74.981652,
              41.479945
            ],
            [
              -74.983341,
              41.480894
            ],
            [
              -74.984390210117795,
              41.482666237655401
            ],
            [
              -74.985004,
              41.483703
            ],
            [
              -74.985595,
              41.485863
            ],
            [
              -74.985469490405293,
              41.487035144203404
            ],
            [
              -74.985247,
              41.489113
            ],
            [
              -74.982463,
              41.496467
            ],
            [
              -74.982168,
              41.498486
            ],
            [
              -74.982385,
              41.500981
            ],
            [
              -74.983941045869898,
              41.505389927150297
            ],
            [
              -74.984372,
              41.506611
            ],
            [
              -74.985653,
              41.507926
            ],
            [
              -74.987645,
              41.508738
            ],
            [
              -74.993893,
              41.508754
            ],
            [
              -74.999612,
              41.5074
            ],
            [
              -75.001329438607101,
              41.5077401877546
            ],
            [
              -75.001497144097897,
              41.507773406615598
            ],
            [
              -75.003151,
              41.508101
            ],
            [
              -75.003694,
              41.509295
            ],
            [
              -75.003706,
              41.511118
            ],
            [
              -75.003687957918004,
              41.511173745822397
            ],
            [
              -75.002592,
              41.51456
            ],
            [
              -75.000935,
              41.517638
            ],
            [
              -75.000911,
              41.519292
            ],
            [
              -75.001297,
              41.52065
            ],
            [
              -75.00385,
              41.524052
            ],
            [
              -75.009552,
              41.528461
            ],
            [
              -75.014919,
              41.531399
            ],
            [
              -75.016616,
              41.53211
            ],
            [
              -75.023018,
              41.533147
            ],
            [
              -75.024206,
              41.534018
            ],
            [
              -75.024757,
              41.535099
            ],
            [
              -75.024793012890498,
              41.5392290636902
            ],
            [
              -75.024798,
              41.539801
            ],
            [
              -75.022828,
              41.541456
            ],
            [
              -75.017626,
              41.542734
            ],
            [
              -75.016144,
              41.544246
            ],
            [
              -75.016328,
              41.546501
            ],
            [
              -75.018524,
              41.551802
            ],
            [
              -75.027343,
              41.563541
            ],
            [
              -75.029211,
              41.564637
            ],
            [
              -75.033162,
              41.565092
            ],
            [
              -75.036989,
              41.567049
            ],
            [
              -75.04049,
              41.569688
            ],
            [
              -75.043879,
              41.575094
            ],
            [
              -75.04676,
              41.583258
            ],
            [
              -75.052858,
              41.587772
            ],
            [
              -75.060012,
              41.590813
            ],
            [
              -75.061070785590303,
              41.591947186146598
            ],
            [
              -75.063677,
              41.594739
            ],
            [
              -75.066955,
              41.599428
            ],
            [
              -75.069712139420801,
              41.601690092841601
            ],
            [
              -75.074613,
              41.605711
            ],
            [
              -75.074626,
              41.607905
            ],
            [
              -75.071667,
              41.609501
            ],
            [
              -75.070971311511101,
              41.6096163491761
            ],
            [
              -75.067795,
              41.610143
            ],
            [
              -75.062716,
              41.609639
            ],
            [
              -75.061849775526497,
              41.609975527194301
            ],
            [
              -75.059725,
              41.610801
            ],
            [
              -75.059956,
              41.612306
            ],
            [
              -75.061675,
              41.615468
            ],
            [
              -75.06156,
              41.616429
            ],
            [
              -75.060098,
              41.617482
            ],
            [
              -75.05385,
              41.618655
            ],
            [
              -75.051856,
              41.618157
            ],
            [
              -75.051570820050799,
              41.617978629020499
            ],
            [
              -75.048385,
              41.615986
            ],
            [
              -75.047298,
              41.615791
            ],
            [
              -75.045508,
              41.616203
            ],
            [
              -75.044224,
              41.617978
            ],
            [
              -75.043562,
              41.62364
            ],
            [
              -75.048199,
              41.632011
            ],
            [
              -75.048658,
              41.633781
            ],
            [
              -75.049281,
              41.641862
            ],
            [
              -75.048945319858504,
              41.6499761412135
            ],
            [
              -75.048683,
              41.656317
            ],
            [
              -75.04992,
              41.662556
            ],
            [
              -75.053991,
              41.668194
            ],
            [
              -75.057251,
              41.668933
            ],
            [
              -75.05843,
              41.669653
            ],
            [
              -75.058441862849605,
              41.669688075631697
            ],
            [
              -75.059332,
              41.67232
            ],
            [
              -75.058765,
              41.674412
            ],
            [
              -75.052653,
              41.678436
            ],
            [
              -75.051285,
              41.679961
            ],
            [
              -75.051234,
              41.682439
            ],
            [
              -75.052736,
              41.688393
            ],
            [
              -75.056745,
              41.695703
            ],
            [
              -75.059829,
              41.699716
            ],
            [
              -75.066738690816194,
              41.705020015584203
            ],
            [
              -75.067278,
              41.705434
            ],
            [
              -75.06883,
              41.708161
            ],
            [
              -75.068642,
              41.710146
            ],
            [
              -75.06663,
              41.712588
            ],
            [
              -75.061174,
              41.712935
            ],
            [
              -75.052226,
              41.711396
            ],
            [
              -75.050689,
              41.711969
            ],
            [
              -75.049862,
              41.713309
            ],
            [
              -75.049699,
              41.715093
            ],
            [
              -75.053527,
              41.72715
            ],
            [
              -75.053998835693406,
              41.730080424933902
            ],
            [
              -75.054818,
              41.735168
            ],
            [
              -75.052808,
              41.744725
            ],
            [
              -75.053431,
              41.752538
            ],
            [
              -75.055990776963398,
              41.7567647059576
            ],
            [
              -75.060759,
              41.764638
            ],
            [
              -75.064901,
              41.766686
            ],
            [
              -75.068567,
              41.767298
            ],
            [
              -75.072664,
              41.768807
            ],
            [
              -75.073485303259005,
              41.769703777202302
            ],
            [
              -75.074231,
              41.770518
            ],
            [
              -75.075942,
              41.771518
            ],
            [
              -75.079478,
              41.771205
            ],
            [
              -75.09281,
              41.768361
            ],
            [
              -75.095451,
              41.768366
            ],
            [
              -75.10099,
              41.769121
            ],
            [
              -75.103492,
              41.771238
            ],
            [
              -75.104334,
              41.772693
            ],
            [
              -75.10464,
              41.774203
            ],
            [
              -75.103999328083702,
              41.778782161453201
            ],
            [
              -75.103548,
              41.782008
            ],
            [
              -75.102329,
              41.786503
            ],
            [
              -75.101463,
              41.787941
            ],
            [
              -75.092876,
              41.796386
            ],
            [
              -75.088328,
              41.797534
            ],
            [
              -75.081415,
              41.796483
            ],
            [
              -75.07827,
              41.797467
            ],
            [
              -75.076889,
              41.798509
            ],
            [
              -75.074412,
              41.802191
            ],
            [
              -75.073881038014505,
              41.803642863967497
            ],
            [
              -75.072168,
              41.808327
            ],
            [
              -75.071751,
              41.811901
            ],
            [
              -75.072172,
              41.813732
            ],
            [
              -75.074409,
              41.815088
            ],
            [
              -75.0773306539255,
              41.8151071898452
            ],
            [
              -75.078063,
              41.815112
            ],
            [
              -75.079818,
              41.814815
            ],
            [
              -75.085789,
              41.811626
            ],
            [
              -75.089484,
              41.811576
            ],
            [
              -75.090724892045699,
              41.812126793187801
            ],
            [
              -75.093537,
              41.813375
            ],
            [
              -75.100024,
              41.818347
            ],
            [
              -75.113334,
              41.822782
            ],
            [
              -75.114837,
              41.82567
            ],
            [
              -75.115147,
              41.827285
            ],
            [
              -75.114998,
              41.8303
            ],
            [
              -75.113441,
              41.836298
            ],
            [
              -75.113369,
              41.840698
            ],
            [
              -75.114399,
              41.843583
            ],
            [
              -75.115598,
              41.844638
            ],
            [
              -75.118789,
              41.845819
            ],
            [
              -75.127913,
              41.844903
            ],
            [
              -75.130983,
              41.845145
            ],
            [
              -75.140241,
              41.852078
            ],
            [
              -75.143824,
              41.851737
            ],
            [
              -75.144676133874498,
              41.851464655153798
            ],
            [
              -75.144744,
              41.851677
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "STATEFP": "36",
        "COUNTYFP": "111",
        "COUNTYNS": "00974153",
        "GEOIDFQ": "0500000US36111",
        "GEOID": "36111",
        "NAME": "Ulster",
        "NAMELSAD": "Ulster County",
        "STUSPS": "NY",
        "STATE_NAME": "New York",
        "LSAD": "06",
        "ALAND": 2911757764,
        "AWATER": 94596810
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -74.780693,
              42.016375
            ],
            [
              -74.749602,
              42.030755
            ],
            [
              -74.702768,
              42.05259
            ],
            [
              -74.669689,
              42.067819
            ],
            [
              -74.624599,
              42.088582
            ],
            [
              -74.566002,
              42.115764
            ],
            [
              -74.553598,
              42.121484
            ],
            [
              -74.548265,
              42.127406
            ],
            [
              -74.546925,
              42.128566
            ],
            [
              -74.530985,
              42.146475
            ],
            [
              -74.50914,
              42.1452
            ],
            [
              -74.503984,
              42.14492
            ],
            [
              -74.451713,
              42.169225
            ],
            [
              -74.450322,
              42.168698
            ],
            [
              -74.413678,
              42.154844
            ],
            [
              -74.32448,
              42.120753
            ],
            [
              -74.307571,
              42.114346
            ],
            [
              -74.286479,
              42.112814
            ],
            [
              -74.280754,
              42.112356
            ],
            [
              -74.271606,
              42.111625
            ],
            [
              -74.224748,
              42.107975
            ],
            [
              -74.171495,
              42.103939
            ],
            [
              -74.075423,
              42.096637
            ],
            [
              -74.074797,
              42.096589
            ],
            [
              -74.063817,
              42.121582
            ],
            [
              -74.042393,
              42.170386
            ],
            [
              -74.024878,
              42.162134
            ],
            [
              -74.017775,
              42.162273
            ],
            [
              -74.003589,
              42.163365
            ],
            [
              -74.002519,
              42.176162
            ],
            [
              -74.00245,
              42.176992
            ],
            [
              -73.989381,
              42.169363
            ],
            [
              -73.972946,
              42.159971
            ],
            [
              -73.946941,
              42.145162
            ],
            [
              -73.926233,
              42.133323
            ],
            [
              -73.918786,
              42.129159
            ],
            [
              -73.910675,
              42.127293
            ],
            [
              -73.915321,
              42.121337
            ],
            [
              -73.918873,
              42.114137
            ],
            [
              -73.921465,
              42.110025
            ],
            [
              -73.922553,
              42.10665
            ],
            [
              -73.923273,
              42.10217
            ],
            [
              -73.924729,
              42.095418
            ],
            [
              -73.926682,
              42.090298
            ],
            [
              -73.929114,
              42.081658
            ],
            [
              -73.929626,
              42.078778
            ],
            [
              -73.929688,
              42.078422
            ],
            [
              -73.929754,
              42.075306
            ],
            [
              -73.926186,
              42.07193
            ],
            [
              -73.92729,
              42.066858
            ],
            [
              -73.928314,
              42.066778
            ],
            [
              -73.928234,
              42.064874
            ],
            [
              -73.932282,
              42.061578
            ],
            [
              -73.932877,
              42.059943
            ],
            [
              -73.932763,
              42.055034
            ],
            [
              -73.934395,
              42.044747
            ],
            [
              -73.934171,
              42.039547
            ],
            [
              -73.936235,
              42.035835
            ],
            [
              -73.937051,
              42.032923
            ],
            [
              -73.937171,
              42.030268
            ],
            [
              -73.937035,
              42.026827
            ],
            [
              -73.934639,
              42.023304
            ],
            [
              -73.933819,
              42.021339
            ],
            [
              -73.933323,
              42.018491
            ],
            [
              -73.933435,
              42.015659
            ],
            [
              -73.934315,
              42.012779
            ],
            [
              -73.936796,
              42.006651
            ],
            [
              -73.940044,
              41.999003
            ],
            [
              -73.939788,
              41.995579
            ],
            [
              -73.940412,
              41.994347
            ],
            [
              -73.941564,
              41.992475
            ],
            [
              -73.943336,
              41.985534
            ],
            [
              -73.943494,
              41.985167
            ],
            [
              -73.944478,
              41.981813
            ],
            [
              -73.945855,
              41.977616
            ],
            [
              -73.947212,
              41.973372
            ],
            [
              -73.950076,
              41.965756
            ],
            [
              -73.950877,
              41.962428
            ],
            [
              -73.952829,
              41.957067
            ],
            [
              -73.953709,
              41.952748
            ],
            [
              -73.954205,
              41.950812
            ],
            [
              -73.955597,
              41.936188
            ],
            [
              -73.957421,
              41.926572
            ],
            [
              -73.957938,
              41.92198
            ],
            [
              -73.958301,
              41.920332
            ],
            [
              -73.961101,
              41.918316
            ],
            [
              -73.964237,
              41.913916
            ],
            [
              -73.964413,
              41.913148
            ],
            [
              -73.964189,
              41.910156
            ],
            [
              -73.962781,
              41.90582
            ],
            [
              -73.962221,
              41.90102
            ],
            [
              -73.961835,
              41.900508
            ],
            [
              -73.960829,
              41.899052
            ],
            [
              -73.955213,
              41.892908
            ],
            [
              -73.954301,
              41.891436
            ],
            [
              -73.945629,
              41.882188
            ],
            [
              -73.941885,
              41.8763
            ],
            [
              -73.940406,
              41.872979
            ],
            [
              -73.939581,
              41.870044
            ],
            [
              -73.939389,
              41.865852
            ],
            [
              -73.940349,
              41.862284
            ],
            [
              -73.941933,
              41.859244
            ],
            [
              -73.946589,
              41.854236
            ],
            [
              -73.948477,
              41.8507
            ],
            [
              -73.948941,
              41.848636
            ],
            [
              -73.949373,
              41.843916
            ],
            [
              -73.949789,
              41.836972
            ],
            [
              -73.948685,
              41.828332
            ],
            [
              -73.949741,
              41.821212
            ],
            [
              -73.948452,
              41.816642
            ],
            [
              -73.948333,
              41.815741
            ],
            [
              -73.949357,
              41.811341
            ],
            [
              -73.949725,
              41.803389
            ],
            [
              -73.949597,
              41.800125
            ],
            [
              -73.952014,
              41.791581
            ],
            [
              -73.951982,
              41.790477
            ],
            [
              -73.952446,
              41.787965
            ],
            [
              -73.951614,
              41.770621
            ],
            [
              -73.951134,
              41.769421
            ],
            [
              -73.946589,
              41.763677
            ],
            [
              -73.943514,
              41.759979
            ],
            [
              -73.941709,
              41.757357
            ],
            [
              -73.940989,
              41.755741
            ],
            [
              -73.940829,
              41.754317
            ],
            [
              -73.941431,
              41.744202
            ],
            [
              -73.941741,
              41.739021
            ],
            [
              -73.941081,
              41.735993
            ],
            [
              -73.941081,
              41.732693
            ],
            [
              -73.94208,
              41.727036
            ],
            [
              -73.942301,
              41.725789
            ],
            [
              -73.944435,
              41.714634
            ],
            [
              -73.944971,
              41.710582
            ],
            [
              -73.946069,
              41.702886
            ],
            [
              -73.946682,
              41.699396
            ],
            [
              -73.945782,
              41.695593
            ],
            [
              -73.943482,
              41.690293
            ],
            [
              -73.942482,
              41.684093
            ],
            [
              -73.943282,
              41.679393
            ],
            [
              -73.945182,
              41.675893
            ],
            [
              -73.947033,
              41.668826
            ],
            [
              -73.947382,
              41.667493
            ],
            [
              -73.947382,
              41.661893
            ],
            [
              -73.946882,
              41.656393
            ],
            [
              -73.948182,
              41.652493
            ],
            [
              -73.948982,
              41.644793
            ],
            [
              -73.948782,
              41.642193
            ],
            [
              -73.950644,
              41.632639
            ],
            [
              -73.951482,
              41.627693
            ],
            [
              -73.952582,
              41.625193
            ],
            [
              -73.952082,
              41.613993
            ],
            [
              -73.952274,
              41.609154
            ],
            [
              -73.952582,
              41.595293
            ],
            [
              -73.953282,
              41.590193
            ],
            [
              -73.953307,
              41.589977
            ],
            [
              -73.982658,
              41.587113
            ],
            [
              -73.98635,
              41.586817
            ],
            [
              -73.999584,
              41.585805
            ],
            [
              -74.004434,
              41.585171
            ],
            [
              -74.026844,
              41.582979
            ],
            [
              -74.037125,
              41.582044
            ],
            [
              -74.041328,
              41.581655
            ],
            [
              -74.050724,
              41.580871
            ],
            [
              -74.053942,
              41.580724
            ],
            [
              -74.053804,
              41.586065
            ],
            [
              -74.068083,
              41.606001
            ],
            [
              -74.074432,
              41.603649
            ],
            [
              -74.08076,
              41.601589
            ],
            [
              -74.084578,
              41.600437
            ],
            [
              -74.089896,
              41.598602
            ],
            [
              -74.094419,
              41.605452
            ],
            [
              -74.098653,
              41.607259
            ],
            [
              -74.134511,
              41.615695
            ],
            [
              -74.130471,
              41.599198
            ],
            [
              -74.126393,
              41.582544
            ],
            [
              -74.137588,
              41.584691
            ],
            [
              -74.160738,
              41.589408
            ],
            [
              -74.170969,
              41.591252
            ],
            [
              -74.177297,
              41.592729
            ],
            [
              -74.184531,
              41.593961
            ],
            [
              -74.185361,
              41.594128
            ],
            [
              -74.187505,
              41.590793
            ],
            [
              -74.202248,
              41.59429
            ],
            [
              -74.236555,
              41.601846
            ],
            [
              -74.240179,
              41.602662
            ],
            [
              -74.244911,
              41.603758
            ],
            [
              -74.251601,
              41.605374
            ],
            [
              -74.250222,
              41.625875
            ],
            [
              -74.250186,
              41.629324
            ],
            [
              -74.264093,
              41.632738
            ],
            [
              -74.264676,
              41.63225
            ],
            [
              -74.266979,
              41.629525
            ],
            [
              -74.268613,
              41.628618
            ],
            [
              -74.271038,
              41.629275
            ],
            [
              -74.272346,
              41.628151
            ],
            [
              -74.275786,
              41.625639
            ],
            [
              -74.279112,
              41.625822
            ],
            [
              -74.280844,
              41.625216
            ],
            [
              -74.285966,
              41.621492
            ],
            [
              -74.289058,
              41.621342
            ],
            [
              -74.289704,
              41.619608
            ],
            [
              -74.292776,
              41.618272
            ],
            [
              -74.295212,
              41.619679
            ],
            [
              -74.29721,
              41.618721
            ],
            [
              -74.300286,
              41.616432
            ],
            [
              -74.304121,
              41.615788
            ],
            [
              -74.304711,
              41.615251
            ],
            [
              -74.304412,
              41.612151
            ],
            [
              -74.306701,
              41.60882
            ],
            [
              -74.307924,
              41.609355
            ],
            [
              -74.309317,
              41.611153
            ],
            [
              -74.310789,
              41.611487
            ],
            [
              -74.312046,
              41.61127
            ],
            [
              -74.314349,
              41.609592
            ],
            [
              -74.314792,
              41.607449
            ],
            [
              -74.316324,
              41.60543
            ],
            [
              -74.320161,
              41.603006
            ],
            [
              -74.323752,
              41.602957
            ],
            [
              -74.326502,
              41.602067
            ],
            [
              -74.329614,
              41.601547
            ],
            [
              -74.330384,
              41.600254
            ],
            [
              -74.329751,
              41.598622
            ],
            [
              -74.332033,
              41.596739
            ],
            [
              -74.3344,
              41.597511
            ],
            [
              -74.335627,
              41.597038
            ],
            [
              -74.336624,
              41.595374
            ],
            [
              -74.34068,
              41.594376
            ],
            [
              -74.342539,
              41.596829
            ],
            [
              -74.344713,
              41.597853
            ],
            [
              -74.346663,
              41.597783
            ],
            [
              -74.349354,
              41.598621
            ],
            [
              -74.351835,
              41.597735
            ],
            [
              -74.353189,
              41.59537
            ],
            [
              -74.351955,
              41.594791
            ],
            [
              -74.352115,
              41.592657
            ],
            [
              -74.353941,
              41.592975
            ],
            [
              -74.353704,
              41.591683
            ],
            [
              -74.358446,
              41.59109
            ],
            [
              -74.359801,
              41.592028
            ],
            [
              -74.363472,
              41.591965
            ],
            [
              -74.367055,
              41.590977
            ],
            [
              -74.368191,
              41.591353
            ],
            [
              -74.364486,
              41.593783
            ],
            [
              -74.365654,
              41.595092
            ],
            [
              -74.366086,
              41.595622
            ],
            [
              -74.370313,
              41.596507
            ],
            [
              -74.373073,
              41.596263
            ],
            [
              -74.375058,
              41.596886
            ],
            [
              -74.376138,
              41.598189
            ],
            [
              -74.376476,
              41.601772
            ],
            [
              -74.375332,
              41.602929
            ],
            [
              -74.375937,
              41.604574
            ],
            [
              -74.377494,
              41.605653
            ],
            [
              -74.37863,
              41.605545
            ],
            [
              -74.379549,
              41.607322
            ],
            [
              -74.37966,
              41.610744
            ],
            [
              -74.380841,
              41.611751
            ],
            [
              -74.380724,
              41.614125
            ],
            [
              -74.384008,
              41.615197
            ],
            [
              -74.38604,
              41.61824
            ],
            [
              -74.386203,
              41.620183
            ],
            [
              -74.387168,
              41.622661
            ],
            [
              -74.386314,
              41.626099
            ],
            [
              -74.386842,
              41.628239
            ],
            [
              -74.388303,
              41.629285
            ],
            [
              -74.391457,
              41.633455
            ],
            [
              -74.391551,
              41.637101
            ],
            [
              -74.39224,
              41.639295
            ],
            [
              -74.393242,
              41.640503
            ],
            [
              -74.392502,
              41.64124
            ],
            [
              -74.394373,
              41.642562
            ],
            [
              -74.395071,
              41.644876
            ],
            [
              -74.407597,
              41.651353
            ],
            [
              -74.421428,
              41.658506
            ],
            [
              -74.425354,
              41.660596
            ],
            [
              -74.455465,
              41.677327
            ],
            [
              -74.464778,
              41.682519
            ],
            [
              -74.491062,
              41.697185
            ],
            [
              -74.520697,
              41.71394
            ],
            [
              -74.53024,
              41.719448
            ],
            [
              -74.5569,
              41.734798
            ],
            [
              -74.56207,
              41.737772
            ],
            [
              -74.575086,
              41.745258
            ],
            [
              -74.570575,
              41.750091
            ],
            [
              -74.563193,
              41.757491
            ],
            [
              -74.543475,
              41.778933
            ],
            [
              -74.532956,
              41.789369
            ],
            [
              -74.525506,
              41.796817
            ],
            [
              -74.524531,
              41.797958
            ],
            [
              -74.490883,
              41.831316
            ],
            [
              -74.487829,
              41.834361
            ],
            [
              -74.483112,
              41.839817
            ],
            [
              -74.45382,
              41.875092
            ],
            [
              -74.453685,
              41.875595
            ],
            [
              -74.576557,
              41.92971
            ],
            [
              -74.601167,
              41.940684
            ],
            [
              -74.655032,
              41.963676
            ],
            [
              -74.670952,
              41.970382
            ],
            [
              -74.67402,
              41.971675
            ],
            [
              -74.742763,
              42.000089
            ],
            [
              -74.747123,
              42.002081
            ],
            [
              -74.749602,
              42.002937
            ],
            [
              -74.780693,
              42.016375
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "STATEFP": "36",
        "COUNTYFP": "027",
        "COUNTYNS": "00974112",
        "GEOIDFQ": "0500000US36027",
        "GEOID": "36027",
        "NAME": "Dutchess",
        "NAMELSAD": "Dutchess County",
        "STUSPS": "NY",
        "STATE_NAME": "New York",
        "LSAD": "06",
        "ALAND": 2060598611,
        "AWATER": 76906718
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -73.999911,
              41.459656
            ],
            [
              -73.998898,
              41.462984
            ],
            [
              -73.997584,
              41.475093
            ],
            [
              -73.99825,
              41.480625
            ],
            [
              -73.998584,
              41.483393
            ],
            [
              -73.997609,
              41.487212
            ],
            [
              -73.995029,
              41.497332
            ],
            [
              -73.994784,
              41.498293
            ],
            [
              -73.997075,
              41.50172
            ],
            [
              -73.997789,
              41.502784
            ],
            [
              -73.997884,
              41.505685
            ],
            [
              -73.99725,
              41.509769
            ],
            [
              -73.997184,
              41.513393
            ],
            [
              -73.997484,
              41.516493
            ],
            [
              -73.996536,
              41.522649
            ],
            [
              -73.994547,
              41.527138
            ],
            [
              -73.992949,
              41.529821
            ],
            [
              -73.989607,
              41.538671
            ],
            [
              -73.988753,
              41.541219
            ],
            [
              -73.987866,
              41.542789
            ],
            [
              -73.98593,
              41.545621
            ],
            [
              -73.982805,
              41.549195
            ],
            [
              -73.979933,
              41.55235
            ],
            [
              -73.977889,
              41.555234
            ],
            [
              -73.973372,
              41.559797
            ],
            [
              -73.972707,
              41.560356
            ],
            [
              -73.970214,
              41.562276
            ],
            [
              -73.964781,
              41.565311
            ],
            [
              -73.961913,
              41.568149
            ],
            [
              -73.959467,
              41.571443
            ],
            [
              -73.956831,
              41.576656
            ],
            [
              -73.954725,
              41.58179
            ],
            [
              -73.954146,
              41.583271
            ],
            [
              -73.953307,
              41.589977
            ],
            [
              -73.953282,
              41.590193
            ],
            [
              -73.952582,
              41.595293
            ],
            [
              -73.952274,
              41.609154
            ],
            [
              -73.952082,
              41.613993
            ],
            [
              -73.952582,
              41.625193
            ],
            [
              -73.951482,
              41.627693
            ],
            [
              -73.950644,
              41.632639
            ],
            [
              -73.948782,
              41.642193
            ],
            [
              -73.948982,
              41.644793
            ],
            [
              -73.948182,
              41.652493
            ],
            [
              -73.946882,
              41.656393
            ],
            [
              -73.947382,
              41.661893
            ],
            [
              -73.947382,
              41.667493
            ],
            [
              -73.947033,
              41.668826
            ],
            [
              -73.945182,
              41.675893
            ],
            [
              -73.943282,
              41.679393
            ],
            [
              -73.942482,
              41.684093
            ],
            [
              -73.943482,
              41.690293
            ],
            [
              -73.945782,
              41.695593
            ],
            [
              -73.946682,
              41.699396
            ],
            [
              -73.946069,
              41.702886
            ],
            [
              -73.944971,
              41.710582
            ],
            [
              -73.944435,
              41.714634
            ],
            [
              -73.942301,
              41.725789
            ],
            [
              -73.94208,
              41.727036
            ],
            [
              -73.941081,
              41.732693
            ],
            [
              -73.941081,
              41.735993
            ],
            [
              -73.941741,
              41.739021
            ],
            [
              -73.941431,
              41.744202
            ],
            [
              -73.940829,
              41.754317
            ],
            [
              -73.940989,
              41.755741
            ],
            [
              -73.941709,
              41.757357
            ],
            [
              -73.943514,
              41.759979
            ],
            [
              -73.946589,
              41.763677
            ],
            [
              -73.951134,
              41.769421
            ],
            [
              -73.951614,
              41.770621
            ],
            [
              -73.952446,
              41.787965
            ],
            [
              -73.951982,
              41.790477
            ],
            [
              -73.952014,
              41.791581
            ],
            [
              -73.949597,
              41.800125
            ],
            [
              -73.949725,
              41.803389
            ],
            [
              -73.949357,
              41.811341
            ],
            [
              -73.948333,
              41.815741
            ],
            [
              -73.948452,
              41.816642
            ],
            [
              -73.949741,
              41.821212
            ],
            [
              -73.948685,
              41.828332
            ],
            [
              -73.949789,
              41.836972
            ],
            [
              -73.949373,
              41.843916
            ],
            [
              -73.948941,
              41.848636
            ],
            [
              -73.948477,
              41.8507
            ],
            [
              -73.946589,
              41.854236
            ],
            [
              -73.941933,
              41.859244
            ],
            [
              -73.940349,
              41.862284
            ],
            [
              -73.939389,
              41.865852
            ],
            [
              -73.939581,
              41.870044
            ],
            [
              -73.940406,
              41.872979
            ],
            [
              -73.941885,
              41.8763
            ],
            [
              -73.945629,
              41.882188
            ],
            [
              -73.954301,
              41.891436
            ],
            [
              -73.955213,
              41.892908
            ],
            [
              -73.960829,
              41.899052
            ],
            [
              -73.961835,
              41.900508
            ],
            [
              -73.962221,
              41.90102
            ],
            [
              -73.962781,
              41.90582
            ],
            [
              -73.964189,
              41.910156
            ],
            [
              -73.964413,
              41.913148
            ],
            [
              -73.964237,
              41.913916
            ],
            [
              -73.961101,
              41.918316
            ],
            [
              -73.958301,
              41.920332
            ],
            [
              -73.957938,
              41.92198
            ],
            [
              -73.957421,
              41.926572
            ],
            [
              -73.955597,
              41.936188
            ],
            [
              -73.954205,
              41.950812
            ],
            [
              -73.953709,
              41.952748
            ],
            [
              -73.952829,
              41.957067
            ],
            [
              -73.950877,
              41.962428
            ],
            [
              -73.950076,
              41.965756
            ],
            [
              -73.947212,
              41.973372
            ],
            [
              -73.945855,
              41.977616
            ],
            [
              -73.944478,
              41.981813
            ],
            [
              -73.943494,
              41.985167
            ],
            [
              -73.943336,
              41.985534
            ],
            [
              -73.941564,
              41.992475
            ],
            [
              -73.940412,
              41.994347
            ],
            [
              -73.939788,
              41.995579
            ],
            [
              -73.940044,
              41.999003
            ],
            [
              -73.936796,
              42.006651
            ],
            [
              -73.934315,
              42.012779
            ],
            [
              -73.933435,
              42.015659
            ],
            [
              -73.933323,
              42.018491
            ],
            [
              -73.933819,
              42.021339
            ],
            [
              -73.934639,
              42.023304
            ],
            [
              -73.937035,
              42.026827
            ],
            [
              -73.937171,
              42.030268
            ],
            [
              -73.937051,
              42.032923
            ],
            [
              -73.936235,
              42.035835
            ],
            [
              -73.934171,
              42.039547
            ],
            [
              -73.934395,
              42.044747
            ],
            [
              -73.932763,
              42.055034
            ],
            [
              -73.932877,
              42.059943
            ],
            [
              -73.932282,
              42.061578
            ],
            [
              -73.928234,
              42.064874
            ],
            [
              -73.928314,
              42.066778
            ],
            [
              -73.92729,
              42.066858
            ],
            [
              -73.926186,
              42.07193
            ],
            [
              -73.929754,
              42.075306
            ],
            [
              -73.929688,
              42.078422
            ],
            [
              -73.929626,
              42.078778
            ],
            [
              -73.917098,
              42.076474
            ],
            [
              -73.915593,
              42.080906
            ],
            [
              -73.908633,
              42.07841
            ],
            [
              -73.907785,
              42.07961
            ],
            [
              -73.895488,
              42.07525
            ],
            [
              -73.870263,
              42.066037
            ],
            [
              -73.867712,
              42.065206
            ],
            [
              -73.844999,
              42.056687
            ],
            [
              -73.818533,
              42.046739
            ],
            [
              -73.817151,
              42.046252
            ],
            [
              -73.806755,
              42.042559
            ],
            [
              -73.790893,
              42.036808
            ],
            [
              -73.755669,
              42.023483
            ],
            [
              -73.736244,
              42.015702
            ],
            [
              -73.733797,
              42.014725
            ],
            [
              -73.71093,
              42.005488
            ],
            [
              -73.676078,
              42.000435
            ],
            [
              -73.672323,
              42.000091
            ],
            [
              -73.657333,
              41.997577
            ],
            [
              -73.642191,
              41.995016
            ],
            [
              -73.556048,
              41.981756
            ],
            [
              -73.539639,
              41.979696
            ],
            [
              -73.533414,
              41.978834
            ],
            [
              -73.530893,
              41.978487
            ],
            [
              -73.527072,
              41.97798
            ],
            [
              -73.524706,
              42.014
            ],
            [
              -73.524317,
              42.018254
            ],
            [
              -73.523584,
              42.026267
            ],
            [
              -73.521416,
              42.049966
            ],
            [
              -73.496879,
              42.049675
            ],
            [
              -73.487314,
              42.049638
            ],
            [
              -73.488223828605399,
              42.030047227255899
            ],
            [
              -73.489615,
              42.000092
            ],
            [
              -73.492975,
              41.958524
            ],
            [
              -73.493484502121404,
              41.953339471656001
            ],
            [
              -73.496527,
              41.92238
            ],
            [
              -73.496564648703895,
              41.921747111938998
            ],
            [
              -73.498304,
              41.892508
            ],
            [
              -73.499459410771394,
              41.881898628973403
            ],
            [
              -73.500910093996097,
              41.868577966787399
            ],
            [
              -73.500910817137793,
              41.868571326656998
            ],
            [
              -73.501984,
              41.858717
            ],
            [
              -73.504944,
              41.824285
            ],
            [
              -73.504992123076903,
              41.823900015384602
            ],
            [
              -73.505008,
              41.823773
            ],
            [
              -73.5079601692712,
              41.791526762021299
            ],
            [
              -73.510961,
              41.758749
            ],
            [
              -73.511018632007904,
              41.7576799262538
            ],
            [
              -73.5115449368014,
              41.747916972334302
            ],
            [
              -73.511906546325505,
              41.741209115662102
            ],
            [
              -73.511921,
              41.740941
            ],
            [
              -73.515991463867294,
              41.696286404613801
            ],
            [
              -73.516590775975899,
              41.689711714211903
            ],
            [
              -73.516785,
              41.687581
            ],
            [
              -73.517950050843396,
              41.670860790123001
            ],
            [
              -73.518237603552507,
              41.666733981689397
            ],
            [
              -73.520017,
              41.641197
            ],
            [
              -73.520073733201698,
              41.640010035044703
            ],
            [
              -73.521038324955398,
              41.619828966949001
            ],
            [
              -73.521041,
              41.619773
            ],
            [
              -73.527419093775094,
              41.554353374074203
            ],
            [
              -73.527420827250893,
              41.554335593944202
            ],
            [
              -73.530067,
              41.527194
            ],
            [
              -73.560811,
              41.526637
            ],
            [
              -73.573503,
              41.526462
            ],
            [
              -73.580153,
              41.526382
            ],
            [
              -73.604342,
              41.523874
            ],
            [
              -73.6205,
              41.521994
            ],
            [
              -73.638376,
              41.519546
            ],
            [
              -73.644727,
              41.518716
            ],
            [
              -73.645669,
              41.518579
            ],
            [
              -73.647635,
              41.518293
            ],
            [
              -73.653091,
              41.517405
            ],
            [
              -73.673285,
              41.514701
            ],
            [
              -73.681501,
              41.51362
            ],
            [
              -73.683849,
              41.513306
            ],
            [
              -73.715337,
              41.510049
            ],
            [
              -73.742474,
              41.507547
            ],
            [
              -73.759624,
              41.505869
            ],
            [
              -73.77068,
              41.504413
            ],
            [
              -73.795561,
              41.502268
            ],
            [
              -73.813193,
              41.500714
            ],
            [
              -73.814438,
              41.500603
            ],
            [
              -73.820968,
              41.500021
            ],
            [
              -73.838362,
              41.498414
            ],
            [
              -73.856497,
              41.496473
            ],
            [
              -73.861095,
              41.495951
            ],
            [
              -73.864997,
              41.49554
            ],
            [
              -73.87458,
              41.495073
            ],
            [
              -73.897755,
              41.49277
            ],
            [
              -73.901886,
              41.492386
            ],
            [
              -73.907533,
              41.490975
            ],
            [
              -73.918758,
              41.489783
            ],
            [
              -73.933775,
              41.488279
            ],
            [
              -73.975855,
              41.444885
            ],
            [
              -73.977924,
              41.442757
            ],
            [
              -73.978588,
              41.442119
            ],
            [
              -73.981486,
              41.438905
            ],
            [
              -73.986583,
              41.444893
            ],
            [
              -73.994832,
              41.450268
            ],
            [
              -73.997784,
              41.452193
            ],
            [
              -74.000108,
              41.456549
            ],
            [
              -73.999911,
              41.459656
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "STATEFP": "36",
        "COUNTYFP": "071",
        "COUNTYNS": "00974134",
        "GEOIDFQ": "0500000US36071",
        "GEOID": "36071",
        "NAME": "Orange",
        "NAMELSAD": "Orange County",
        "STUSPS": "NY",
        "STATE_NAME": "New York",
        "LSAD": "06",
        "ALAND": 2103272844,
        "AWATER": 67953621
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -74.762466,
              41.449525
            ],
            [
              -74.7613,
              41.450012
            ],
            [
              -74.760017,
              41.452264
            ],
            [
              -74.75863,
              41.45429
            ],
            [
              -74.759897,
              41.460692
            ],
            [
              -74.753227,
              41.462398
            ],
            [
              -74.750832,
              41.463713
            ],
            [
              -74.750412,
              41.46433
            ],
            [
              -74.750853,
              41.465698
            ],
            [
              -74.752956,
              41.468087
            ],
            [
              -74.752344,
              41.472643
            ],
            [
              -74.754343,
              41.476294
            ],
            [
              -74.754495,
              41.478849
            ],
            [
              -74.759648,
              41.481856
            ],
            [
              -74.759741,
              41.485045
            ],
            [
              -74.762042,
              41.488065
            ],
            [
              -74.761715,
              41.489755
            ],
            [
              -74.760654,
              41.49079
            ],
            [
              -74.755008,
              41.491405
            ],
            [
              -74.753115,
              41.492389
            ],
            [
              -74.752399,
              41.493743
            ],
            [
              -74.740238,
              41.494139
            ],
            [
              -74.620472,
              41.498421
            ],
            [
              -74.575379,
              41.500093
            ],
            [
              -74.571897,
              41.500093
            ],
            [
              -74.56092,
              41.5006
            ],
            [
              -74.557366,
              41.50125
            ],
            [
              -74.529751,
              41.502394
            ],
            [
              -74.519529,
              41.502781
            ],
            [
              -74.504485,
              41.503465
            ],
            [
              -74.501171,
              41.503458
            ],
            [
              -74.496341,
              41.503669
            ],
            [
              -74.493801,
              41.504447
            ],
            [
              -74.491691,
              41.503495
            ],
            [
              -74.488518,
              41.503779
            ],
            [
              -74.483963,
              41.504256
            ],
            [
              -74.475619,
              41.503953
            ],
            [
              -74.475591,
              41.504334
            ],
            [
              -74.475811,
              41.505622
            ],
            [
              -74.473948,
              41.506899
            ],
            [
              -74.474055,
              41.508734
            ],
            [
              -74.476102,
              41.510239
            ],
            [
              -74.473336,
              41.511369
            ],
            [
              -74.472685,
              41.512443
            ],
            [
              -74.46889,
              41.514042
            ],
            [
              -74.468195,
              41.515886
            ],
            [
              -74.465616,
              41.516882
            ],
            [
              -74.465729,
              41.518326
            ],
            [
              -74.46484,
              41.519375
            ],
            [
              -74.465748,
              41.522862
            ],
            [
              -74.462356,
              41.523563
            ],
            [
              -74.46024,
              41.524656
            ],
            [
              -74.458792,
              41.526963
            ],
            [
              -74.456989,
              41.527784
            ],
            [
              -74.457462,
              41.529361
            ],
            [
              -74.45545,
              41.530112
            ],
            [
              -74.45604,
              41.531884
            ],
            [
              -74.45454,
              41.533369
            ],
            [
              -74.453527,
              41.53263
            ],
            [
              -74.450465,
              41.532955
            ],
            [
              -74.447939,
              41.534353
            ],
            [
              -74.447921,
              41.535379
            ],
            [
              -74.444602,
              41.537233
            ],
            [
              -74.443813,
              41.53862
            ],
            [
              -74.443787,
              41.540923
            ],
            [
              -74.445775,
              41.540873
            ],
            [
              -74.445176,
              41.544094
            ],
            [
              -74.439551,
              41.543023
            ],
            [
              -74.43789,
              41.543458
            ],
            [
              -74.438775,
              41.545046
            ],
            [
              -74.438616,
              41.54733
            ],
            [
              -74.438229,
              41.547441
            ],
            [
              -74.437078,
              41.546734
            ],
            [
              -74.435514,
              41.546117
            ],
            [
              -74.435089,
              41.54618
            ],
            [
              -74.434787,
              41.546688
            ],
            [
              -74.435036,
              41.548497
            ],
            [
              -74.435927,
              41.549704
            ],
            [
              -74.436152,
              41.550699
            ],
            [
              -74.434877,
              41.552166
            ],
            [
              -74.434393,
              41.552976
            ],
            [
              -74.434171,
              41.553541
            ],
            [
              -74.433893,
              41.553731
            ],
            [
              -74.432958,
              41.553736
            ],
            [
              -74.432021,
              41.553832
            ],
            [
              -74.43103,
              41.553721
            ],
            [
              -74.430359,
              41.553796
            ],
            [
              -74.430259,
              41.55407
            ],
            [
              -74.430416,
              41.554174
            ],
            [
              -74.43124,
              41.554322
            ],
            [
              -74.431417,
              41.554665
            ],
            [
              -74.430384,
              41.555916
            ],
            [
              -74.428865,
              41.556079
            ],
            [
              -74.426919,
              41.555925
            ],
            [
              -74.426216,
              41.556088
            ],
            [
              -74.426255,
              41.556485
            ],
            [
              -74.426896,
              41.556638
            ],
            [
              -74.427426,
              41.556601
            ],
            [
              -74.428662,
              41.55686
            ],
            [
              -74.429149,
              41.557009
            ],
            [
              -74.429959,
              41.557993
            ],
            [
              -74.426083,
              41.559268
            ],
            [
              -74.423307,
              41.559879
            ],
            [
              -74.42344,
              41.562643
            ],
            [
              -74.419733,
              41.562426
            ],
            [
              -74.418909,
              41.563586
            ],
            [
              -74.419321,
              41.565626
            ],
            [
              -74.417781,
              41.567911
            ],
            [
              -74.418399,
              41.569397
            ],
            [
              -74.416934,
              41.569821
            ],
            [
              -74.416274,
              41.568757
            ],
            [
              -74.41414,
              41.567803
            ],
            [
              -74.413026,
              41.568742
            ],
            [
              -74.409894,
              41.568217
            ],
            [
              -74.407625,
              41.568885
            ],
            [
              -74.408092,
              41.570394
            ],
            [
              -74.410222,
              41.570467
            ],
            [
              -74.411023,
              41.57123
            ],
            [
              -74.409786,
              41.5718
            ],
            [
              -74.409801,
              41.573291
            ],
            [
              -74.408278,
              41.575175
            ],
            [
              -74.408163,
              41.573805
            ],
            [
              -74.406952,
              41.572321
            ],
            [
              -74.404464,
              41.573101
            ],
            [
              -74.403836,
              41.57425
            ],
            [
              -74.401874,
              41.575332
            ],
            [
              -74.399345,
              41.575495
            ],
            [
              -74.397614,
              41.575094
            ],
            [
              -74.395788,
              41.577113
            ],
            [
              -74.396067,
              41.579139
            ],
            [
              -74.395429,
              41.580693
            ],
            [
              -74.393546,
              41.581958
            ],
            [
              -74.391305,
              41.582059
            ],
            [
              -74.391458,
              41.583704
            ],
            [
              -74.390613,
              41.586221
            ],
            [
              -74.389007,
              41.585295
            ],
            [
              -74.388452,
              41.583642
            ],
            [
              -74.386149,
              41.583132
            ],
            [
              -74.383515,
              41.583879
            ],
            [
              -74.380756,
              41.586158
            ],
            [
              -74.379951,
              41.587416
            ],
            [
              -74.377974,
              41.586385
            ],
            [
              -74.370089,
              41.58859
            ],
            [
              -74.36899,
              41.590258
            ],
            [
              -74.367055,
              41.590977
            ],
            [
              -74.363472,
              41.591965
            ],
            [
              -74.359801,
              41.592028
            ],
            [
              -74.358446,
              41.59109
            ],
            [
              -74.353704,
              41.591683
            ],
            [
              -74.353941,
              41.592975
            ],
            [
              -74.352115,
              41.592657
            ],
            [
              -74.351955,
              41.594791
            ],
            [
              -74.353189,
              41.59537
            ],
            [
              -74.351835,
              41.597735
            ],
            [
              -74.349354,
              41.598621
            ],
            [
              -74.346663,
              41.597783
            ],
            [
              -74.344713,
              41.597853
            ],
            [
              -74.342539,
              41.596829
            ],
            [
              -74.34068,
              41.594376
            ],
            [
              -74.336624,
              41.595374
            ],
            [
              -74.335627,
              41.597038
            ],
            [
              -74.3344,
              41.597511
            ],
            [
              -74.332033,
              41.596739
            ],
            [
              -74.329751,
              41.598622
            ],
            [
              -74.330384,
              41.600254
            ],
            [
              -74.329614,
              41.601547
            ],
            [
              -74.326502,
              41.602067
            ],
            [
              -74.323752,
              41.602957
            ],
            [
              -74.320161,
              41.603006
            ],
            [
              -74.316324,
              41.60543
            ],
            [
              -74.314792,
              41.607449
            ],
            [
              -74.314349,
              41.609592
            ],
            [
              -74.312046,
              41.61127
            ],
            [
              -74.310789,
              41.611487
            ],
            [
              -74.309317,
              41.611153
            ],
            [
              -74.307924,
              41.609355
            ],
            [
              -74.306701,
              41.60882
            ],
            [
              -74.304412,
              41.612151
            ],
            [
              -74.304711,
              41.615251
            ],
            [
              -74.304121,
              41.615788
            ],
            [
              -74.300286,
              41.616432
            ],
            [
              -74.29721,
              41.618721
            ],
            [
              -74.295212,
              41.619679
            ],
            [
              -74.292776,
              41.618272
            ],
            [
              -74.289704,
              41.619608
            ],
            [
              -74.289058,
              41.621342
            ],
            [
              -74.285966,
              41.621492
            ],
            [
              -74.280844,
              41.625216
            ],
            [
              -74.279112,
              41.625822
            ],
            [
              -74.275786,
              41.625639
            ],
            [
              -74.272346,
              41.628151
            ],
            [
              -74.271038,
              41.629275
            ],
            [
              -74.268613,
              41.628618
            ],
            [
              -74.266979,
              41.629525
            ],
            [
              -74.264676,
              41.63225
            ],
            [
              -74.264093,
              41.632738
            ],
            [
              -74.250186,
              41.629324
            ],
            [
              -74.250222,
              41.625875
            ],
            [
              -74.251601,
              41.605374
            ],
            [
              -74.244911,
              41.603758
            ],
            [
              -74.240179,
              41.602662
            ],
            [
              -74.236555,
              41.601846
            ],
            [
              -74.202248,
              41.59429
            ],
            [
              -74.187505,
              41.590793
            ],
            [
              -74.185361,
              41.594128
            ],
            [
              -74.184531,
              41.593961
            ],
            [
              -74.177297,
              41.592729
            ],
            [
              -74.170969,
              41.591252
            ],
            [
              -74.160738,
              41.589408
            ],
            [
              -74.137588,
              41.584691
            ],
            [
              -74.126393,
              41.582544
            ],
            [
              -74.130471,
              41.599198
            ],
            [
              -74.134511,
              41.615695
            ],
            [
              -74.098653,
              41.607259
            ],
            [
              -74.094419,
              41.605452
            ],
            [
              -74.089896,
              41.598602
            ],
            [
              -74.084578,
              41.600437
            ],
            [
              -74.08076,
              41.601589
            ],
            [
              -74.074432,
              41.603649
            ],
            [
              -74.068083,
              41.606001
            ],
            [
              -74.053804,
              41.586065
            ],
            [
              -74.053942,
              41.580724
            ],
            [
              -74.050724,
              41.580871
            ],
            [
              -74.041328,
              41.581655
            ],
            [
              -74.037125,
              41.582044
            ],
            [
              -74.026844,
              41.582979
            ],
            [
              -74.004434,
              41.585171
            ],
            [
              -73.999584,
              41.585805
            ],
            [
              -73.98635,
              41.586817
            ],
            [
              -73.982658,
              41.587113
            ],
            [
              -73.953307,
              41.589977
            ],
            [
              -73.954146,
              41.583271
            ],
            [
              -73.954725,
              41.58179
            ],
            [
              -73.956831,
              41.576656
            ],
            [
              -73.959467,
              41.571443
            ],
            [
              -73.961913,
              41.568149
            ],
            [
              -73.964781,
              41.565311
            ],
            [
              -73.970214,
              41.562276
            ],
            [
              -73.972707,
              41.560356
            ],
            [
              -73.973372,
              41.559797
            ],
            [
              -73.977889,
              41.555234
            ],
            [
              -73.979933,
              41.55235
            ],
            [
              -73.982805,
              41.549195
            ],
            [
              -73.98593,
              41.545621
            ],
            [
              -73.987866,
              41.542789
            ],
            [
              -73.988753,
              41.541219
            ],
            [
              -73.989607,
              41.538671
            ],
            [
              -73.992949,
              41.529821
            ],
            [
              -73.994547,
              41.527138
            ],
            [
              -73.996536,
              41.522649
            ],
            [
              -73.997484,
              41.516493
            ],
            [
              -73.997184,
              41.513393
            ],
            [
              -73.99725,
              41.509769
            ],
            [
              -73.997884,
              41.505685
            ],
            [
              -73.997789,
              41.502784
            ],
            [
              -73.997075,
              41.50172
            ],
            [
              -73.994784,
              41.498293
            ],
            [
              -73.995029,
              41.497332
            ],
            [
              -73.997609,
              41.487212
            ],
            [
              -73.998584,
              41.483393
            ],
            [
              -73.99825,
              41.480625
            ],
            [
              -73.997584,
              41.475093
            ],
            [
              -73.998898,
              41.462984
            ],
            [
              -73.999911,
              41.459656
            ],
            [
              -74.000108,
              41.456549
            ],
            [
              -73.997784,
              41.452193
            ],
            [
              -73.994832,
              41.450268
            ],
            [
              -73.986583,
              41.444893
            ],
            [
              -73.981486,
              41.438905
            ],
            [
              -73.974501,
              41.427976
            ],
            [
              -73.972792,
              41.424589
            ],
            [
              -73.967513,
              41.418912
            ],
            [
              -73.965156,
              41.41387
            ],
            [
              -73.963057,
              41.410344
            ],
            [
              -73.962355,
              41.403699
            ],
            [
              -73.959136,
              41.400442
            ],
            [
              -73.951415,
              41.398963
            ],
            [
              -73.948637,
              41.39758
            ],
            [
              -73.947355,
              41.395254
            ],
            [
              -73.947523,
              41.393316
            ],
            [
              -73.950987,
              41.386815
            ],
            [
              -73.952391,
              41.380826
            ],
            [
              -73.955031,
              41.376554
            ],
            [
              -73.956099,
              41.374402
            ],
            [
              -73.958251,
              41.367277
            ],
            [
              -73.95938,
              41.361036
            ],
            [
              -73.959731,
              41.353719
            ],
            [
              -73.960143,
              41.351217
            ],
            [
              -73.961257,
              41.348539
            ],
            [
              -73.965087,
              41.343472
            ],
            [
              -73.980018,
              41.32627
            ],
            [
              -73.980754,
              41.32542
            ],
            [
              -73.984956,
              41.322442
            ],
            [
              -74.024025,
              41.294412
            ],
            [
              -74.069896,
              41.262026
            ],
            [
              -74.099394,
              41.241127
            ],
            [
              -74.104898,
              41.237129
            ],
            [
              -74.108421,
              41.234596
            ],
            [
              -74.143224,
              41.209619
            ],
            [
              -74.151419,
              41.203736
            ],
            [
              -74.162255,
              41.195905
            ],
            [
              -74.185577,
              41.179023
            ],
            [
              -74.186572,
              41.178266
            ],
            [
              -74.194122,
              41.172684
            ],
            [
              -74.212195,
              41.15927
            ],
            [
              -74.234299970671302,
              41.143149240279897
            ],
            [
              -74.242642565627904,
              41.146644902653101
            ],
            [
              -74.243175,
              41.146868
            ],
            [
              -74.245655750750799,
              41.147953020041399
            ],
            [
              -74.280004634676501,
              41.162976386434401
            ],
            [
              -74.2807460598153,
              41.163300667757099
            ],
            [
              -74.301994,
              41.172594
            ],
            [
              -74.302203106546301,
              41.172688765939299
            ],
            [
              -74.322333086825395,
              41.181811562536097
            ],
            [
              -74.330624216400295,
              41.185569056960802
            ],
            [
              -74.332125708600401,
              41.186249524986302
            ],
            [
              -74.333969304971603,
              41.187085032744797
            ],
            [
              -74.342625330102095,
              41.191007895832897
            ],
            [
              -74.344927,
              41.192051
            ],
            [
              -74.355127390529105,
              41.1972465268205
            ],
            [
              -74.365835304292105,
              41.202700558505803
            ],
            [
              -74.367383593890906,
              41.203489173423399
            ],
            [
              -74.382977158393004,
              41.211431691150302
            ],
            [
              -74.404258,
              41.222271
            ],
            [
              -74.418761565975899,
              41.229329949693202
            ],
            [
              -74.4237519184056,
              41.2317587762873
            ],
            [
              -74.439724217448401,
              41.239532564858699
            ],
            [
              -74.457584,
              41.248225
            ],
            [
              -74.465068384140295,
              41.251630458016102
            ],
            [
              -74.468371447320294,
              41.253133379669102
            ],
            [
              -74.476960542955794,
              41.257041490748698
            ],
            [
              -74.499603,
              41.267344
            ],
            [
              -74.518392162397404,
              41.276138259220403
            ],
            [
              -74.536689066822206,
              41.284702117312598
            ],
            [
              -74.536868683423606,
              41.284786186784103
            ],
            [
              -74.556173048054902,
              41.293821586184102
            ],
            [
              -74.556504781928098,
              41.293976854077997
            ],
            [
              -74.561035554456197,
              41.296097480172797
            ],
            [
              -74.569267737612805,
              41.299950549889203
            ],
            [
              -74.607348,
              41.317774
            ],
            [
              -74.641544,
              41.332879
            ],
            [
              -74.641598901505802,
              41.332904248314698
            ],
            [
              -74.649374635990497,
              41.3364801828696
            ],
            [
              -74.673926395476201,
              41.347771140051897
            ],
            [
              -74.685331723105406,
              41.3530162658029
            ],
            [
              -74.693807938874897,
              41.356914340373699
            ],
            [
              -74.694914,
              41.357423
            ],
            [
              -74.696398,
              41.357339
            ],
            [
              -74.695783187324096,
              41.357685684111303
            ],
            [
              -74.691076,
              41.36034
            ],
            [
              -74.689767,
              41.361558
            ],
            [
              -74.689516,
              41.363843
            ],
            [
              -74.691129,
              41.367324
            ],
            [
              -74.694968,
              41.370431
            ],
            [
              -74.697176440828002,
              41.371669363139297
            ],
            [
              -74.697189500918597,
              41.3716766864665
            ],
            [
              -74.703282,
              41.375093
            ],
            [
              -74.705920325113198,
              41.377034024349101
            ],
            [
              -74.708458,
              41.378901
            ],
            [
              -74.710391,
              41.382102
            ],
            [
              -74.712594140742596,
              41.387728033578497
            ],
            [
              -74.713411,
              41.389814
            ],
            [
              -74.715979,
              41.392584
            ],
            [
              -74.720891,
              41.39469
            ],
            [
              -74.730384,
              41.39566
            ],
            [
              -74.73364,
              41.396975
            ],
            [
              -74.736103,
              41.398398
            ],
            [
              -74.738554,
              41.401191
            ],
            [
              -74.740963,
              41.40512
            ],
            [
              -74.741307147484505,
              41.406379744107703
            ],
            [
              -74.741717,
              41.40788
            ],
            [
              -74.741086,
              41.411413
            ],
            [
              -74.738684,
              41.413463
            ],
            [
              -74.734731,
              41.422699
            ],
            [
              -74.734893,
              41.425818
            ],
            [
              -74.735519,
              41.427465
            ],
            [
              -74.736688,
              41.429228
            ],
            [
              -74.736939748045799,
              41.429429312953403
            ],
            [
              -74.738455,
              41.430641
            ],
            [
              -74.740932,
              41.43116
            ],
            [
              -74.743821,
              41.430635
            ],
            [
              -74.75068,
              41.427984
            ],
            [
              -74.754359,
              41.425147
            ],
            [
              -74.754708208531,
              41.424993374676497
            ],
            [
              -74.756421,
              41.428009
            ],
            [
              -74.755479,
              41.429479
            ],
            [
              -74.752889,
              41.430302
            ],
            [
              -74.751868,
              41.432477
            ],
            [
              -74.752575,
              41.433241
            ],
            [
              -74.755087,
              41.433182
            ],
            [
              -74.756107,
              41.433947
            ],
            [
              -74.756578,
              41.436827
            ],
            [
              -74.758897,
              41.440743
            ],
            [
              -74.759483,
              41.442588
            ],
            [
              -74.762309,
              41.444352
            ],
            [
              -74.762466,
              41.449525
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "NAME": "Putnam"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -73.5599760248898,
              41.5270220898171,
              0
            ],
            [
              -73.5597693370994,
              41.5269914855085,
              0
            ],
            [
              -73.5581587969652,
              41.5267530019013,
              0
            ],
            [
              -73.5562597676706,
              41.52647304063,
              0
            ],
            [
              -73.5559468712855,
              41.5264508900978,
              0
            ],
            [
              -73.555945595271,
              41.5264507994817,
              0
            ],
            [
              -73.5541055206516,
              41.526320517425,
              0
            ],
            [
              -73.5521957317852,
              41.5261863500951,
              0
            ],
            [
              -73.5516797228881,
              41.5261590388291,
              0
            ],
            [
              -73.5488498702949,
              41.5260092188633,
              0
            ],
            [
              -73.5487735616975,
              41.5260150232288,
              0
            ],
            [
              -73.5486088611181,
              41.5260275520548,
              0
            ],
            [
              -73.5485311681649,
              41.5260334618653,
              0
            ],
            [
              -73.5418648121178,
              41.5261788963899,
              0
            ],
            [
              -73.5384971759708,
              41.5262360637122,
              0
            ],
            [
              -73.5355714382148,
              41.5262848371495,
              0
            ],
            [
              -73.5348587456352,
              41.526297905994,
              0
            ],
            [
              -73.5345042356767,
              41.5263045127068,
              0
            ],
            [
              -73.5342725928035,
              41.5263089158008,
              0
            ],
            [
              -73.5340901877432,
              41.5263121373121,
              0
            ],
            [
              -73.5322237477638,
              41.5263485702914,
              0
            ],
            [
              -73.5320326536048,
              41.5263472383467,
              0
            ],
            [
              -73.5320297505555,
              41.5263472184124,
              0
            ],
            [
              -73.531319727252,
              41.5263560502406,
              0
            ],
            [
              -73.5312626430369,
              41.526356762467,
              0
            ],
            [
              -73.5307264386299,
              41.5263629919369,
              0
            ],
            [
              -73.5308156903623,
              41.5254145155935,
              0
            ],
            [
              -73.5308245893335,
              41.5253199518195,
              0
            ],
            [
              -73.5310268361014,
              41.5236149676434,
              0
            ],
            [
              -73.5311544526219,
              41.5223624921392,
              0
            ],
            [
              -73.5311594293658,
              41.522313767173,
              0
            ],
            [
              -73.5312909305,
              41.521026035979,
              0
            ],
            [
              -73.5312961902818,
              41.5209746264183,
              0
            ],
            [
              -73.5316956073552,
              41.5170585093261,
              0
            ],
            [
              -73.532198820599,
              41.5086691148633,
              0
            ],
            [
              -73.5327925717489,
              41.4987670660002,
              0
            ],
            [
              -73.5328011922389,
              41.4986311618872,
              0
            ],
            [
              -73.5330508124859,
              41.494230082611,
              0
            ],
            [
              -73.5333265254743,
              41.4904094712931,
              0
            ],
            [
              -73.5333418548359,
              41.4902070153322,
              0
            ],
            [
              -73.5334222741099,
              41.4891772954465,
              0
            ],
            [
              -73.5334741422715,
              41.4885131243609,
              0
            ],
            [
              -73.5335477460653,
              41.4873060837764,
              0
            ],
            [
              -73.5339156362298,
              41.4803627931342,
              0
            ],
            [
              -73.5339413296208,
              41.4799998596163,
              0
            ],
            [
              -73.5339539784351,
              41.4798239686496,
              0
            ],
            [
              -73.533958088496,
              41.4797622494474,
              0
            ],
            [
              -73.5339705251752,
              41.4795851554728,
              0
            ],
            [
              -73.5339774839791,
              41.4794852058407,
              0
            ],
            [
              -73.5340042823979,
              41.4791092482373,
              0
            ],
            [
              -73.5340175831217,
              41.4789201520231,
              0
            ],
            [
              -73.5340512833625,
              41.4784939903062,
              0
            ],
            [
              -73.534091446521,
              41.4779550107051,
              0
            ],
            [
              -73.5341239708094,
              41.477515802117,
              0
            ],
            [
              -73.534136682857,
              41.4773510611171,
              0
            ],
            [
              -73.5341572264279,
              41.4770735119395,
              0
            ],
            [
              -73.5341735041712,
              41.4768527065209,
              0
            ],
            [
              -73.5341900421916,
              41.476629845719,
              0
            ],
            [
              -73.5342005015576,
              41.4764939050918,
              0
            ],
            [
              -73.5342210037888,
              41.4762190992252,
              0
            ],
            [
              -73.5342249571791,
              41.4761642672021,
              0
            ],
            [
              -73.5342288409497,
              41.4761104142977,
              0
            ],
            [
              -73.5342326736239,
              41.4760572606235,
              0
            ],
            [
              -73.534236729384,
              41.4760010157309,
              0
            ],
            [
              -73.5342405350011,
              41.4759482319186,
              0
            ],
            [
              -73.5342506955429,
              41.4758169189432,
              0
            ],
            [
              -73.534269647443,
              41.4755388421421,
              0
            ],
            [
              -73.5342758362501,
              41.4754447209579,
              0
            ],
            [
              -73.5342975827552,
              41.4751320177707,
              0
            ],
            [
              -73.5343054039306,
              41.4750046282592,
              0
            ],
            [
              -73.5343478731859,
              41.4743716646246,
              0
            ],
            [
              -73.5343703397613,
              41.4740411265279,
              0
            ],
            [
              -73.5343888289892,
              41.4737637318898,
              0
            ],
            [
              -73.5344131190127,
              41.4734025059518,
              0
            ],
            [
              -73.5344218671659,
              41.473274094946,
              0
            ],
            [
              -73.5344333084037,
              41.4731026526782,
              0
            ],
            [
              -73.5344704275663,
              41.4725686219449,
              0
            ],
            [
              -73.5344796264548,
              41.4724405586769,
              0
            ],
            [
              -73.534491273242,
              41.4722704904106,
              0
            ],
            [
              -73.534505095567,
              41.4720767681078,
              0
            ],
            [
              -73.5345166047812,
              41.4719159608439,
              0
            ],
            [
              -73.5345397553311,
              41.4715854292142,
              0
            ],
            [
              -73.5345516687474,
              41.4714126176401,
              0
            ],
            [
              -73.5345760168373,
              41.4710608162622,
              0
            ],
            [
              -73.5345884195042,
              41.4708880177796,
              0
            ],
            [
              -73.5345999231433,
              41.4707275544044,
              0
            ],
            [
              -73.5346127307882,
              41.4705406841553,
              0
            ],
            [
              -73.5346225403229,
              41.4704021634642,
              0
            ],
            [
              -73.5346473072731,
              41.4700548336275,
              0
            ],
            [
              -73.5346584942307,
              41.4699001998713,
              0
            ],
            [
              -73.5346777237363,
              41.469634132735,
              0
            ],
            [
              -73.534689695652,
              41.4694728169043,
              0
            ],
            [
              -73.5347230482931,
              41.4690078836815,
              0
            ],
            [
              -73.5347534000636,
              41.4685914692597,
              0
            ],
            [
              -73.5347755032845,
              41.4682851159746,
              0
            ],
            [
              -73.534781456454,
              41.4682067715039,
              0
            ],
            [
              -73.5348028750494,
              41.4679069255071,
              0
            ],
            [
              -73.5348139512628,
              41.467753325382,
              0
            ],
            [
              -73.5348194431748,
              41.4676753201084,
              0
            ],
            [
              -73.5348308386818,
              41.467522060329,
              0
            ],
            [
              -73.5348352545646,
              41.4674548533971,
              0
            ],
            [
              -73.5348555235559,
              41.4671493418869,
              0
            ],
            [
              -73.5348653361406,
              41.4669950386762,
              0
            ],
            [
              -73.5348685610286,
              41.4669468647682,
              0
            ],
            [
              -73.5349016472891,
              41.4664381853816,
              0
            ],
            [
              -73.5349051314329,
              41.4663877822917,
              0
            ],
            [
              -73.534915749139,
              41.4662254257523,
              0
            ],
            [
              -73.5349239855805,
              41.4661006139137,
              0
            ],
            [
              -73.5349682079113,
              41.4654252924041,
              0
            ],
            [
              -73.5349899787582,
              41.4650942075542,
              0
            ],
            [
              -73.5349906379194,
              41.4650844691541,
              0
            ],
            [
              -73.5349946711136,
              41.4650247994698,
              0
            ],
            [
              -73.534998016828,
              41.4649682198152,
              0
            ],
            [
              -73.5350021526477,
              41.4649046150584,
              0
            ],
            [
              -73.5350068386592,
              41.4648346639376,
              0
            ],
            [
              -73.535010175165,
              41.4647789459485,
              0
            ],
            [
              -73.5350113336638,
              41.4647628193366,
              0
            ],
            [
              -73.5350159207566,
              41.4646990535779,
              0
            ],
            [
              -73.535019494751,
              41.4646428189118,
              0
            ],
            [
              -73.5350232292696,
              41.4645905323294,
              0
            ],
            [
              -73.5350269684399,
              41.4645384159734,
              0
            ],
            [
              -73.5350344279109,
              41.4644352123327,
              0
            ],
            [
              -73.5350484397953,
              41.4642284534573,
              0
            ],
            [
              -73.5350531027874,
              41.4641600473312,
              0
            ],
            [
              -73.5350604162868,
              41.4640511803335,
              0
            ],
            [
              -73.5350646241198,
              41.4639982115607,
              0
            ],
            [
              -73.5350681740877,
              41.4639433489933,
              0
            ],
            [
              -73.5350716706268,
              41.4638920896382,
              0
            ],
            [
              -73.5350752155088,
              41.4638375692037,
              0
            ],
            [
              -73.5350789637266,
              41.4637845938713,
              0
            ],
            [
              -73.5350826977079,
              41.4637328205398,
              0
            ],
            [
              -73.5350879143104,
              41.4636580734732,
              0
            ],
            [
              -73.5350925964836,
              41.463588125003,
              0
            ],
            [
              -73.5350966532494,
              41.4635298386115,
              0
            ],
            [
              -73.535105426347,
              41.4633995392664,
              0
            ],
            [
              -73.535125021396,
              41.4631238695578,
              0
            ],
            [
              -73.5351355711463,
              41.4629691626878,
              0
            ],
            [
              -73.5351439597466,
              41.46284613496,
              0
            ],
            [
              -73.5351533309926,
              41.462706238052,
              0
            ],
            [
              -73.5351606935903,
              41.4626005743869,
              0
            ],
            [
              -73.5351735288058,
              41.4624275865145,
              0
            ],
            [
              -73.5351836950683,
              41.4622701452935,
              0
            ],
            [
              -73.5351924490034,
              41.4621442616341,
              0
            ],
            [
              -73.5351981075939,
              41.4620702035032,
              0
            ],
            [
              -73.535203750902,
              41.4619971753752,
              0
            ],
            [
              -73.5352262527332,
              41.4617251336254,
              0
            ],
            [
              -73.5352514520415,
              41.4613633975107,
              0
            ],
            [
              -73.5352520295419,
              41.461355689868,
              0
            ],
            [
              -73.5352562945459,
              41.4612985965105,
              0
            ],
            [
              -73.5352615274248,
              41.4612377428222,
              0
            ],
            [
              -73.5352665061089,
              41.4611787743766,
              0
            ],
            [
              -73.535271489854,
              41.4611194637958,
              0
            ],
            [
              -73.5352762452391,
              41.4610598109229,
              0
            ],
            [
              -73.5352805046081,
              41.4610035792598,
              0
            ],
            [
              -73.5352846118829,
              41.4609418597841,
              0
            ],
            [
              -73.5352884613628,
              41.4608820264217,
              0
            ],
            [
              -73.5352922813981,
              41.4608244214637,
              0
            ],
            [
              -73.535296345452,
              41.4607656164301,
              0
            ],
            [
              -73.5353004222011,
              41.460705954259,
              0
            ],
            [
              -73.535304251312,
              41.4606474930323,
              0
            ],
            [
              -73.5353059985442,
              41.4606257155193,
              0
            ],
            [
              -73.5353094053083,
              41.4605766894294,
              0
            ],
            [
              -73.53531319732,
              41.4605209725089,
              0
            ],
            [
              -73.5353177682226,
              41.460458738247,
              0
            ],
            [
              -73.5353218473961,
              41.4603989095061,
              0
            ],
            [
              -73.535326397904,
              41.4603380500825,
              0
            ],
            [
              -73.5353304694941,
              41.4602787318405,
              0
            ],
            [
              -73.5353346808736,
              41.4602252461853,
              0
            ],
            [
              -73.5353384270831,
              41.460172616573,
              0
            ],
            [
              -73.535342423501,
              41.4601186113461,
              0
            ],
            [
              -73.5353464812609,
              41.4600599818415,
              0
            ],
            [
              -73.535350922396,
              41.460006499011,
              0
            ],
            [
              -73.5353552277517,
              41.4599466694597,
              0
            ],
            [
              -73.5354000772625,
              41.4593514613533,
              0
            ],
            [
              -73.5354022596744,
              41.459327291344,
              0
            ],
            [
              -73.535430227372,
              41.458924957341,
              0
            ],
            [
              -73.5354528311128,
              41.4586075949081,
              0
            ],
            [
              -73.5354636502448,
              41.4584622198718,
              0
            ],
            [
              -73.5354728370135,
              41.458334672074,
              0
            ],
            [
              -73.5354831252434,
              41.4581788309642,
              0
            ],
            [
              -73.5355093171944,
              41.4577961751624,
              0
            ],
            [
              -73.5355193775881,
              41.457655940802,
              0
            ],
            [
              -73.5355368045079,
              41.4573876264836,
              0
            ],
            [
              -73.5355579680241,
              41.4570980753708,
              0
            ],
            [
              -73.535566812743,
              41.4569628040708,
              0
            ],
            [
              -73.5355977844273,
              41.4565499974127,
              0
            ],
            [
              -73.5356045610688,
              41.456431179185,
              0
            ],
            [
              -73.5356407821504,
              41.455894735645,
              0
            ],
            [
              -73.5356434928531,
              41.4558501582758,
              0
            ],
            [
              -73.5356482611351,
              41.4557745500783,
              0
            ],
            [
              -73.5356529125596,
              41.4557068298853,
              0
            ],
            [
              -73.5356582400869,
              41.4556279693874,
              0
            ],
            [
              -73.5356623398073,
              41.4555629891884,
              0
            ],
            [
              -73.5356706351694,
              41.4554495000219,
              0
            ],
            [
              -73.5356856721928,
              41.4552368233693,
              0
            ],
            [
              -73.5356931919861,
              41.4551273653842,
              0
            ],
            [
              -73.5357473702066,
              41.453863098159,
              0
            ],
            [
              -73.5357833706786,
              41.4529797638971,
              0
            ],
            [
              -73.5357847168149,
              41.4527041134944,
              0
            ],
            [
              -73.5358340455413,
              41.4518981193045,
              0
            ],
            [
              -73.5358596260035,
              41.4514931938337,
              0
            ],
            [
              -73.5361483192536,
              41.4474565114062,
              0
            ],
            [
              -73.5361629288354,
              41.4472549038636,
              0
            ],
            [
              -73.5363759385889,
              41.4443358841217,
              0
            ],
            [
              -73.5364356777885,
              41.4435208908807,
              0
            ],
            [
              -73.5364946492967,
              41.4427091408527,
              0
            ],
            [
              -73.5365201056062,
              41.442390807087,
              0
            ],
            [
              -73.5365525219112,
              41.4419871014493,
              0
            ],
            [
              -73.5365771854325,
              41.4416759647387,
              0
            ],
            [
              -73.5366021737934,
              41.4413581393447,
              0
            ],
            [
              -73.5366717037868,
              41.440479063757,
              0
            ],
            [
              -73.5366849441898,
              41.4403121007748,
              0
            ],
            [
              -73.5366941272883,
              41.4401965574932,
              0
            ],
            [
              -73.5367582243794,
              41.43939240021,
              0
            ],
            [
              -73.5367659814226,
              41.4392945364746,
              0
            ],
            [
              -73.5368173536241,
              41.4386463543681,
              0
            ],
            [
              -73.536865207252,
              41.4380463664255,
              0
            ],
            [
              -73.5368755660517,
              41.4379160832437,
              0
            ],
            [
              -73.5371889730858,
              41.4339698613052,
              0
            ],
            [
              -73.5371942015849,
              41.433903089314,
              0
            ],
            [
              -73.5371994336877,
              41.433836315551,
              0
            ],
            [
              -73.5372046621627,
              41.4337695435575,
              0
            ],
            [
              -73.5372098906656,
              41.4337027688619,
              0
            ],
            [
              -73.5372151262816,
              41.4336359978266,
              0
            ],
            [
              -73.5372204458057,
              41.4335692157865,
              0
            ],
            [
              -73.5372368086289,
              41.4333636944414,
              0
            ],
            [
              -73.5372825533097,
              41.4327890777676,
              0
            ],
            [
              -73.5372915139899,
              41.4326762797581,
              0
            ],
            [
              -73.5373491953135,
              41.4319502930238,
              0
            ],
            [
              -73.5373637477592,
              41.4317675527521,
              0
            ],
            [
              -73.5374066644667,
              41.4312231013647,
              0
            ],
            [
              -73.5374747584105,
              41.430363053957,
              0
            ],
            [
              -73.5374836499177,
              41.4302548882253,
              0
            ],
            [
              -73.5374984960482,
              41.4300675174198,
              0
            ],
            [
              -73.537553147817,
              41.4293766691732,
              0
            ],
            [
              -73.5377038989593,
              41.4276263368084,
              0
            ],
            [
              -73.5377745199813,
              41.4269339054405,
              0
            ],
            [
              -73.5378605355785,
              41.4260942487387,
              0
            ],
            [
              -73.5380648640556,
              41.4240942579846,
              0
            ],
            [
              -73.5384112899445,
              41.4211575344415,
              0
            ],
            [
              -73.5402895152406,
              41.4049185552567,
              0
            ],
            [
              -73.5403020019493,
              41.4047926317426,
              0
            ],
            [
              -73.5407662114907,
              41.4001109535655,
              0
            ],
            [
              -73.5410782461237,
              41.3953145442364,
              0
            ],
            [
              -73.5413213695681,
              41.3911117910866,
              0
            ],
            [
              -73.5413428090227,
              41.3907841530924,
              0
            ],
            [
              -73.5413853754863,
              41.3901336532615,
              0
            ],
            [
              -73.5414850944897,
              41.388609682633,
              0
            ],
            [
              -73.541682964808,
              41.3855854165992,
              0
            ],
            [
              -73.5418088627675,
              41.3836610157691,
              0
            ],
            [
              -73.5418214881145,
              41.3834680279083,
              0
            ],
            [
              -73.5419377566651,
              41.3816906787129,
              0
            ],
            [
              -73.5420047043142,
              41.3806672279659,
              0
            ],
            [
              -73.5421240397107,
              41.3788428010309,
              0
            ],
            [
              -73.5424225682644,
              41.3752378102509,
              0
            ],
            [
              -73.5425216782135,
              41.3742454589936,
              0
            ],
            [
              -73.5425362744786,
              41.3740993093431,
              0
            ],
            [
              -73.5430626639746,
              41.3688281457474,
              0
            ],
            [
              -73.5432743359628,
              41.3667082065961,
              0
            ],
            [
              -73.5601822181765,
              41.3648347947921,
              0
            ],
            [
              -73.5602930429697,
              41.3648225069104,
              0
            ],
            [
              -73.5604154971984,
              41.3648089289379,
              0
            ],
            [
              -73.5621502024267,
              41.3646530897627,
              0
            ],
            [
              -73.5650751191998,
              41.3643802775601,
              0
            ],
            [
              -73.5667177320439,
              41.3642291222432,
              0
            ],
            [
              -73.5689727109552,
              41.3640215776587,
              0
            ],
            [
              -73.5693445272752,
              41.3639873521996,
              0
            ],
            [
              -73.5710154000682,
              41.3638335328991,
              0
            ],
            [
              -73.5724260955834,
              41.3637036451375,
              0
            ],
            [
              -73.5726864088559,
              41.3636762379591,
              0
            ],
            [
              -73.5755544353251,
              41.3633742382007,
              0
            ],
            [
              -73.5851968172721,
              41.3623583617468,
              0
            ],
            [
              -73.5939183126126,
              41.361438779753,
              0
            ],
            [
              -73.5940316714127,
              41.3614268232726,
              0
            ],
            [
              -73.5963360598647,
              41.3611837346456,
              0
            ],
            [
              -73.5968902450454,
              41.3611341048527,
              0
            ],
            [
              -73.5992698359686,
              41.3609209690404,
              0
            ],
            [
              -73.5997516965566,
              41.3608778038044,
              0
            ],
            [
              -73.6000339091957,
              41.3608525221829,
              0
            ],
            [
              -73.6005191554468,
              41.3608090497305,
              0
            ],
            [
              -73.6008982152104,
              41.3607768012998,
              0
            ],
            [
              -73.6019214129904,
              41.3606169410589,
              0
            ],
            [
              -73.6025772891467,
              41.3605457148224,
              0
            ],
            [
              -73.602751480617,
              41.3605240936943,
              0
            ],
            [
              -73.6034358033261,
              41.3604354330827,
              0
            ],
            [
              -73.6044556317162,
              41.3603420472083,
              0
            ],
            [
              -73.6051825086238,
              41.3602704095122,
              0
            ],
            [
              -73.605672892544,
              41.3602246653223,
              0
            ],
            [
              -73.6082861618585,
              41.359990369234,
              0
            ],
            [
              -73.6108720041924,
              41.3597110595103,
              0
            ],
            [
              -73.6112488003513,
              41.3596736663221,
              0
            ],
            [
              -73.6113608113023,
              41.3596637804668,
              0
            ],
            [
              -73.6113847826137,
              41.3596590732471,
              0
            ],
            [
              -73.6122574170258,
              41.3595788441515,
              0
            ],
            [
              -73.6128842614966,
              41.3595198185366,
              0
            ],
            [
              -73.6137978098361,
              41.3594456256188,
              0
            ],
            [
              -73.6149199538783,
              41.3593467700744,
              0
            ],
            [
              -73.616024244998,
              41.3592625460772,
              0
            ],
            [
              -73.6175426899694,
              41.3591329718445,
              0
            ],
            [
              -73.6175830498692,
              41.3591316424519,
              0
            ],
            [
              -73.6183097376528,
              41.3590300017211,
              0
            ],
            [
              -73.6184336202126,
              41.359022794224,
              0
            ],
            [
              -73.6208866861136,
              41.3588566916633,
              0
            ],
            [
              -73.6225352653739,
              41.3587326830422,
              0
            ],
            [
              -73.6228008556568,
              41.3587006380434,
              0
            ],
            [
              -73.6231943216341,
              41.3586024123249,
              0
            ],
            [
              -73.6239284253899,
              41.3585115452479,
              0
            ],
            [
              -73.6246185470906,
              41.3584743148384,
              0
            ],
            [
              -73.6252458439629,
              41.3585032466723,
              0
            ],
            [
              -73.6256901298998,
              41.3584626694833,
              0
            ],
            [
              -73.6261186931104,
              41.3584403941867,
              0
            ],
            [
              -73.6262097883676,
              41.3584285142528,
              0
            ],
            [
              -73.6267066517747,
              41.3583643488514,
              0
            ],
            [
              -73.6271946020248,
              41.3583311254736,
              0
            ],
            [
              -73.6272724180201,
              41.3583299425864,
              0
            ],
            [
              -73.6273040858028,
              41.3583263935064,
              0
            ],
            [
              -73.6276983998101,
              41.3583135508021,
              0
            ],
            [
              -73.6280047293522,
              41.3582795918901,
              0
            ],
            [
              -73.6282840283094,
              41.3582486295301,
              0
            ],
            [
              -73.6288993255458,
              41.3582038683809,
              0
            ],
            [
              -73.6297892897199,
              41.3581068757684,
              0
            ],
            [
              -73.6298600225885,
              41.3580991666883,
              0
            ],
            [
              -73.6303291451038,
              41.3580507180397,
              0
            ],
            [
              -73.6306721846586,
              41.3580132708164,
              0
            ],
            [
              -73.6306865461941,
              41.358011702604,
              0
            ],
            [
              -73.6309985224075,
              41.3579776450966,
              0
            ],
            [
              -73.631425421595,
              41.3579293188607,
              0
            ],
            [
              -73.631854819402,
              41.3578728848182,
              0
            ],
            [
              -73.6320880558245,
              41.3578496763742,
              0
            ],
            [
              -73.632430203849,
              41.3578102712329,
              0
            ],
            [
              -73.6329267490758,
              41.3577599962288,
              0
            ],
            [
              -73.6329934234284,
              41.3577483429366,
              0
            ],
            [
              -73.6332870353094,
              41.3577300209005,
              0
            ],
            [
              -73.6332964429582,
              41.3577294334996,
              0
            ],
            [
              -73.633341487208,
              41.357726622843,
              0
            ],
            [
              -73.6337534796587,
              41.3577009111268,
              0
            ],
            [
              -73.6344434277504,
              41.357631711776,
              0
            ],
            [
              -73.6346820472994,
              41.3576038452324,
              0
            ],
            [
              -73.6348411833338,
              41.3575952039309,
              0
            ],
            [
              -73.6349557171127,
              41.3575847953731,
              0
            ],
            [
              -73.6351896247496,
              41.3575635388324,
              0
            ],
            [
              -73.6358274128087,
              41.3574908856394,
              0
            ],
            [
              -73.6359472654951,
              41.3574820396552,
              0
            ],
            [
              -73.6364835592379,
              41.3574281810454,
              0
            ],
            [
              -73.6371441746852,
              41.3573693350752,
              0
            ],
            [
              -73.6391891714805,
              41.3571338165929,
              0
            ],
            [
              -73.6405260911023,
              41.3569942233963,
              0
            ],
            [
              -73.6412016132701,
              41.3569237879518,
              0
            ],
            [
              -73.6413824095292,
              41.3569048950366,
              0
            ],
            [
              -73.6451107243303,
              41.3565158967571,
              0
            ],
            [
              -73.6484133539622,
              41.3561771350967,
              0
            ],
            [
              -73.6547104335357,
              41.3555458926828,
              0
            ],
            [
              -73.6558907225747,
              41.3554203873942,
              0
            ],
            [
              -73.6562513764935,
              41.3553820781348,
              0
            ],
            [
              -73.6564521335993,
              41.3553607531868,
              0
            ],
            [
              -73.6568487347687,
              41.3553186254442,
              0
            ],
            [
              -73.6572529341791,
              41.3552757361364,
              0
            ],
            [
              -73.6575049265726,
              41.3552551096158,
              0
            ],
            [
              -73.6583289579251,
              41.3551825710788,
              0
            ],
            [
              -73.6588594721062,
              41.3551151692766,
              0
            ],
            [
              -73.6597512849119,
              41.3550018593,
              0
            ],
            [
              -73.6598748379564,
              41.3549861608915,
              0
            ],
            [
              -73.6605203788298,
              41.3549400348232,
              0
            ],
            [
              -73.6608611434036,
              41.3549134470191,
              0
            ],
            [
              -73.6611479759482,
              41.3548929494905,
              0
            ],
            [
              -73.6617396110887,
              41.3548526153714,
              0
            ],
            [
              -73.662210211344,
              41.3548207180626,
              0
            ],
            [
              -73.6628265995504,
              41.3547673025003,
              0
            ],
            [
              -73.662914501648,
              41.3547597222913,
              0
            ],
            [
              -73.6632353956622,
              41.3547383750212,
              0
            ],
            [
              -73.6635668167217,
              41.3547095870143,
              0
            ],
            [
              -73.6637633225043,
              41.3546924281691,
              0
            ],
            [
              -73.6649428116025,
              41.3545949904193,
              0
            ],
            [
              -73.6651034153316,
              41.3545760190267,
              0
            ],
            [
              -73.6657736723096,
              41.3545430232788,
              0
            ],
            [
              -73.6659809447896,
              41.3545330750419,
              0
            ],
            [
              -73.6665855621974,
              41.3545003174254,
              0
            ],
            [
              -73.6673782786214,
              41.3544655489815,
              0
            ],
            [
              -73.6698661167761,
              41.354207351786,
              0
            ],
            [
              -73.6699543119109,
              41.3542010415959,
              0
            ],
            [
              -73.6699900849679,
              41.3541985549293,
              0
            ],
            [
              -73.6701716808116,
              41.3541871703747,
              0
            ],
            [
              -73.6701839583465,
              41.3541863854336,
              0
            ],
            [
              -73.6705174140025,
              41.3541659458713,
              0
            ],
            [
              -73.6716083699803,
              41.3540335254746,
              0
            ],
            [
              -73.67172376642,
              41.3540199248869,
              0
            ],
            [
              -73.6729673304753,
              41.3538690123888,
              0
            ],
            [
              -73.6729686719199,
              41.3538688734489,
              0
            ],
            [
              -73.6729796009229,
              41.3538682135909,
              0
            ],
            [
              -73.6731095051391,
              41.3538600845685,
              0
            ],
            [
              -73.6731217826508,
              41.3538592939106,
              0
            ],
            [
              -73.6753523734346,
              41.3537210731721,
              0
            ],
            [
              -73.6761043619768,
              41.3536661231119,
              0
            ],
            [
              -73.6777464491225,
              41.3534340896174,
              0
            ],
            [
              -73.6779707663058,
              41.3534104740144,
              0
            ],
            [
              -73.678041896721,
              41.3534022347528,
              0
            ],
            [
              -73.6794967395526,
              41.3532324959079,
              0
            ],
            [
              -73.6827860056828,
              41.3528488274454,
              0
            ],
            [
              -73.6832030290798,
              41.352800624183,
              0
            ],
            [
              -73.6832055099602,
              41.3528003428295,
              0
            ],
            [
              -73.6881536236946,
              41.3522380429403,
              0
            ],
            [
              -73.6890665074301,
              41.3521348836767,
              0
            ],
            [
              -73.6917058993812,
              41.3518345544186,
              0
            ],
            [
              -73.6929475314681,
              41.3517123610302,
              0
            ],
            [
              -73.6944935967614,
              41.3515603965199,
              0
            ],
            [
              -73.6946814063097,
              41.3515424981188,
              0
            ],
            [
              -73.6995333762835,
              41.351100487851,
              0
            ],
            [
              -73.7019812827493,
              41.3508773499471,
              0
            ],
            [
              -73.7019893102308,
              41.3508765276362,
              0
            ],
            [
              -73.702626326043,
              41.3508184159152,
              0
            ],
            [
              -73.7026760561508,
              41.3508088929252,
              0
            ],
            [
              -73.702754445667,
              41.3508025769854,
              0
            ],
            [
              -73.7028634113213,
              41.3507884062176,
              0
            ],
            [
              -73.7048015973544,
              41.3505513623149,
              0
            ],
            [
              -73.7051834677392,
              41.3505059682989,
              0
            ],
            [
              -73.7055315789243,
              41.3504658293385,
              0
            ],
            [
              -73.7098094080019,
              41.3499744761646,
              0
            ],
            [
              -73.7098139727319,
              41.3499743949459,
              0
            ],
            [
              -73.7134567132737,
              41.3495982446054,
              0
            ],
            [
              -73.7136965687076,
              41.3495743007833,
              0
            ],
            [
              -73.7158143180462,
              41.3493520204272,
              0
            ],
            [
              -73.7186115282562,
              41.3490581512974,
              0
            ],
            [
              -73.7196716479454,
              41.3489466365299,
              0
            ],
            [
              -73.7198047586385,
              41.3489327863067,
              0
            ],
            [
              -73.719920772875,
              41.3489207083696,
              0
            ],
            [
              -73.7218716416263,
              41.3487157153836,
              0
            ],
            [
              -73.7226188000411,
              41.3486370481493,
              0
            ],
            [
              -73.7244875378601,
              41.3484455197874,
              0
            ],
            [
              -73.7262901810674,
              41.3482404785436,
              0
            ],
            [
              -73.7299227881426,
              41.347827234293,
              0
            ],
            [
              -73.7355788443968,
              41.3471813429936,
              0
            ],
            [
              -73.7358073946026,
              41.3471617596802,
              0
            ],
            [
              -73.7370297328723,
              41.3470333213968,
              0
            ],
            [
              -73.7381795749147,
              41.3469131393975,
              0
            ],
            [
              -73.7413471686511,
              41.3465808551341,
              0
            ],
            [
              -73.7521484214515,
              41.3454641252625,
              0
            ],
            [
              -73.7528788343562,
              41.3453901322502,
              0
            ],
            [
              -73.7574686968359,
              41.3449232169757,
              0
            ],
            [
              -73.7583006552534,
              41.3448465830596,
              0
            ],
            [
              -73.7594750511096,
              41.344722400361,
              0
            ],
            [
              -73.759960687637,
              41.3446753704485,
              0
            ],
            [
              -73.760313066674,
              41.3446734115885,
              0
            ],
            [
              -73.7604128882072,
              41.3446629014463,
              0
            ],
            [
              -73.7605287831551,
              41.344660045104,
              0
            ],
            [
              -73.760642086453,
              41.3446448181723,
              0
            ],
            [
              -73.7608836555162,
              41.3446403671661,
              0
            ],
            [
              -73.7609610216586,
              41.3446230234925,
              0
            ],
            [
              -73.7610649162397,
              41.3445943553434,
              0
            ],
            [
              -73.761184889772,
              41.3445731680368,
              0
            ],
            [
              -73.7612215252682,
              41.3445541903594,
              0
            ],
            [
              -73.7618869146609,
              41.3444917307318,
              0
            ],
            [
              -73.762570305547,
              41.3444276635647,
              0
            ],
            [
              -73.7629457744988,
              41.3443985048059,
              0
            ],
            [
              -73.7631098589281,
              41.3443832053321,
              0
            ],
            [
              -73.7646484125476,
              41.3442400844145,
              0
            ],
            [
              -73.7651886992602,
              41.3441860425985,
              0
            ],
            [
              -73.7653786482572,
              41.3441668573201,
              0
            ],
            [
              -73.7659364254908,
              41.3441105202248,
              0
            ],
            [
              -73.766116306308,
              41.3440923518989,
              0
            ],
            [
              -73.7668461727107,
              41.3440186277644,
              0
            ],
            [
              -73.769359907082,
              41.3437646791421,
              0
            ],
            [
              -73.7697279167152,
              41.3437274959493,
              0
            ],
            [
              -73.7718966049114,
              41.3435083516952,
              0
            ],
            [
              -73.7720797746067,
              41.3434898409533,
              0
            ],
            [
              -73.7721927918724,
              41.3434784189073,
              0
            ],
            [
              -73.7722087592928,
              41.3434768053486,
              0
            ],
            [
              -73.7760817386811,
              41.3430853286535,
              0
            ],
            [
              -73.7768104064084,
              41.3430116597934,
              0
            ],
            [
              -73.7786207735216,
              41.3428286109093,
              0
            ],
            [
              -73.779364626474,
              41.3427533911535,
              0
            ],
            [
              -73.7799536734839,
              41.3426938212169,
              0
            ],
            [
              -73.7802932507301,
              41.3426594789815,
              0
            ],
            [
              -73.7810527815972,
              41.3425826165014,
              0
            ],
            [
              -73.7818249223146,
              41.3425044769557,
              0
            ],
            [
              -73.7832447814574,
              41.3423607752832,
              0
            ],
            [
              -73.7841811313578,
              41.3422659991433,
              0
            ],
            [
              -73.7851323162546,
              41.3421697136561,
              0
            ],
            [
              -73.7853255472309,
              41.3421501520106,
              0
            ],
            [
              -73.7880534691688,
              41.341873962101,
              0
            ],
            [
              -73.7882641699271,
              41.3418526269604,
              0
            ],
            [
              -73.7893657378751,
              41.3417410761356,
              0
            ],
            [
              -73.7902726925953,
              41.3416492260013,
              0
            ],
            [
              -73.7923315883181,
              41.3414406859482,
              0
            ],
            [
              -73.7930310323591,
              41.3413698322834,
              0
            ],
            [
              -73.7937548874711,
              41.3412965010325,
              0
            ],
            [
              -73.7945954134627,
              41.341211344637,
              0
            ],
            [
              -73.7948622746592,
              41.3411843065141,
              0
            ],
            [
              -73.7957313286289,
              41.3410962513246,
              0
            ],
            [
              -73.7972471668487,
              41.3409426452866,
              0
            ],
            [
              -73.7974403409165,
              41.340921928314,
              0
            ],
            [
              -73.7988534473849,
              41.3407703700055,
              0
            ],
            [
              -73.7991476719718,
              41.3407350681375,
              0
            ],
            [
              -73.7999428762212,
              41.3406564133717,
              0
            ],
            [
              -73.8002262874413,
              41.3406283792743,
              0
            ],
            [
              -73.800607093984,
              41.3405907103981,
              0
            ],
            [
              -73.8014476547821,
              41.3405075581432,
              0
            ],
            [
              -73.8018815102699,
              41.3404786707419,
              0
            ],
            [
              -73.8053289935901,
              41.3401035243431,
              0
            ],
            [
              -73.8065905503506,
              41.3399834899801,
              0
            ],
            [
              -73.806854360594,
              41.339958387625,
              0
            ],
            [
              -73.8144928704524,
              41.3392312768998,
              0
            ],
            [
              -73.8172042653585,
              41.3389852756785,
              0
            ],
            [
              -73.8219842901285,
              41.3384868932376,
              0
            ],
            [
              -73.8221601888866,
              41.3384687290365,
              0
            ],
            [
              -73.8226022174917,
              41.3384230822501,
              0
            ],
            [
              -73.8235206494758,
              41.338328232377,
              0
            ],
            [
              -73.8281180849408,
              41.3378533265517,
              0
            ],
            [
              -73.8325469316857,
              41.3373816177198,
              0
            ],
            [
              -73.8326827312553,
              41.3373673093149,
              0
            ],
            [
              -73.8329388375092,
              41.3373399745815,
              0
            ],
            [
              -73.8346533634788,
              41.3371426730209,
              0
            ],
            [
              -73.8348451590116,
              41.3371176844355,
              0
            ],
            [
              -73.8359980147688,
              41.3369679158038,
              0
            ],
            [
              -73.8361001222253,
              41.336954095154,
              0
            ],
            [
              -73.8361110605656,
              41.3369527858986,
              0
            ],
            [
              -73.8364199814266,
              41.3369022478797,
              0
            ],
            [
              -73.8365052103491,
              41.3368919333273,
              0
            ],
            [
              -73.8366375663368,
              41.3368801722076,
              0
            ],
            [
              -73.8375219326802,
              41.3368010357192,
              0
            ],
            [
              -73.8379996381319,
              41.3367598691642,
              0
            ],
            [
              -73.8390155171911,
              41.3366619251512,
              0
            ],
            [
              -73.8426762095824,
              41.3363096098678,
              0
            ],
            [
              -73.8427390933554,
              41.336303107235,
              0
            ],
            [
              -73.8427912718422,
              41.3362975727025,
              0
            ],
            [
              -73.8468665201264,
              41.3358862479303,
              0
            ],
            [
              -73.8479643188029,
              41.3357752156247,
              0
            ],
            [
              -73.8487152904271,
              41.3356992570637,
              0
            ],
            [
              -73.8524848196373,
              41.3353172454109,
              0
            ],
            [
              -73.8533335914257,
              41.3352201202772,
              0
            ],
            [
              -73.8548233221691,
              41.3350723748272,
              0
            ],
            [
              -73.8566925992379,
              41.3348869348131,
              0
            ],
            [
              -73.8567766642543,
              41.334878484363,
              0
            ],
            [
              -73.8568796375082,
              41.3348684240671,
              0
            ],
            [
              -73.8618483872641,
              41.3343722771834,
              0
            ],
            [
              -73.8646191093866,
              41.3340969169204,
              0
            ],
            [
              -73.8648437346224,
              41.3340746565491,
              0
            ],
            [
              -73.8654715939974,
              41.3340122467589,
              0
            ],
            [
              -73.8661967467667,
              41.3339401118265,
              0
            ],
            [
              -73.8664871930483,
              41.333911311102,
              0
            ],
            [
              -73.8670842661208,
              41.3338550715313,
              0
            ],
            [
              -73.8681442570308,
              41.3337523059154,
              0
            ],
            [
              -73.8695284195363,
              41.3336176876879,
              0
            ],
            [
              -73.8705954482672,
              41.3335161410906,
              0
            ],
            [
              -73.8711201139699,
              41.3334625696726,
              0
            ],
            [
              -73.871510993757,
              41.3334260078289,
              0
            ],
            [
              -73.8722765885613,
              41.3333601229209,
              0
            ],
            [
              -73.8728585018694,
              41.3332916437293,
              0
            ],
            [
              -73.8730934328891,
              41.3332640501473,
              0
            ],
            [
              -73.8734818852074,
              41.3332182545222,
              0
            ],
            [
              -73.8745767875314,
              41.3330895548322,
              0
            ],
            [
              -73.8746323034444,
              41.333083036144,
              0
            ],
            [
              -73.8747970627195,
              41.3330633468357,
              0
            ],
            [
              -73.8748302443392,
              41.3330594928591,
              0
            ],
            [
              -73.87493673336,
              41.3330471239209,
              0
            ],
            [
              -73.8751360967759,
              41.3330238471774,
              0
            ],
            [
              -73.8756214016381,
              41.3329679829898,
              0
            ],
            [
              -73.8769447524131,
              41.3328109870171,
              0
            ],
            [
              -73.8773913319495,
              41.3327583366022,
              0
            ],
            [
              -73.8776702163924,
              41.3327255360399,
              0
            ],
            [
              -73.877879819107,
              41.3327024827981,
              0
            ],
            [
              -73.878083044591,
              41.3326799079972,
              0
            ],
            [
              -73.8783051815294,
              41.3326553764589,
              0
            ],
            [
              -73.8788252597246,
              41.3326038036352,
              0
            ],
            [
              -73.8790134269354,
              41.3325850927876,
              0
            ],
            [
              -73.8794061625735,
              41.3325462106544,
              0
            ],
            [
              -73.8796658623062,
              41.3325201626764,
              0
            ],
            [
              -73.8800444726968,
              41.3324827474802,
              0
            ],
            [
              -73.8805506547492,
              41.3324324670575,
              0
            ],
            [
              -73.8807723076373,
              41.3324106728563,
              0
            ],
            [
              -73.880916279825,
              41.3323963514569,
              0
            ],
            [
              -73.8809716524914,
              41.33239209008,
              0
            ],
            [
              -73.8818602992306,
              41.3323026158312,
              0
            ],
            [
              -73.8824355024468,
              41.3322453200255,
              0
            ],
            [
              -73.8826300463348,
              41.3322259485964,
              0
            ],
            [
              -73.8828191366127,
              41.332207307612,
              0
            ],
            [
              -73.882878813251,
              41.3322014240923,
              0
            ],
            [
              -73.8829535247064,
              41.3321940605889,
              0
            ],
            [
              -73.8835228077898,
              41.3321372435893,
              0
            ],
            [
              -73.8836535664089,
              41.332124220342,
              0
            ],
            [
              -73.883779072324,
              41.3321117883637,
              0
            ],
            [
              -73.8846356159151,
              41.3320265287073,
              0
            ],
            [
              -73.884757721107,
              41.3320145061145,
              0
            ],
            [
              -73.8851169663105,
              41.3319786861434,
              0
            ],
            [
              -73.8854850940942,
              41.3319420534035,
              0
            ],
            [
              -73.8856069661473,
              41.3319298890874,
              0
            ],
            [
              -73.8859716771668,
              41.3318937030073,
              0
            ],
            [
              -73.8863306901216,
              41.3318580481991,
              0
            ],
            [
              -73.8864545900829,
              41.3318455399026,
              0
            ],
            [
              -73.8867972259848,
              41.3318116459521,
              0
            ],
            [
              -73.8871514535403,
              41.3317764790697,
              0
            ],
            [
              -73.8884816806183,
              41.3316440316843,
              0
            ],
            [
              -73.8888510777955,
              41.3316059072958,
              0
            ],
            [
              -73.8889068960802,
              41.3315998578822,
              0
            ],
            [
              -73.888973191274,
              41.3315928320947,
              0
            ],
            [
              -73.8893395186796,
              41.3315534354505,
              0
            ],
            [
              -73.8897022024721,
              41.3315143587062,
              0
            ],
            [
              -73.8898247675801,
              41.3315011148019,
              0
            ],
            [
              -73.8901858559931,
              41.3314620280744,
              0
            ],
            [
              -73.8905478518682,
              41.331423461002,
              0
            ],
            [
              -73.8906699631064,
              41.3314100408984,
              0
            ],
            [
              -73.8910349226907,
              41.3313708018053,
              0
            ],
            [
              -73.8913960080966,
              41.3313318841569,
              0
            ],
            [
              -73.8915172055096,
              41.3313188014102,
              0
            ],
            [
              -73.8918801161217,
              41.3312797216974,
              0
            ],
            [
              -73.8922439302593,
              41.3312408149033,
              0
            ],
            [
              -73.8923623948709,
              41.3312278870291,
              0
            ],
            [
              -73.8927736028159,
              41.3311833971517,
              0
            ],
            [
              -73.8934906579761,
              41.3311063675091,
              0
            ],
            [
              -73.8935057763453,
              41.3311045867521,
              0
            ],
            [
              -73.8943840935254,
              41.3310011251816,
              0
            ],
            [
              -73.8953313309134,
              41.330898939306,
              0
            ],
            [
              -73.8953588704079,
              41.3308959682693,
              0
            ],
            [
              -73.8961612122841,
              41.3308094069003,
              0
            ],
            [
              -73.896622117288,
              41.3307596790606,
              0
            ],
            [
              -73.8969526953502,
              41.3307264273441,
              0
            ],
            [
              -73.8972244912392,
              41.3306990883664,
              0
            ],
            [
              -73.8975254518178,
              41.3306688136136,
              0
            ],
            [
              -73.8977471949707,
              41.3306467305253,
              0
            ],
            [
              -73.8977581361907,
              41.3306448616156,
              0
            ],
            [
              -73.8980824605091,
              41.3306127481749,
              0
            ],
            [
              -73.8981036982857,
              41.3306106449208,
              0
            ],
            [
              -73.8981191485576,
              41.3306091210336,
              0
            ],
            [
              -73.8981556523677,
              41.3306055217331,
              0
            ],
            [
              -73.8981933292092,
              41.3306018060871,
              0
            ],
            [
              -73.8982314998909,
              41.3305980416825,
              0
            ],
            [
              -73.8982716220292,
              41.3305940848559,
              0
            ],
            [
              -73.8983087416415,
              41.3305904238906,
              0
            ],
            [
              -73.8983470940644,
              41.3305866414873,
              0
            ],
            [
              -73.8983843906359,
              41.3305829634127,
              0
            ],
            [
              -73.8983861579527,
              41.3305827889494,
              0
            ],
            [
              -73.8984223877058,
              41.3305792385595,
              0
            ],
            [
              -73.89847459853,
              41.3305741219726,
              0
            ],
            [
              -73.8985275172235,
              41.3305689361211,
              0
            ],
            [
              -73.8986786396603,
              41.3305541255719,
              0
            ],
            [
              -73.8990902553343,
              41.330513225323,
              0
            ],
            [
              -73.8991104190277,
              41.3305112540512,
              0
            ],
            [
              -73.8991614410781,
              41.3305062651201,
              0
            ],
            [
              -73.8992092047389,
              41.3305015950428,
              0
            ],
            [
              -73.8992573570117,
              41.3304968864517,
              0
            ],
            [
              -73.8993084256714,
              41.3304918931962,
              0
            ],
            [
              -73.8993602404594,
              41.3304868272695,
              0
            ],
            [
              -73.8994094772341,
              41.3304820135134,
              0
            ],
            [
              -73.8994543770723,
              41.330477623753,
              0
            ],
            [
              -73.8995633742489,
              41.3304669668424,
              0
            ],
            [
              -73.8996381801392,
              41.3304597001509,
              0
            ],
            [
              -73.899657222097,
              41.3304578499019,
              0
            ],
            [
              -73.8997038571814,
              41.3304527405942,
              0
            ],
            [
              -73.8997425409684,
              41.3304485020021,
              0
            ],
            [
              -73.8997844224917,
              41.3304439126705,
              0
            ],
            [
              -73.8998297074284,
              41.3304389511561,
              0
            ],
            [
              -73.8998704289518,
              41.3304344890178,
              0
            ],
            [
              -73.8999135517612,
              41.3304297638331,
              0
            ],
            [
              -73.8999539766981,
              41.3304253343376,
              0
            ],
            [
              -73.8999969619677,
              41.3304206246135,
              0
            ],
            [
              -73.9000387059284,
              41.3304160506811,
              0
            ],
            [
              -73.9003162821357,
              41.3303856359215,
              0
            ],
            [
              -73.9003531910661,
              41.3303816048959,
              0
            ],
            [
              -73.9003901334741,
              41.3303775704308,
              0
            ],
            [
              -73.9004296457772,
              41.3303732548791,
              0
            ],
            [
              -73.9004688351942,
              41.3303689745523,
              0
            ],
            [
              -73.9005065836002,
              41.3303648514972,
              0
            ],
            [
              -73.9005437543981,
              41.330360792058,
              0
            ],
            [
              -73.9005800366697,
              41.3303568297354,
              0
            ],
            [
              -73.9006206371751,
              41.3303523955169,
              0
            ],
            [
              -73.9007096383478,
              41.3303425870117,
              0
            ],
            [
              -73.9007595848951,
              41.3303370829916,
              0
            ],
            [
              -73.9008098423607,
              41.3303315445485,
              0
            ],
            [
              -73.9008576781928,
              41.3303262726312,
              0
            ],
            [
              -73.9009011718254,
              41.3303214796683,
              0
            ],
            [
              -73.9009416506782,
              41.330317018589,
              0
            ],
            [
              -73.9009833158237,
              41.330312426794,
              0
            ],
            [
              -73.9012092078521,
              41.3302877561904,
              0
            ],
            [
              -73.9013806166613,
              41.3302690359203,
              0
            ],
            [
              -73.9014097059694,
              41.3302658382667,
              0
            ],
            [
              -73.9014533118327,
              41.3302610438776,
              0
            ],
            [
              -73.9014900032179,
              41.3302570104553,
              0
            ],
            [
              -73.9015263992194,
              41.3302530097042,
              0
            ],
            [
              -73.9015680426509,
              41.3302484319924,
              0
            ],
            [
              -73.9016077069291,
              41.3302440718013,
              0
            ],
            [
              -73.9016471368134,
              41.3302397373929,
              0
            ],
            [
              -73.9016884011449,
              41.3302352008905,
              0
            ],
            [
              -73.9017252132884,
              41.3302311536129,
              0
            ],
            [
              -73.9017667143872,
              41.3302265912982,
              0
            ],
            [
              -73.9017858959641,
              41.3302244829802,
              0
            ],
            [
              -73.9018763527431,
              41.330214580282,
              0
            ],
            [
              -73.9020134692999,
              41.3301995691975,
              0
            ],
            [
              -73.9022451621817,
              41.3301742035989,
              0
            ],
            [
              -73.9023563891807,
              41.3301619392318,
              0
            ],
            [
              -73.9023955667604,
              41.3301576194655,
              0
            ],
            [
              -73.9024347012884,
              41.3301533039649,
              0
            ],
            [
              -73.9024720719193,
              41.3301491828057,
              0
            ],
            [
              -73.9026240106845,
              41.3301324280401,
              0
            ],
            [
              -73.9027055243615,
              41.3301237965985,
              0
            ],
            [
              -73.9034069697353,
              41.3300495147045,
              0
            ],
            [
              -73.9036238516963,
              41.3300249070175,
              0
            ],
            [
              -73.9036549709153,
              41.3300195680296,
              0
            ],
            [
              -73.9036924245279,
              41.3300131425352,
              0
            ],
            [
              -73.9037287928858,
              41.330006903212,
              0
            ],
            [
              -73.9037442029249,
              41.3300042590444,
              0
            ],
            [
              -73.904710342214,
              41.3298980983297,
              0
            ],
            [
              -73.9047622197661,
              41.3298924710858,
              0
            ],
            [
              -73.9048006920421,
              41.3298882981358,
              0
            ],
            [
              -73.9048427649568,
              41.3298837349665,
              0
            ],
            [
              -73.9048816151079,
              41.3298795207196,
              0
            ],
            [
              -73.9048960057334,
              41.3298779598261,
              0
            ],
            [
              -73.9049205828241,
              41.3298752521372,
              0
            ],
            [
              -73.9049615633639,
              41.3298707382068,
              0
            ],
            [
              -73.9050034838403,
              41.3298661201609,
              0
            ],
            [
              -73.9050421468132,
              41.3298618616684,
              0
            ],
            [
              -73.9050825593067,
              41.3298574104947,
              0
            ],
            [
              -73.9051189405931,
              41.3298534031275,
              0
            ],
            [
              -73.9051562462708,
              41.3298492933671,
              0
            ],
            [
              -73.9051980184353,
              41.3298446915932,
              0
            ],
            [
              -73.9053298510621,
              41.3298301688337,
              0
            ],
            [
              -73.9056004042103,
              41.3298003650961,
              0
            ],
            [
              -73.905623399137,
              41.3297978318868,
              0
            ],
            [
              -73.9056369982446,
              41.3297963397532,
              0
            ],
            [
              -73.9056733243175,
              41.3297923535373,
              0
            ],
            [
              -73.9057142746952,
              41.3297878607949,
              0
            ],
            [
              -73.9063729587252,
              41.3297155894481,
              0
            ],
            [
              -73.9072196493931,
              41.3296226843693,
              0
            ],
            [
              -73.9080548824403,
              41.3295308118349,
              0
            ],
            [
              -73.9080689155566,
              41.3295292685166,
              0
            ],
            [
              -73.9081904556315,
              41.3295158709945,
              0
            ],
            [
              -73.9083261077194,
              41.3295009177929,
              0
            ],
            [
              -73.9083326775797,
              41.3295002005523,
              0
            ],
            [
              -73.9083718671655,
              41.329495919334,
              0
            ],
            [
              -73.9084145019213,
              41.3294912613927,
              0
            ],
            [
              -73.9084160923684,
              41.3294910876672,
              0
            ],
            [
              -73.9084518537538,
              41.3294871544025,
              0
            ],
            [
              -73.9097790269086,
              41.3293411752551,
              0
            ],
            [
              -73.9098182548374,
              41.3293368604221,
              0
            ],
            [
              -73.9098376033298,
              41.329334731806,
              0
            ],
            [
              -73.9103305719553,
              41.3292806487637,
              0
            ],
            [
              -73.9107328032799,
              41.3292362566898,
              0
            ],
            [
              -73.910764314537,
              41.3292327791098,
              0
            ],
            [
              -73.9107964590053,
              41.3292290301113,
              0
            ],
            [
              -73.9129680196555,
              41.3289757207339,
              0
            ],
            [
              -73.9131721167044,
              41.3289519114159,
              0
            ],
            [
              -73.9131839401266,
              41.3289505651223,
              0
            ],
            [
              -73.9132220065841,
              41.3289462314999,
              0
            ],
            [
              -73.913473460118,
              41.3289176022763,
              0
            ],
            [
              -73.9135254534549,
              41.3289116826098,
              0
            ],
            [
              -73.913536250849,
              41.3289104499173,
              0
            ],
            [
              -73.9139945135235,
              41.3288581509123,
              0
            ],
            [
              -73.9140076217526,
              41.3288566030608,
              0
            ],
            [
              -73.9141312547463,
              41.3288420068523,
              0
            ],
            [
              -73.9142006920693,
              41.3288338091682,
              0
            ],
            [
              -73.9142216127595,
              41.3288313744435,
              0
            ],
            [
              -73.9142571901188,
              41.3288272349246,
              0
            ],
            [
              -73.9142595293081,
              41.3288269568692,
              0
            ],
            [
              -73.9147605397243,
              41.3287674216442,
              0
            ],
            [
              -73.914800377607,
              41.3287626876812,
              0
            ],
            [
              -73.9148012243094,
              41.3287625866281,
              0
            ],
            [
              -73.9148384976401,
              41.3287582169208,
              0
            ],
            [
              -73.9148790811687,
              41.3287534597066,
              0
            ],
            [
              -73.9149190033743,
              41.3287487792605,
              0
            ],
            [
              -73.9149571401157,
              41.3287443085457,
              0
            ],
            [
              -73.9149807432765,
              41.3287415415273,
              0
            ],
            [
              -73.9149957783296,
              41.3287397341084,
              0
            ],
            [
              -73.9151884725483,
              41.3287165728451,
              0
            ],
            [
              -73.9152285452562,
              41.3287117561809,
              0
            ],
            [
              -73.9152436508483,
              41.3287099409835,
              0
            ],
            [
              -73.9152684886302,
              41.3287069739649,
              0
            ],
            [
              -73.9153056191224,
              41.3287025394453,
              0
            ],
            [
              -73.9153075792121,
              41.328702305368,
              0
            ],
            [
              -73.9153427532014,
              41.3286981040313,
              0
            ],
            [
              -73.9153443389704,
              41.3286979148778,
              0
            ],
            [
              -73.9153675861881,
              41.3286951378675,
              0
            ],
            [
              -73.9153814000947,
              41.3286934880858,
              0
            ],
            [
              -73.9155719042272,
              41.328670734687,
              0
            ],
            [
              -73.9155922154795,
              41.3286683083249,
              0
            ],
            [
              -73.9156118057021,
              41.3286659566415,
              0
            ],
            [
              -73.91565018608,
              41.3286613491579,
              0
            ],
            [
              -73.9156897659539,
              41.328656597368,
              0
            ],
            [
              -73.9157285015118,
              41.3286519466365,
              0
            ],
            [
              -73.9157669632012,
              41.3286473287207,
              0
            ],
            [
              -73.9158061232967,
              41.3286426269888,
              0
            ],
            [
              -73.9158441747782,
              41.3286380582934,
              0
            ],
            [
              -73.9158801716768,
              41.3286337367003,
              0
            ],
            [
              -73.9159205683288,
              41.3286288863196,
              0
            ],
            [
              -73.9159589666071,
              41.3286242761222,
              0
            ],
            [
              -73.9159788258885,
              41.3286218915227,
              0
            ],
            [
              -73.9159897624854,
              41.3286205782615,
              0
            ],
            [
              -73.9165882553459,
              41.3285481338779,
              0
            ],
            [
              -73.9174582800097,
              41.3284715715663,
              0
            ],
            [
              -73.9174690116469,
              41.3284705966142,
              0
            ],
            [
              -73.9183436004552,
              41.328391175421,
              0
            ],
            [
              -73.9183820494012,
              41.3283876839875,
              0
            ],
            [
              -73.9184231764614,
              41.3283839494318,
              0
            ],
            [
              -73.9184629130476,
              41.3283803411095,
              0
            ],
            [
              -73.9184999428183,
              41.3283769784411,
              0
            ],
            [
              -73.9185050671148,
              41.328376512659,
              0
            ],
            [
              -73.918505250052,
              41.3283764946728,
              0
            ],
            [
              -73.9191856556071,
              41.3283099607147,
              0
            ],
            [
              -73.9192010624156,
              41.3283083725421,
              0
            ],
            [
              -73.9192407159666,
              41.328304284468,
              0
            ],
            [
              -73.9192773001134,
              41.3283005122764,
              0
            ],
            [
              -73.9193236927097,
              41.3282957296736,
              0
            ],
            [
              -73.919328397661,
              41.3282952662417,
              0
            ],
            [
              -73.921503037667,
              41.3280811232877,
              0
            ],
            [
              -73.9239854093352,
              41.3278451325056,
              0
            ],
            [
              -73.9239952516373,
              41.3278441966181,
              0
            ],
            [
              -73.9242554529146,
              41.32782776591,
              0
            ],
            [
              -73.9245469228303,
              41.3278260240626,
              0
            ],
            [
              -73.9248284710971,
              41.327812914457,
              0
            ],
            [
              -73.9254297806869,
              41.3277849136577,
              0
            ],
            [
              -73.925429828493,
              41.3277849111949,
              0
            ],
            [
              -73.9258778510472,
              41.3277472350345,
              0
            ],
            [
              -73.9265764519627,
              41.3276884842781,
              0
            ],
            [
              -73.9265859860129,
              41.3276876826083,
              0
            ],
            [
              -73.9265882335358,
              41.327687493895,
              0
            ],
            [
              -73.9273699502109,
              41.3276148650859,
              0
            ],
            [
              -73.9274031718474,
              41.3276117786695,
              0
            ],
            [
              -73.9275117689379,
              41.327601688508,
              0
            ],
            [
              -73.9303894306347,
              41.3273050557079,
              0
            ],
            [
              -73.9303936513731,
              41.3273046209444,
              0
            ],
            [
              -73.9313576434055,
              41.3272013891752,
              0
            ],
            [
              -73.9314015775746,
              41.3271966841067,
              0
            ],
            [
              -73.9316140692522,
              41.3271739281043,
              0
            ],
            [
              -73.9316226288164,
              41.3271730752793,
              0
            ],
            [
              -73.9317787419474,
              41.3271575137752,
              0
            ],
            [
              -73.9320039153939,
              41.3271352915194,
              0
            ],
            [
              -73.9321363364855,
              41.3271214433208,
              0
            ],
            [
              -73.9328375172528,
              41.327048115235,
              0
            ],
            [
              -73.93429412812,
              41.3268957714047,
              0
            ],
            [
              -73.9343798941123,
              41.3268868007253,
              0
            ],
            [
              -73.9367528876544,
              41.3266385722148,
              0
            ],
            [
              -73.9372509970687,
              41.3265864601676,
              0
            ],
            [
              -73.9420679459698,
              41.3260824003027,
              0
            ],
            [
              -73.9438750980613,
              41.325893240198,
              0
            ],
            [
              -73.9462619906828,
              41.3256509177642,
              0
            ],
            [
              -73.9522668157278,
              41.3250410675432,
              0
            ],
            [
              -73.9523818667557,
              41.3250283380487,
              0
            ],
            [
              -73.9551622543342,
              41.3247206747405,
              0
            ],
            [
              -73.960100302649,
              41.3241740823639,
              0
            ],
            [
              -73.9601332407862,
              41.3241652922165,
              0
            ],
            [
              -73.9604061350387,
              41.3240924681059,
              0
            ],
            [
              -73.9748829125077,
              41.3225967471047,
              0
            ],
            [
              -73.9757997675881,
              41.3225128818972,
              0
            ],
            [
              -73.9758264244062,
              41.322535544569,
              0
            ],
            [
              -73.9759904793885,
              41.3224958952021,
              0
            ],
            [
              -73.9760906196655,
              41.3224716954092,
              0
            ],
            [
              -73.9762764744,
              41.3224526158862,
              0
            ],
            [
              -73.9765573735344,
              41.3224237782902,
              0
            ],
            [
              -73.9772848930746,
              41.3223490887198,
              0
            ],
            [
              -73.9774123830773,
              41.3223359989565,
              0
            ],
            [
              -73.9779060013789,
              41.3222853185375,
              0
            ],
            [
              -73.9792352830319,
              41.3221485330274,
              0
            ],
            [
              -73.9795579899597,
              41.3221129226996,
              0
            ],
            [
              -73.9825302656072,
              41.3217848879185,
              0
            ],
            [
              -73.9825302267291,
              41.3217849705896,
              0
            ],
            [
              -73.9825301830232,
              41.3217850595425,
              0
            ],
            [
              -73.9825252060359,
              41.3217949606613,
              0
            ],
            [
              -73.9821868109016,
              41.3224681643305,
              0
            ],
            [
              -73.9820823073786,
              41.3226888853797,
              0
            ],
            [
              -73.9820070237236,
              41.3228478970009,
              0
            ],
            [
              -73.9817764792984,
              41.3234416717188,
              0
            ],
            [
              -73.9816931169182,
              41.3236824948258,
              0
            ],
            [
              -73.9815885697647,
              41.3239845247639,
              0
            ],
            [
              -73.9814502286393,
              41.3243959929712,
              0
            ],
            [
              -73.9814010221595,
              41.3245423489582,
              0
            ],
            [
              -73.9813514370076,
              41.3246895802991,
              0
            ],
            [
              -73.9812697369819,
              41.324932168306,
              0
            ],
            [
              -73.9811669902211,
              41.3251493375698,
              0
            ],
            [
              -73.9810120802564,
              41.3254767617408,
              0
            ],
            [
              -73.9807726279322,
              41.3259828674406,
              0
            ],
            [
              -73.9801195873258,
              41.327311713526,
              0
            ],
            [
              -73.9800045604705,
              41.3275063749786,
              0
            ],
            [
              -73.9797623699596,
              41.3279162496462,
              0
            ],
            [
              -73.9789825196484,
              41.3291275580466,
              0
            ],
            [
              -73.9786648285944,
              41.3294663436117,
              0
            ],
            [
              -73.9782377182795,
              41.3299218059088,
              0
            ],
            [
              -73.9776349916735,
              41.3305009391016,
              0
            ],
            [
              -73.9771438977663,
              41.3309727993488,
              0
            ],
            [
              -73.9768711152452,
              41.3311955440755,
              0
            ],
            [
              -73.9767381054118,
              41.331304155333,
              0
            ],
            [
              -73.9763053503375,
              41.3316391593658,
              0
            ],
            [
              -73.975825708198,
              41.3319804948353,
              0
            ],
            [
              -73.9753968873838,
              41.3323042129837,
              0
            ],
            [
              -73.9750910046628,
              41.3325485666574,
              0
            ],
            [
              -73.9749615047462,
              41.3326520157804,
              0
            ],
            [
              -73.9748888599481,
              41.3327232396435,
              0
            ],
            [
              -73.9746157496307,
              41.3329910067773,
              0
            ],
            [
              -73.9745279203493,
              41.3330771165418,
              0
            ],
            [
              -73.9744359511048,
              41.3331645706854,
              0
            ],
            [
              -73.9741583829391,
              41.3334285036499,
              0
            ],
            [
              -73.9738116215167,
              41.3338491995318,
              0
            ],
            [
              -73.9733862100233,
              41.3343062315324,
              0
            ],
            [
              -73.9731295664832,
              41.3346044693473,
              0
            ],
            [
              -73.9729862907697,
              41.3347709653276,
              0
            ],
            [
              -73.9726620407689,
              41.3351671735533,
              0
            ],
            [
              -73.9723727919834,
              41.3354980887245,
              0
            ],
            [
              -73.9720551065824,
              41.3359279362934,
              0
            ],
            [
              -73.9717544307437,
              41.3363252216355,
              0
            ],
            [
              -73.9715571424857,
              41.3366388367464,
              0
            ],
            [
              -73.9713867780517,
              41.3368519492346,
              0
            ],
            [
              -73.971162189394,
              41.3371328916198,
              0
            ],
            [
              -73.9709567103684,
              41.3374770632638,
              0
            ],
            [
              -73.9709518473791,
              41.3374852075077,
              0
            ],
            [
              -73.9708715489839,
              41.337619704745,
              0
            ],
            [
              -73.9703007272703,
              41.3383363392873,
              0
            ],
            [
              -73.9696575817426,
              41.3391356912646,
              0
            ],
            [
              -73.9689275398402,
              41.3400233472935,
              0
            ],
            [
              -73.967842763736,
              41.3412694885542,
              0
            ],
            [
              -73.9677003457805,
              41.3414329758366,
              0
            ],
            [
              -73.9673364287897,
              41.3418507302032,
              0
            ],
            [
              -73.9664976888504,
              41.3428135267824,
              0
            ],
            [
              -73.9646662921996,
              41.3449052225359,
              0
            ],
            [
              -73.9645525753701,
              41.3450350959619,
              0
            ],
            [
              -73.9634597701021,
              41.3462831365311,
              0
            ],
            [
              -73.962910167183,
              41.3469107884707,
              0
            ],
            [
              -73.9628234726293,
              41.347009794825,
              0
            ],
            [
              -73.9617167102208,
              41.3482669994522,
              0
            ],
            [
              -73.9612756694744,
              41.3488072114943,
              0
            ],
            [
              -73.9608143262529,
              41.349567327222,
              0
            ],
            [
              -73.9605720228594,
              41.3500187808584,
              0
            ],
            [
              -73.9605335586442,
              41.3500904509626,
              0
            ],
            [
              -73.9603113651029,
              41.3506463501722,
              0
            ],
            [
              -73.9601114419774,
              41.3512680785929,
              0
            ],
            [
              -73.9600351589333,
              41.3515697489436,
              0
            ],
            [
              -73.9599765258391,
              41.3518016075463,
              0
            ],
            [
              -73.9598630029836,
              41.3521618953208,
              0
            ],
            [
              -73.9598254463609,
              41.3523520824521,
              0
            ],
            [
              -73.9597918581627,
              41.3525221963845,
              0
            ],
            [
              -73.9597695127926,
              41.3526379840868,
              0
            ],
            [
              -73.9597539170639,
              41.3527187958892,
              0
            ],
            [
              -73.9597524163303,
              41.3527265682061,
              0
            ],
            [
              -73.9597319748066,
              41.3528324981289,
              0
            ],
            [
              -73.9597319355318,
              41.352841439843,
              0
            ],
            [
              -73.9597305218749,
              41.3531653343323,
              0
            ],
            [
              -73.9597478220238,
              41.3535609175686,
              0
            ],
            [
              -73.9597475767292,
              41.353568325675,
              0
            ],
            [
              -73.9597406992224,
              41.3537765801603,
              0
            ],
            [
              -73.9597356613958,
              41.3539291297645,
              0
            ],
            [
              -73.9596901916605,
              41.3544108367882,
              0
            ],
            [
              -73.9596676896512,
              41.3546492240204,
              0
            ],
            [
              -73.9596347223671,
              41.3551713641611,
              0
            ],
            [
              -73.9596349764321,
              41.3551744585473,
              0
            ],
            [
              -73.9596698324176,
              41.3555984049663,
              0
            ],
            [
              -73.9596902745274,
              41.3558470315635,
              0
            ],
            [
              -73.9596929040086,
              41.3558668061241,
              0
            ],
            [
              -73.9597553031727,
              41.356336063099,
              0
            ],
            [
              -73.9598105688932,
              41.3568370351906,
              0
            ],
            [
              -73.9598104040429,
              41.3568464211524,
              0
            ],
            [
              -73.9598104016491,
              41.3568465661205,
              0
            ],
            [
              -73.9598022575755,
              41.3573082852092,
              0
            ],
            [
              -73.9597770500021,
              41.3577314164006,
              0
            ],
            [
              -73.9597695155996,
              41.3578578966305,
              0
            ],
            [
              -73.9597665866699,
              41.3579818554856,
              0
            ],
            [
              -73.9597525058806,
              41.3585778100297,
              0
            ],
            [
              -73.9597523986196,
              41.3585854330948,
              0
            ],
            [
              -73.9597426312639,
              41.3592812138882,
              0
            ],
            [
              -73.9597426090774,
              41.3592814398076,
              0
            ],
            [
              -73.9596814515485,
              41.3599352882619,
              0
            ],
            [
              -73.9596210335531,
              41.3607103850354,
              0
            ],
            [
              -73.9596133252673,
              41.3610642656251,
              0
            ],
            [
              -73.9596099000112,
              41.3612214313205,
              0
            ],
            [
              -73.9595740578623,
              41.3614420087129,
              0
            ],
            [
              -73.9595480209095,
              41.3616022298365,
              0
            ],
            [
              -73.959525908021,
              41.3617382974745,
              0
            ],
            [
              -73.9594968314222,
              41.3621229816157,
              0
            ],
            [
              -73.9594656673095,
              41.3625352830065,
              0
            ],
            [
              -73.9593760036154,
              41.3632678602861,
              0
            ],
            [
              -73.9592975701616,
              41.3636905355627,
              0
            ],
            [
              -73.9592572464033,
              41.3639078427288,
              0
            ],
            [
              -73.9588795527913,
              41.3653725609407,
              0
            ],
            [
              -73.958436623172,
              41.3673949102887,
              0
            ],
            [
              -73.9580979725006,
              41.3683176970514,
              0
            ],
            [
              -73.9578641177993,
              41.3689549103062,
              0
            ],
            [
              -73.9577177019785,
              41.3694678414371,
              0
            ],
            [
              -73.9576613464796,
              41.3696652659757,
              0
            ],
            [
              -73.9575825653707,
              41.3699412543394,
              0
            ],
            [
              -73.9574226745921,
              41.3707113754106,
              0
            ],
            [
              -73.956631168653,
              41.3735363093863,
              0
            ],
            [
              -73.9560188913548,
              41.3750596020727,
              0
            ],
            [
              -73.9558790495613,
              41.375366389741,
              0
            ],
            [
              -73.9556629611883,
              41.3758404364243,
              0
            ],
            [
              -73.9555002628859,
              41.3761844929878,
              0
            ],
            [
              -73.9554372947501,
              41.3763176511805,
              0
            ],
            [
              -73.9554368225622,
              41.3763186502904,
              0
            ],
            [
              -73.9554265465187,
              41.3763403782001,
              0
            ],
            [
              -73.9553778150553,
              41.3764129476534,
              0
            ],
            [
              -73.9541702286879,
              41.3782111944776,
              0
            ],
            [
              -73.9536516271018,
              41.3789810136506,
              0
            ],
            [
              -73.9531086697676,
              41.3798526508695,
              0
            ],
            [
              -73.9526796607809,
              41.380883695242,
              0
            ],
            [
              -73.9523146930886,
              41.3820390723354,
              0
            ],
            [
              -73.9521762189061,
              41.3826384420294,
              0
            ],
            [
              -73.9521670005852,
              41.3827168072794,
              0
            ],
            [
              -73.9521178184514,
              41.3831349247563,
              0
            ],
            [
              -73.9520642979026,
              41.3835899307401,
              0
            ],
            [
              -73.9520055708386,
              41.3839176098365,
              0
            ],
            [
              -73.9519492303356,
              41.3842319676209,
              0
            ],
            [
              -73.9517778402435,
              41.3849260966773,
              0
            ],
            [
              -73.9514970162651,
              41.3860634012587,
              0
            ],
            [
              -73.9511048634972,
              41.3871484219856,
              0
            ],
            [
              -73.9506594151093,
              41.3882349985136,
              0
            ],
            [
              -73.950174003785,
              41.3894190111919,
              0
            ],
            [
              -73.9487931878511,
              41.3917384571315,
              0
            ],
            [
              -73.9481093174851,
              41.3928871279548,
              0
            ],
            [
              -73.9480196190134,
              41.3930850272225,
              0
            ],
            [
              -73.9480086215966,
              41.3931092894115,
              0
            ],
            [
              -73.9477709022792,
              41.3936337412986,
              0
            ],
            [
              -73.9476883553505,
              41.394049312324,
              0
            ],
            [
              -73.9476121216324,
              41.3944330678581,
              0
            ],
            [
              -73.9476120891335,
              41.3944419915242,
              0
            ],
            [
              -73.9476105588731,
              41.394853540753,
              0
            ],
            [
              -73.9476105215899,
              41.3948634531296,
              0
            ],
            [
              -73.9476100917724,
              41.394979053724,
              0
            ],
            [
              -73.9476097113955,
              41.3950821756116,
              0
            ],
            [
              -73.947616745362,
              41.3951133905247,
              0
            ],
            [
              -73.9477642812573,
              41.3957681427015,
              0
            ],
            [
              -73.9479686065607,
              41.396156398916,
              0
            ],
            [
              -73.9482099225242,
              41.3966149349949,
              0
            ],
            [
              -73.9482151363499,
              41.3966223088659,
              0
            ],
            [
              -73.9488198721098,
              41.3974774679145,
              0
            ],
            [
              -73.9492138706371,
              41.3978937924984,
              0
            ],
            [
              -73.9492213488527,
              41.3979016922397,
              0
            ],
            [
              -73.9495090741542,
              41.3982057153009,
              0
            ],
            [
              -73.9502024306087,
              41.3986707293733,
              0
            ],
            [
              -73.9512249769984,
              41.3990494745294,
              0
            ],
            [
              -73.9522181909004,
              41.3992849378137,
              0
            ],
            [
              -73.9532187461499,
              41.3994495411597,
              0
            ],
            [
              -73.9536695424652,
              41.3995236988236,
              0
            ],
            [
              -73.9554450707751,
              41.3997556395066,
              0
            ],
            [
              -73.9559447664854,
              41.3998026647113,
              0
            ],
            [
              -73.9569026483753,
              41.3998927972895,
              0
            ],
            [
              -73.9578256855696,
              41.4001134677458,
              0
            ],
            [
              -73.9591816204487,
              41.4005317428428,
              0
            ],
            [
              -73.9596445561147,
              41.4007487674227,
              0
            ],
            [
              -73.9600911087827,
              41.4010440033002,
              0
            ],
            [
              -73.9603137403104,
              41.4012280372581,
              0
            ],
            [
              -73.960475293605,
              41.4013858224984,
              0
            ],
            [
              -73.961210295369,
              41.4021036686942,
              0
            ],
            [
              -73.961758273287,
              41.4026060848172,
              0
            ],
            [
              -73.9618903196326,
              41.4027829202574,
              0
            ],
            [
              -73.9620501524097,
              41.4029969647482,
              0
            ],
            [
              -73.9620564423171,
              41.4030069472219,
              0
            ],
            [
              -73.9625845699897,
              41.4038451052884,
              0
            ],
            [
              -73.9627788797436,
              41.4042957502021,
              0
            ],
            [
              -73.9629931341584,
              41.4050074925944,
              0
            ],
            [
              -73.9631087417109,
              41.4058457471499,
              0
            ],
            [
              -73.9631085282876,
              41.405854819442,
              0
            ],
            [
              -73.9631022099915,
              41.4061229787315,
              0
            ],
            [
              -73.9630718211421,
              41.4074127411167,
              0
            ],
            [
              -73.9630592924039,
              41.4079444333461,
              0
            ],
            [
              -73.9630593418957,
              41.4079453952948,
              0
            ],
            [
              -73.9631272600059,
              41.4092432917407,
              0
            ],
            [
              -73.9631700093962,
              41.4095303297554,
              0
            ],
            [
              -73.9631768566131,
              41.4095763071247,
              0
            ],
            [
              -73.9632088531939,
              41.4097911445202,
              0
            ],
            [
              -73.9632801681214,
              41.4102699775428,
              0
            ],
            [
              -73.9633699438629,
              41.4105589961394,
              0
            ],
            [
              -73.9635058289502,
              41.410996455685,
              0
            ],
            [
              -73.9641235530264,
              41.4119641420077,
              0
            ],
            [
              -73.9641237636842,
              41.411964416736,
              0
            ],
            [
              -73.9641239719571,
              41.4119646905527,
              0
            ],
            [
              -73.9645312170382,
              41.4125000072556,
              0
            ],
            [
              -73.9646453079551,
              41.4126499771083,
              0
            ],
            [
              -73.9646477635217,
              41.4126532023616,
              0
            ],
            [
              -73.9646997939391,
              41.4127215948795,
              0
            ],
            [
              -73.9647040944756,
              41.4127289880512,
              0
            ],
            [
              -73.9654451079186,
              41.4140022993018,
              0
            ],
            [
              -73.9656771332868,
              41.414617112631,
              0
            ],
            [
              -73.965920925582,
              41.4154205692532,
              0
            ],
            [
              -73.965972733672,
              41.4155913091076,
              0
            ],
            [
              -73.9660505374982,
              41.4158143012759,
              0
            ],
            [
              -73.9660823344973,
              41.4159054345991,
              0
            ],
            [
              -73.9661762918973,
              41.416174724353,
              0
            ],
            [
              -73.9663952699421,
              41.4166527298659,
              0
            ],
            [
              -73.966504927326,
              41.4168517877874,
              0
            ],
            [
              -73.9665079483917,
              41.4168572758346,
              0
            ],
            [
              -73.9665735309831,
              41.416976324864,
              0
            ],
            [
              -73.9666243653272,
              41.4170659758387,
              0
            ],
            [
              -73.966707210214,
              41.417212081494,
              0
            ],
            [
              -73.9667964692256,
              41.4174014030946,
              0
            ],
            [
              -73.9668934341836,
              41.4176070680797,
              0
            ],
            [
              -73.9671146498583,
              41.4179849433422,
              0
            ],
            [
              -73.9671626446586,
              41.4180634617462,
              0
            ],
            [
              -73.9673346593265,
              41.4183448731467,
              0
            ],
            [
              -73.9674331432227,
              41.418511416883,
              0
            ],
            [
              -73.9675759795564,
              41.4187529635205,
              0
            ],
            [
              -73.9677625940193,
              41.4190454673291,
              0
            ],
            [
              -73.9678872124712,
              41.4192407957332,
              0
            ],
            [
              -73.9679541888489,
              41.419346063983,
              0
            ],
            [
              -73.9680716109433,
              41.4195306161371,
              0
            ],
            [
              -73.9680717981357,
              41.4195308394219,
              0
            ],
            [
              -73.9680719853355,
              41.4195310618062,
              0
            ],
            [
              -73.968304684806,
              41.4198068018522,
              0
            ],
            [
              -73.9685995855013,
              41.4201788301161,
              0
            ],
            [
              -73.9687065381862,
              41.4203101282086,
              0
            ],
            [
              -73.9687767907807,
              41.4203963721813,
              0
            ],
            [
              -73.9688635988037,
              41.4205029398971,
              0
            ],
            [
              -73.9690282300257,
              41.4206736479323,
              0
            ],
            [
              -73.9690391783511,
              41.4206849995189,
              0
            ],
            [
              -73.9691728029668,
              41.4208235538801,
              0
            ],
            [
              -73.9695266111872,
              41.4211737518359,
              0
            ],
            [
              -73.9697224175878,
              41.4213333969894,
              0
            ],
            [
              -73.9699020025853,
              41.4214798182186,
              0
            ],
            [
              -73.9704542404159,
              41.4219554461283,
              0
            ],
            [
              -73.971042854396,
              41.4224254259895,
              0
            ],
            [
              -73.9719369498525,
              41.4234396711356,
              0
            ],
            [
              -73.9728461742408,
              41.424557992332,
              0
            ],
            [
              -73.9728486911292,
              41.424562172197,
              0
            ],
            [
              -73.9728516235444,
              41.4245670446359,
              0
            ],
            [
              -73.9736262459135,
              41.4258541467964,
              0
            ],
            [
              -73.9736381011737,
              41.4258738450543,
              0
            ],
            [
              -73.973914417434,
              41.4263329545317,
              0
            ],
            [
              -73.9743990182488,
              41.4272957793643,
              0
            ],
            [
              -73.9746595565988,
              41.4279243531015,
              0
            ],
            [
              -73.9747019057122,
              41.4280265197379,
              0
            ],
            [
              -73.9751686943001,
              41.4290984476597,
              0
            ],
            [
              -73.9756287534045,
              41.4300853310747,
              0
            ],
            [
              -73.9757875112893,
              41.4304271803767,
              0
            ],
            [
              -73.9760312960658,
              41.4309521117943,
              0
            ],
            [
              -73.9763490646682,
              41.4317470393643,
              0
            ],
            [
              -73.9765429789456,
              41.4322544209313,
              0
            ],
            [
              -73.9766541910455,
              41.4325454104205,
              0
            ],
            [
              -73.9770419466233,
              41.4335195212828,
              0
            ],
            [
              -73.9775043482666,
              41.4343608516316,
              0
            ],
            [
              -73.9779284941365,
              41.4350850735817,
              0
            ],
            [
              -73.9780972076819,
              41.4353731446747,
              0
            ],
            [
              -73.9786054023679,
              41.4361178674163,
              0
            ],
            [
              -73.9792438010245,
              41.4368337162552,
              0
            ],
            [
              -73.9793860741013,
              41.4369932481665,
              0
            ],
            [
              -73.9799314580898,
              41.4375581397258,
              0
            ],
            [
              -73.9803817115087,
              41.4379901455585,
              0
            ],
            [
              -73.980387250223,
              41.4379954590964,
              0
            ],
            [
              -73.9805562275969,
              41.4381575864664,
              0
            ],
            [
              -73.9809281293357,
              41.438481022905,
              0
            ],
            [
              -73.9810029550743,
              41.438546096021,
              0
            ],
            [
              -73.9811990670529,
              41.4387388639227,
              0
            ],
            [
              -73.9814715262956,
              41.4390066722643,
              0
            ],
            [
              -73.9786535408041,
              41.4419638537203,
              0
            ],
            [
              -73.9783269784515,
              41.4423055002579,
              0
            ],
            [
              -73.9781144138355,
              41.4425278812418,
              0
            ],
            [
              -73.9776417695722,
              41.4430225721714,
              0
            ],
            [
              -73.9775325948637,
              41.4431368380231,
              0
            ],
            [
              -73.9770570017919,
              41.4436346026394,
              0
            ],
            [
              -73.9766991399283,
              41.4440091461462,
              0
            ],
            [
              -73.9760479401194,
              41.444690692317,
              0
            ],
            [
              -73.9759740899417,
              41.4447679871655,
              0
            ],
            [
              -73.9756426870855,
              41.4451148446204,
              0
            ],
            [
              -73.9541740960612,
              41.4673677855855,
              0
            ],
            [
              -73.9520136275474,
              41.4695864247483,
              0
            ],
            [
              -73.944974465717,
              41.4768472826134,
              0
            ],
            [
              -73.9336514323201,
              41.4885652799538,
              0
            ],
            [
              -73.9313922842377,
              41.488785150769,
              0
            ],
            [
              -73.9257408643591,
              41.4893504375391,
              0
            ],
            [
              -73.9227669847985,
              41.4896477861455,
              0
            ],
            [
              -73.9191018524086,
              41.490031493381,
              0
            ],
            [
              -73.9183327963019,
              41.4901131091527,
              0
            ],
            [
              -73.915116471115,
              41.4904566125415,
              0
            ],
            [
              -73.9117581192188,
              41.4908126040858,
              0
            ],
            [
              -73.9107118852431,
              41.4909221468146,
              0
            ],
            [
              -73.9088709302811,
              41.4910684544995,
              0
            ],
            [
              -73.9074166118705,
              41.4911840130373,
              0
            ],
            [
              -73.9032435275038,
              41.4915154982326,
              0
            ],
            [
              -73.902520380271,
              41.491572924665,
              0
            ],
            [
              -73.9022168683258,
              41.4915970263379,
              0
            ],
            [
              -73.9000071781626,
              41.491772468239,
              0
            ],
            [
              -73.8996111367207,
              41.4918039081013,
              0
            ],
            [
              -73.8995201706363,
              41.4918111286452,
              0
            ],
            [
              -73.8991334602696,
              41.491841825864,
              0
            ],
            [
              -73.8990000443805,
              41.4918524162019,
              0
            ],
            [
              -73.8984756759881,
              41.4918940385071,
              0
            ],
            [
              -73.8983363857246,
              41.4919093986609,
              0
            ],
            [
              -73.8979318289434,
              41.4919540107004,
              0
            ],
            [
              -73.8975359393032,
              41.4919976653915,
              0
            ],
            [
              -73.897158878299,
              41.4920392418703,
              0
            ],
            [
              -73.8963592128299,
              41.4921274135499,
              0
            ],
            [
              -73.8949282470131,
              41.4922851785995,
              0
            ],
            [
              -73.8942774779464,
              41.4923569200129,
              0
            ],
            [
              -73.8819575698458,
              41.493714355648,
              0
            ],
            [
              -73.8794395702377,
              41.4939827688662,
              0
            ],
            [
              -73.8762713706588,
              41.4944297596297,
              0
            ],
            [
              -73.876262001796,
              41.4944310811379,
              0
            ],
            [
              -73.8732741140775,
              41.494852265311,
              0
            ],
            [
              -73.8719325487261,
              41.4950410190477,
              0
            ],
            [
              -73.8716815252312,
              41.4950698389436,
              0
            ],
            [
              -73.8705720734849,
              41.495226216541,
              0
            ],
            [
              -73.8705183860292,
              41.4952336514495,
              0
            ],
            [
              -73.8705010047191,
              41.4952360569234,
              0
            ],
            [
              -73.8702901261729,
              41.4952652501739,
              0
            ],
            [
              -73.8695254710643,
              41.4953710984931,
              0
            ],
            [
              -73.8682469137132,
              41.4955306497806,
              0
            ],
            [
              -73.8681543764665,
              41.4955463264914,
              0
            ],
            [
              -73.8680919651238,
              41.4955569018023,
              0
            ],
            [
              -73.8679703056687,
              41.495562262868,
              0
            ],
            [
              -73.8663409944097,
              41.4956340673513,
              0
            ],
            [
              -73.8662969457856,
              41.4956352933288,
              0
            ],
            [
              -73.8658731393434,
              41.4956470975548,
              0
            ],
            [
              -73.865241738158,
              41.4956787815651,
              0
            ],
            [
              -73.8644515476281,
              41.495709239002,
              0
            ],
            [
              -73.8632972522012,
              41.495759119737,
              0
            ],
            [
              -73.8606613549647,
              41.4958705813543,
              0
            ],
            [
              -73.8596070455767,
              41.4959142894082,
              0
            ],
            [
              -73.8595031063284,
              41.4959272635957,
              0
            ],
            [
              -73.8594743206421,
              41.4959306952608,
              0
            ],
            [
              -73.8572855252341,
              41.4961918726605,
              0
            ],
            [
              -73.8572813726999,
              41.4961923681257,
              0
            ],
            [
              -73.8571493161244,
              41.4962119239672,
              0
            ],
            [
              -73.8560479100912,
              41.4963312060362,
              0
            ],
            [
              -73.8560438239176,
              41.4963316505015,
              0
            ],
            [
              -73.8559222817278,
              41.4963477807875,
              0
            ],
            [
              -73.8558753834653,
              41.496360212059,
              0
            ],
            [
              -73.8558379177569,
              41.4963645991246,
              0
            ],
            [
              -73.8443696891391,
              41.4977073141962,
              0
            ],
            [
              -73.8443550632681,
              41.4977088993892,
              0
            ],
            [
              -73.843231027346,
              41.4978308444091,
              0
            ],
            [
              -73.8409648728355,
              41.4980998874993,
              0
            ],
            [
              -73.8409630560905,
              41.4981001022062,
              0
            ],
            [
              -73.8396785393805,
              41.4982487857937,
              0
            ],
            [
              -73.8393494426296,
              41.4982545976001,
              0
            ],
            [
              -73.8371349871747,
              41.4982796335371,
              0
            ],
            [
              -73.8369776416587,
              41.498294416346,
              0
            ],
            [
              -73.8349743244047,
              41.4985214788415,
              0
            ],
            [
              -73.8256076364824,
              41.4993427020339,
              0
            ],
            [
              -73.8249282361662,
              41.4993859539092,
              0
            ],
            [
              -73.8231324298612,
              41.4995599159569,
              0
            ],
            [
              -73.8207672490836,
              41.4997598251097,
              0
            ],
            [
              -73.8195252109948,
              41.4998817030479,
              0
            ],
            [
              -73.8185742586714,
              41.4999588959707,
              0
            ],
            [
              -73.8149166178308,
              41.5003799420967,
              0
            ],
            [
              -73.8146214221999,
              41.5004139183942,
              0
            ],
            [
              -73.8143721413163,
              41.500442609072,
              0
            ],
            [
              -73.8133938636333,
              41.5005542173908,
              0
            ],
            [
              -73.8121169535791,
              41.500701194837,
              0
            ],
            [
              -73.8117873809487,
              41.5007417450609,
              0
            ],
            [
              -73.8110650753333,
              41.5008248767026,
              0
            ],
            [
              -73.8097616294156,
              41.5009663607614,
              0
            ],
            [
              -73.8095875196339,
              41.5009852583611,
              0
            ],
            [
              -73.8085557168642,
              41.501094162047,
              0
            ],
            [
              -73.8070678950872,
              41.5012545018112,
              0
            ],
            [
              -73.8054631775381,
              41.5014245258503,
              0
            ],
            [
              -73.805330039226,
              41.5014342572338,
              0
            ],
            [
              -73.8034762060812,
              41.5015804125137,
              0
            ],
            [
              -73.8001091841938,
              41.5018637535558,
              0
            ],
            [
              -73.7999587054629,
              41.5018778719238,
              0
            ],
            [
              -73.7996693700679,
              41.5018983294703,
              0
            ],
            [
              -73.796356850519,
              41.5020971324195,
              0
            ],
            [
              -73.796306170256,
              41.5021014327328,
              0
            ],
            [
              -73.7949444527608,
              41.5022026815912,
              0
            ],
            [
              -73.7938543337095,
              41.5023789936351,
              0
            ],
            [
              -73.7917564420532,
              41.5025599408297,
              0
            ],
            [
              -73.7822219633829,
              41.5033521277838,
              0
            ],
            [
              -73.7792183772692,
              41.5036011174477,
              0
            ],
            [
              -73.7776224783235,
              41.50373338009,
              0
            ],
            [
              -73.7772653697155,
              41.5037609500591,
              0
            ],
            [
              -73.776533455148,
              41.5038174521089,
              0
            ],
            [
              -73.7763438872613,
              41.503840187559,
              0
            ],
            [
              -73.775459934287,
              41.5039461998371,
              0
            ],
            [
              -73.7753230408373,
              41.5039576440181,
              0
            ],
            [
              -73.7740554039064,
              41.5040976258818,
              0
            ],
            [
              -73.7727159731887,
              41.5042357044374,
              0
            ],
            [
              -73.7724713112426,
              41.5042600607084,
              0
            ],
            [
              -73.7693680658747,
              41.5045848938122,
              0
            ],
            [
              -73.7669544797941,
              41.5048417119324,
              0
            ],
            [
              -73.7555939998125,
              41.5060313284519,
              0
            ],
            [
              -73.7510131292796,
              41.5065138586996,
              0
            ],
            [
              -73.7486854164155,
              41.5067579954045,
              0
            ],
            [
              -73.7431712784139,
              41.5072754149404,
              0
            ],
            [
              -73.7431238891904,
              41.5072798602308,
              0
            ],
            [
              -73.742637961281,
              41.507325443926,
              0
            ],
            [
              -73.7425007808998,
              41.5073383121698,
              0
            ],
            [
              -73.7410858456573,
              41.5074710223199,
              0
            ],
            [
              -73.7389597086203,
              41.5076704232172,
              0
            ],
            [
              -73.7364505842534,
              41.5079056817161,
              0
            ],
            [
              -73.733287439134,
              41.5082021817828,
              0
            ],
            [
              -73.7305006485902,
              41.5084633291699,
              0
            ],
            [
              -73.7292107561294,
              41.5085978201261,
              0
            ],
            [
              -73.7289598458586,
              41.5086239796632,
              0
            ],
            [
              -73.7240167182076,
              41.5090677412184,
              0
            ],
            [
              -73.7220451920371,
              41.5092460476865,
              0
            ],
            [
              -73.7193258764251,
              41.5094623113462,
              0
            ],
            [
              -73.7191644206743,
              41.5094751499257,
              0
            ],
            [
              -73.717065603144,
              41.5096519636578,
              0
            ],
            [
              -73.7153475260705,
              41.5098313670863,
              0
            ],
            [
              -73.7152636822541,
              41.509838467861,
              0
            ],
            [
              -73.7151785553087,
              41.5098456768784,
              0
            ],
            [
              -73.7136124007979,
              41.5099823897205,
              0
            ],
            [
              -73.7126774154735,
              41.5100662226832,
              0
            ],
            [
              -73.7089521458642,
              41.5103663073275,
              0
            ],
            [
              -73.7057043749018,
              41.5108079181201,
              0
            ],
            [
              -73.7035711313962,
              41.511093034298,
              0
            ],
            [
              -73.7032339851234,
              41.5111039114997,
              0
            ],
            [
              -73.7001897229169,
              41.510945851369,
              0
            ],
            [
              -73.6954105982657,
              41.5107342281805,
              0
            ],
            [
              -73.6948864661339,
              41.5106924101882,
              0
            ],
            [
              -73.6944963714099,
              41.5106612852072,
              0
            ],
            [
              -73.6941186026754,
              41.510631143038,
              0
            ],
            [
              -73.6940930646444,
              41.5106291064265,
              0
            ],
            [
              -73.6937630715017,
              41.5106102159811,
              0
            ],
            [
              -73.6935067427274,
              41.5105955402979,
              0
            ],
            [
              -73.6925847404185,
              41.5105427501952,
              0
            ],
            [
              -73.6924916988291,
              41.5105374226391,
              0
            ],
            [
              -73.6924213574407,
              41.5105595609431,
              0
            ],
            [
              -73.6921220592006,
              41.5106627535421,
              0
            ],
            [
              -73.6907426792969,
              41.511138323773,
              0
            ],
            [
              -73.690234563213,
              41.5113224521775,
              0
            ],
            [
              -73.6894953113806,
              41.5115913795904,
              0
            ],
            [
              -73.6889990917153,
              41.5117821984428,
              0
            ],
            [
              -73.6885801965395,
              41.5119144183705,
              0
            ],
            [
              -73.6881860879424,
              41.5120467712159,
              0
            ],
            [
              -73.6876330754955,
              41.5122228910928,
              0
            ],
            [
              -73.6873971831438,
              41.5123005516738,
              0
            ],
            [
              -73.6871827429368,
              41.5123666051531,
              0
            ],
            [
              -73.68688650108,
              41.5124602112365,
              0
            ],
            [
              -73.686772192165,
              41.5124938924832,
              0
            ],
            [
              -73.6867288929195,
              41.5125066303881,
              0
            ],
            [
              -73.6865089299806,
              41.5125761130313,
              0
            ],
            [
              -73.6863604600838,
              41.5126187621481,
              0
            ],
            [
              -73.6862025528933,
              41.5126663265491,
              0
            ],
            [
              -73.6859948842657,
              41.5127298531011,
              0
            ],
            [
              -73.6858984540919,
              41.5126008420605,
              0
            ],
            [
              -73.6857540142327,
              41.5126456557179,
              0
            ],
            [
              -73.6857237886565,
              41.5126550307332,
              0
            ],
            [
              -73.6857047014612,
              41.5126611078744,
              0
            ],
            [
              -73.6856816281758,
              41.5126684552542,
              0
            ],
            [
              -73.6847106296357,
              41.5129717173668,
              0
            ],
            [
              -73.6846925312076,
              41.5129770782779,
              0
            ],
            [
              -73.6845685776763,
              41.5130159962751,
              0
            ],
            [
              -73.6844168781743,
              41.5130634095326,
              0
            ],
            [
              -73.684284170724,
              41.5131048845847,
              0
            ],
            [
              -73.6841735764643,
              41.513139446827,
              0
            ],
            [
              -73.6841599149077,
              41.5131436991437,
              0
            ],
            [
              -73.6841515572776,
              41.5131463016198,
              0
            ],
            [
              -73.6841046095681,
              41.5131609144263,
              0
            ],
            [
              -73.6840205543952,
              41.5131664934327,
              0
            ],
            [
              -73.6839716883132,
              41.5131695900718,
              0
            ],
            [
              -73.6838912210743,
              41.5131746982879,
              0
            ],
            [
              -73.6837705202109,
              41.5131823591557,
              0
            ],
            [
              -73.6835492346214,
              41.5131964041961,
              0
            ],
            [
              -73.6834084162414,
              41.5132053427895,
              0
            ],
            [
              -73.6832474804121,
              41.513215556566,
              0
            ],
            [
              -73.683002300415,
              41.513231118319,
              0
            ],
            [
              -73.6827388900503,
              41.5132478349573,
              0
            ],
            [
              -73.6826373448267,
              41.5132542782671,
              0
            ],
            [
              -73.6824903383868,
              41.5132634148798,
              0
            ],
            [
              -73.6824737269527,
              41.5132644493865,
              0
            ],
            [
              -73.6822732750336,
              41.5132769048785,
              0
            ],
            [
              -73.6821516722348,
              41.5132846179638,
              0
            ],
            [
              -73.6817895637807,
              41.513307582958,
              0
            ],
            [
              -73.6816449682811,
              41.5133167527511,
              0
            ],
            [
              -73.6814199039919,
              41.5133310252352,
              0
            ],
            [
              -73.681251904507,
              41.5133416802923,
              0
            ],
            [
              -73.6812518478019,
              41.5133416168563,
              0
            ],
            [
              -73.6811431341639,
              41.5133484742505,
              0
            ],
            [
              -73.68113643438,
              41.5133488947861,
              0
            ],
            [
              -73.681084206671,
              41.5133521607613,
              0
            ],
            [
              -73.6810358287499,
              41.5133551902926,
              0
            ],
            [
              -73.6808107322382,
              41.5133693370904,
              0
            ],
            [
              -73.680668022017,
              41.5133783263846,
              0
            ],
            [
              -73.6804266195884,
              41.5133934881394,
              0
            ],
            [
              -73.6803058601911,
              41.5134010720138,
              0
            ],
            [
              -73.6801046737062,
              41.5134137616123,
              0
            ],
            [
              -73.6799437232678,
              41.5134239130287,
              0
            ],
            [
              -73.6798613686454,
              41.5134291076174,
              0
            ],
            [
              -73.6796966593753,
              41.5134394957171,
              0
            ],
            [
              -73.6796363021676,
              41.5134433027549,
              0
            ],
            [
              -73.679112364129,
              41.5134816498922,
              0
            ],
            [
              -73.6791115606681,
              41.5134817125922,
              0
            ],
            [
              -73.6787440920349,
              41.5135114480265,
              0
            ],
            [
              -73.6786639959703,
              41.5135179293379,
              0
            ],
            [
              -73.6783195963817,
              41.5135458264413,
              0
            ],
            [
              -73.6781917066845,
              41.5135561882009,
              0
            ],
            [
              -73.6780315224552,
              41.5135691707648,
              0
            ],
            [
              -73.6778988709899,
              41.5135799718072,
              0
            ],
            [
              -73.6778489365722,
              41.5135840397091,
              0
            ],
            [
              -73.6778015053359,
              41.5135878760576,
              0
            ],
            [
              -73.6775863383541,
              41.5136052823673,
              0
            ],
            [
              -73.6773837879971,
              41.5136215187752,
              0
            ],
            [
              -73.6772146563333,
              41.5136351898856,
              0
            ],
            [
              -73.6772011336109,
              41.5136362871494,
              0
            ],
            [
              -73.676936143138,
              41.5136578605851,
              0
            ],
            [
              -73.6768137246673,
              41.513667724193,
              0
            ],
            [
              -73.6766289060208,
              41.5136826175383,
              0
            ],
            [
              -73.6765910651141,
              41.5136856702124,
              0
            ],
            [
              -73.6763861322604,
              41.5137022173723,
              0
            ],
            [
              -73.6763036889793,
              41.5137088747281,
              0
            ],
            [
              -73.6761635152434,
              41.5137201916827,
              0
            ],
            [
              -73.6759609243038,
              41.5137365495554,
              0
            ],
            [
              -73.6758503962164,
              41.5137455356421,
              0
            ],
            [
              -73.675809773886,
              41.5137488364639,
              0
            ],
            [
              -73.6755742223308,
              41.51376797668,
              0
            ],
            [
              -73.6750681928648,
              41.5138090955222,
              0
            ],
            [
              -73.6742118046781,
              41.5138800639854,
              0
            ],
            [
              -73.6741735055607,
              41.5138832377372,
              0
            ],
            [
              -73.6738530976624,
              41.513909788161,
              0
            ],
            [
              -73.6725741867689,
              41.5140108957796,
              0
            ],
            [
              -73.6725700001997,
              41.5140112312453,
              0
            ],
            [
              -73.6722876195866,
              41.5140340429439,
              0
            ],
            [
              -73.6720821459609,
              41.5140506442691,
              0
            ],
            [
              -73.6715328782189,
              41.5140950218947,
              0
            ],
            [
              -73.6713352186011,
              41.5141109911229,
              0
            ],
            [
              -73.670646216697,
              41.5141666533583,
              0
            ],
            [
              -73.6704463524738,
              41.5141827951561,
              0
            ],
            [
              -73.6701601564605,
              41.514206029738,
              0
            ],
            [
              -73.6700493811283,
              41.5142150210669,
              0
            ],
            [
              -73.6696171557273,
              41.5142501003515,
              0
            ],
            [
              -73.6691414033521,
              41.5142887220269,
              0
            ],
            [
              -73.668215559093,
              41.5143634085645,
              0
            ],
            [
              -73.6680506705844,
              41.5143767087766,
              0
            ],
            [
              -73.6679682280974,
              41.5143833592569,
              0
            ],
            [
              -73.6677479512534,
              41.5144011279878,
              0
            ],
            [
              -73.6674846953382,
              41.5144296194281,
              0
            ],
            [
              -73.6673000865004,
              41.5144498705389,
              0
            ],
            [
              -73.6671154787503,
              41.5144701213609,
              0
            ],
            [
              -73.6670300000273,
              41.514479498287,
              0
            ],
            [
              -73.6668881297031,
              41.5144950607246,
              0
            ],
            [
              -73.6667630001975,
              41.5145087866789,
              0
            ],
            [
              -73.6665189548492,
              41.5145355205215,
              0
            ],
            [
              -73.666373984349,
              41.514551318288,
              0
            ],
            [
              -73.666225953066,
              41.5145674691731,
              0
            ],
            [
              -73.6660002738811,
              41.5145920911182,
              0
            ],
            [
              -73.6658275051959,
              41.5146149776338,
              0
            ],
            [
              -73.6658274295765,
              41.5146149887913,
              0
            ],
            [
              -73.6658264499913,
              41.5146151437689,
              0
            ],
            [
              -73.6655088897047,
              41.514665786121,
              0
            ],
            [
              -73.6654464952477,
              41.5146757363809,
              0
            ],
            [
              -73.6653260124479,
              41.5146949503846,
              0
            ],
            [
              -73.6651625002284,
              41.5147210258811,
              0
            ],
            [
              -73.6648978664404,
              41.5147632271204,
              0
            ],
            [
              -73.6647730795396,
              41.5147831269566,
              0
            ],
            [
              -73.6645278093058,
              41.5148222398192,
              0
            ],
            [
              -73.6639748731048,
              41.5149104116221,
              0
            ],
            [
              -73.6639167831921,
              41.5149196746753,
              0
            ],
            [
              -73.6637726315929,
              41.5149426607915,
              0
            ],
            [
              -73.6634456033925,
              41.5149948079995,
              0
            ],
            [
              -73.6632670269534,
              41.5150232826004,
              0
            ],
            [
              -73.6631616020675,
              41.5150400925036,
              0
            ],
            [
              -73.6629981853886,
              41.5150661503046,
              0
            ],
            [
              -73.6629012142109,
              41.5150818085744,
              0
            ],
            [
              -73.6627615028749,
              41.5151041566988,
              0
            ],
            [
              -73.6625398741077,
              41.5151394204689,
              0
            ],
            [
              -73.6622988872195,
              41.5151778348897,
              0
            ],
            [
              -73.6622606171824,
              41.5151839457879,
              0
            ],
            [
              -73.6620536200323,
              41.5152169460899,
              0
            ],
            [
              -73.6618664371935,
              41.5152467848342,
              0
            ],
            [
              -73.661659891111,
              41.5152797075726,
              0
            ],
            [
              -73.6615207753523,
              41.51530188564,
              0
            ],
            [
              -73.6611887002578,
              41.5153548306519,
              0
            ],
            [
              -73.6605755105983,
              41.5154525966289,
              0
            ],
            [
              -73.6600978657537,
              41.5155287387695,
              0
            ],
            [
              -73.6599231579367,
              41.5155566079008,
              0
            ],
            [
              -73.6599219430044,
              41.5155568016295,
              0
            ],
            [
              -73.659273116043,
              41.5156602946855,
              0
            ],
            [
              -73.6592630700036,
              41.5156618970008,
              0
            ],
            [
              -73.6586684174055,
              41.5157565682585,
              0
            ],
            [
              -73.6578452010542,
              41.5158878766058,
              0
            ],
            [
              -73.6577828078392,
              41.515897828112,
              0
            ],
            [
              -73.6575138687163,
              41.5159407344842,
              0
            ],
            [
              -73.6574305849746,
              41.5159540031321,
              0
            ],
            [
              -73.6574291083038,
              41.5159542390394,
              0
            ],
            [
              -73.6573769424169,
              41.5159625561814,
              0
            ],
            [
              -73.6571868083624,
              41.5159928348113,
              0
            ],
            [
              -73.6569372510394,
              41.5160326654283,
              0
            ],
            [
              -73.6568269691231,
              41.5160502470235,
              0
            ],
            [
              -73.6566403492512,
              41.5160800039339,
              0
            ],
            [
              -73.6566322828002,
              41.5160812891666,
              0
            ],
            [
              -73.6559174053242,
              41.5161952410627,
              0
            ],
            [
              -73.655777252999,
              41.5162175063135,
              0
            ],
            [
              -73.6556763920031,
              41.5162335225258,
              0
            ],
            [
              -73.6543219641425,
              41.51644950784,
              0
            ],
            [
              -73.6537129161025,
              41.5165466228845,
              0
            ],
            [
              -73.6528398753216,
              41.5166857012516,
              0
            ],
            [
              -73.6526452480836,
              41.5167166992486,
              0
            ],
            [
              -73.6525079871942,
              41.5167385721029,
              0
            ],
            [
              -73.652118798454,
              41.5168007931416,
              0
            ],
            [
              -73.6521079199478,
              41.5168025372691,
              0
            ],
            [
              -73.6519787305632,
              41.516823091296,
              0
            ],
            [
              -73.65179581974,
              41.5168521572176,
              0
            ],
            [
              -73.6515651628187,
              41.5168890404834,
              0
            ],
            [
              -73.6515312151494,
              41.5168944692298,
              0
            ],
            [
              -73.6512622579993,
              41.5169373013919,
              0
            ],
            [
              -73.6509932993891,
              41.5169801266099,
              0
            ],
            [
              -73.6507480049999,
              41.5170191828375,
              0
            ],
            [
              -73.6504639796863,
              41.517064405134,
              0
            ],
            [
              -73.6502853840394,
              41.5170928413888,
              0
            ],
            [
              -73.6501218543342,
              41.5171188773225,
              0
            ],
            [
              -73.6497947957279,
              41.5171709493974,
              0
            ],
            [
              -73.6496506322234,
              41.5171939023838,
              0
            ],
            [
              -73.6494204035839,
              41.5172305575907,
              0
            ],
            [
              -73.6494176902647,
              41.5172309895533,
              0
            ],
            [
              -73.6492374898804,
              41.5172597607867,
              0
            ],
            [
              -73.6491750950895,
              41.5172697238108,
              0
            ],
            [
              -73.6486416129088,
              41.5173548581935,
              0
            ],
            [
              -73.6485079484708,
              41.5173761756943,
              0
            ],
            [
              -73.6482327626109,
              41.5174200658073,
              0
            ],
            [
              -73.6480309902486,
              41.5174520809103,
              0
            ],
            [
              -73.6478666903453,
              41.5174781493465,
              0
            ],
            [
              -73.6476922757834,
              41.5175058831748,
              0
            ],
            [
              -73.6459713633096,
              41.5177674007542,
              0
            ],
            [
              -73.6458296128444,
              41.5177888693964,
              0
            ],
            [
              -73.6453634988256,
              41.5178594620236,
              0
            ],
            [
              -73.6443606753056,
              41.518011706192,
              0
            ],
            [
              -73.6434760804291,
              41.5181461250759,
              0
            ],
            [
              -73.6429952571825,
              41.5182191594405,
              0
            ],
            [
              -73.6412064887825,
              41.5184908009633,
              0
            ],
            [
              -73.641008021129,
              41.5185208302801,
              0
            ],
            [
              -73.6406230807694,
              41.5185790730484,
              0
            ],
            [
              -73.6403887613638,
              41.5186148277365,
              0
            ],
            [
              -73.6403865896048,
              41.5186151590804,
              0
            ],
            [
              -73.6402919205566,
              41.5186296043401,
              0
            ],
            [
              -73.6399635769539,
              41.5186794740927,
              0
            ],
            [
              -73.6399559704512,
              41.5186806292257,
              0
            ],
            [
              -73.6399552957629,
              41.5186807313347,
              0
            ],
            [
              -73.6399358221055,
              41.5186836886813,
              0
            ],
            [
              -73.6389937659048,
              41.5188267649278,
              0
            ],
            [
              -73.6387914205323,
              41.5188575015578,
              0
            ],
            [
              -73.6348105984562,
              41.5194616330392,
              0
            ],
            [
              -73.631396402822,
              41.5199796537225,
              0
            ],
            [
              -73.6312887071587,
              41.5199959921851,
              0
            ],
            [
              -73.6306714790396,
              41.5200896293049,
              0
            ],
            [
              -73.6305861670492,
              41.5201027073646,
              0
            ],
            [
              -73.6291203948341,
              41.520325033604,
              0
            ],
            [
              -73.628865988437,
              41.5203636192867,
              0
            ],
            [
              -73.6273860894947,
              41.520588063915,
              0
            ],
            [
              -73.6273336586019,
              41.5205960151145,
              0
            ],
            [
              -73.6239958147856,
              41.5211021623218,
              0
            ],
            [
              -73.6222806651034,
              41.5213621728427,
              0
            ],
            [
              -73.6209964775239,
              41.5215571366411,
              0
            ],
            [
              -73.6206412058467,
              41.5216110711002,
              0
            ],
            [
              -73.620469207083,
              41.521637201733,
              0
            ],
            [
              -73.6199332526953,
              41.5217184729959,
              0
            ],
            [
              -73.6182774858481,
              41.5219695349772,
              0
            ],
            [
              -73.6165326612725,
              41.5222330509316,
              0
            ],
            [
              -73.6159887048576,
              41.5223151454622,
              0
            ],
            [
              -73.6159080494553,
              41.5223273182356,
              0
            ],
            [
              -73.6157702209555,
              41.5223370118181,
              0
            ],
            [
              -73.6133048399057,
              41.5225103757743,
              0
            ],
            [
              -73.6133047631444,
              41.5225103814856,
              0
            ],
            [
              -73.6131085848175,
              41.5225241278458,
              0
            ],
            [
              -73.6093000507809,
              41.5227917869232,
              0
            ],
            [
              -73.6092999332481,
              41.5227917950175,
              0
            ],
            [
              -73.606779795258,
              41.5229685127377,
              0
            ],
            [
              -73.6045378271723,
              41.5231256765551,
              0
            ],
            [
              -73.6045314225342,
              41.5231266559068,
              0
            ],
            [
              -73.6043141882932,
              41.5231524848291,
              0
            ],
            [
              -73.6043138354427,
              41.5231525271037,
              0
            ],
            [
              -73.604119888884,
              41.5231755871375,
              0
            ],
            [
              -73.6040497203927,
              41.5231839360978,
              0
            ],
            [
              -73.6029827697117,
              41.5233108861838,
              0
            ],
            [
              -73.6027437582151,
              41.5233393237781,
              0
            ],
            [
              -73.6027071388526,
              41.5233437627559,
              0
            ],
            [
              -73.6027068976066,
              41.5233437923896,
              0
            ],
            [
              -73.6011619728595,
              41.5235310545408,
              0
            ],
            [
              -73.6008068548919,
              41.5235740954263,
              0
            ],
            [
              -73.6004257902894,
              41.5236202801491,
              0
            ],
            [
              -73.5988056532269,
              41.5238166237532,
              0
            ],
            [
              -73.5944800317304,
              41.5243405115926,
              0
            ],
            [
              -73.5942845707335,
              41.5243641806142,
              0
            ],
            [
              -73.5922420364622,
              41.5246114943673,
              0
            ],
            [
              -73.5919477131384,
              41.5246471285472,
              0
            ],
            [
              -73.5897956420011,
              41.5249076574669,
              0
            ],
            [
              -73.5892365547213,
              41.52497618504,
              0
            ],
            [
              -73.5886532829148,
              41.5250476743336,
              0
            ],
            [
              -73.5881539146698,
              41.5251078715261,
              0
            ],
            [
              -73.5878273970444,
              41.5251476530015,
              0
            ],
            [
              -73.5871272152606,
              41.5252204771817,
              0
            ],
            [
              -73.5855066546087,
              41.5253890100657,
              0
            ],
            [
              -73.5848362000021,
              41.5254587276876,
              0
            ],
            [
              -73.5842425445293,
              41.5255195297694,
              0
            ],
            [
              -73.5838628535985,
              41.5255580174835,
              0
            ],
            [
              -73.5837407884233,
              41.5255702519655,
              0
            ],
            [
              -73.5834830297827,
              41.5255961255917,
              0
            ],
            [
              -73.5831594897592,
              41.5256287444852,
              0
            ],
            [
              -73.5828634794372,
              41.5256586060205,
              0
            ],
            [
              -73.5826019228733,
              41.525684990355,
              0
            ],
            [
              -73.5823431943671,
              41.5257110896058,
              0
            ],
            [
              -73.5822613856856,
              41.5257117108953,
              0
            ],
            [
              -73.5821440095894,
              41.5257126011254,
              0
            ],
            [
              -73.5819831933158,
              41.5257131921821,
              0
            ],
            [
              -73.5819685739801,
              41.5257139318087,
              0
            ],
            [
              -73.5794195176379,
              41.5258442571212,
              0
            ],
            [
              -73.5792411230776,
              41.5258533705181,
              0
            ],
            [
              -73.5791905333057,
              41.5258560035804,
              0
            ],
            [
              -73.5791901100184,
              41.5258560254038,
              0
            ],
            [
              -73.5789241002454,
              41.5258698709659,
              0
            ],
            [
              -73.5789240570755,
              41.5258698733215,
              0
            ],
            [
              -73.5787799362226,
              41.5259693233233,
              0
            ],
            [
              -73.5784197439038,
              41.5259901174975,
              0
            ],
            [
              -73.5771275663364,
              41.5260684838545,
              0
            ],
            [
              -73.5750429968622,
              41.5261854201556,
              0
            ],
            [
              -73.5736694144778,
              41.5262632990256,
              0
            ],
            [
              -73.5736689203954,
              41.526263327462,
              0
            ],
            [
              -73.5736023094493,
              41.5262861271018,
              0
            ],
            [
              -73.5735809193791,
              41.5262934483828,
              0
            ],
            [
              -73.5735707455199,
              41.5262944253572,
              0
            ],
            [
              -73.5730169845661,
              41.5263486725617,
              0
            ],
            [
              -73.5724951271002,
              41.5263999084658,
              0
            ],
            [
              -73.572425761461,
              41.5264059700263,
              0
            ],
            [
              -73.572418441881,
              41.5264066052369,
              0
            ],
            [
              -73.5723938914431,
              41.5264087546941,
              0
            ],
            [
              -73.572387996346,
              41.5264092384106,
              0
            ],
            [
              -73.5723437610651,
              41.5264130677992,
              0
            ],
            [
              -73.5720264085506,
              41.5264449515688,
              0
            ],
            [
              -73.5717621700891,
              41.5264714984865,
              0
            ],
            [
              -73.5706975293209,
              41.5265783842469,
              0
            ],
            [
              -73.5694072978472,
              41.5266942627617,
              0
            ],
            [
              -73.5694009431803,
              41.5266948713711,
              0
            ],
            [
              -73.5694000949012,
              41.5266949491493,
              0
            ],
            [
              -73.5685305618883,
              41.5267782033047,
              0
            ],
            [
              -73.5665481982708,
              41.5269685017611,
              0
            ],
            [
              -73.5661638759243,
              41.5270146120896,
              0
            ],
            [
              -73.5661009487795,
              41.5270140713447,
              0
            ],
            [
              -73.5659860835709,
              41.5270130835105,
              0
            ],
            [
              -73.5644567499162,
              41.5270229181962,
              0
            ],
            [
              -73.5636359419991,
              41.5270272222088,
              0
            ],
            [
              -73.5633901857872,
              41.5270285101966,
              0
            ],
            [
              -73.5622519440722,
              41.5270158480649,
              0
            ],
            [
              -73.5621128115265,
              41.5270142991829,
              0
            ],
            [
              -73.5621023533284,
              41.5270146172905,
              0
            ],
            [
              -73.5620832243126,
              41.5270151996462,
              0
            ],
            [
              -73.5618222536278,
              41.5270231379235,
              0
            ],
            [
              -73.5615535099661,
              41.5270313120266,
              0
            ],
            [
              -73.5615444795146,
              41.5270315868071,
              0
            ],
            [
              -73.5599760248898,
              41.5270220898171,
              0
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "STATEFP": "36",
        "COUNTYFP": "087",
        "COUNTYNS": "00974142",
        "GEOIDFQ": "0500000US36087",
        "GEOID": "36087",
        "NAME": "Rockland",
        "NAMELSAD": "Rockland County",
        "STUSPS": "NY",
        "STATE_NAME": "New York",
        "LSAD": "06",
        "ALAND": 449840998,
        "AWATER": 66919666
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -74.212195,
              41.15927
            ],
            [
              -74.194122,
              41.172684
            ],
            [
              -74.186572,
              41.178266
            ],
            [
              -74.185577,
              41.179023
            ],
            [
              -74.162255,
              41.195905
            ],
            [
              -74.151419,
              41.203736
            ],
            [
              -74.143224,
              41.209619
            ],
            [
              -74.108421,
              41.234596
            ],
            [
              -74.104898,
              41.237129
            ],
            [
              -74.099394,
              41.241127
            ],
            [
              -74.069896,
              41.262026
            ],
            [
              -74.024025,
              41.294412
            ],
            [
              -73.984956,
              41.322442
            ],
            [
              -73.980754,
              41.32542
            ],
            [
              -73.981384,
              41.324693
            ],
            [
              -73.982532,
              41.321824
            ],
            [
              -73.983284,
              41.317393
            ],
            [
              -73.980984,
              41.314193
            ],
            [
              -73.977484,
              41.312093
            ],
            [
              -73.971784,
              41.307293
            ],
            [
              -73.966983,
              41.301693
            ],
            [
              -73.964483,
              41.299693
            ],
            [
              -73.955183,
              41.294993
            ],
            [
              -73.949083,
              41.292593
            ],
            [
              -73.946583,
              41.290993
            ],
            [
              -73.945783,
              41.287593
            ],
            [
              -73.947483,
              41.284593
            ],
            [
              -73.952045,
              41.280736
            ],
            [
              -73.957183,
              41.276393
            ],
            [
              -73.964184,
              41.269993
            ],
            [
              -73.966884,
              41.267193
            ],
            [
              -73.969684,
              41.263193
            ],
            [
              -73.971484,
              41.259593
            ],
            [
              -73.972284,
              41.256193
            ],
            [
              -73.971984,
              41.251493
            ],
            [
              -73.970784,
              41.247893
            ],
            [
              -73.964142,
              41.243851
            ],
            [
              -73.961283,
              41.241994
            ],
            [
              -73.960783,
              41.239394
            ],
            [
              -73.961383,
              41.234194
            ],
            [
              -73.957983,
              41.231694
            ],
            [
              -73.953283,
              41.228994
            ],
            [
              -73.950947,
              41.226346
            ],
            [
              -73.947965,
              41.223101
            ],
            [
              -73.944683,
              41.219594
            ],
            [
              -73.939983,
              41.214494
            ],
            [
              -73.936782,
              41.210814
            ],
            [
              -73.935982,
              41.209894
            ],
            [
              -73.931482,
              41.204994
            ],
            [
              -73.927229,
              41.198038
            ],
            [
              -73.925682,
              41.195194
            ],
            [
              -73.921697,
              41.186288
            ],
            [
              -73.914381,
              41.174195
            ],
            [
              -73.911681,
              41.167795
            ],
            [
              -73.909281,
              41.164395
            ],
            [
              -73.906581,
              41.161895
            ],
            [
              -73.899681,
              41.157295
            ],
            [
              -73.895381,
              41.153995
            ],
            [
              -73.892481,
              41.150595
            ],
            [
              -73.88948,
              41.145095
            ],
            [
              -73.88748,
              41.138295
            ],
            [
              -73.887397,
              41.136861
            ],
            [
              -73.88718,
              41.133095
            ],
            [
              -73.88758,
              41.128795
            ],
            [
              -73.890866,
              41.110583
            ],
            [
              -73.891417,
              41.107318
            ],
            [
              -73.89379,
              41.093193
            ],
            [
              -73.89488,
              41.082396
            ],
            [
              -73.894777,
              41.070791
            ],
            [
              -73.89478,
              41.070496
            ],
            [
              -73.894713,
              41.070023
            ],
            [
              -73.89448,
              41.064596
            ],
            [
              -73.89388,
              41.057896
            ],
            [
              -73.89038,
              41.045796
            ],
            [
              -73.89028,
              41.045196
            ],
            [
              -73.88938,
              41.037597
            ],
            [
              -73.889915,
              41.025749
            ],
            [
              -73.890079,
              41.022597
            ],
            [
              -73.893579,
              41.005297
            ],
            [
              -73.893984026368997,
              40.997170191723399
            ],
            [
              -73.90268,
              40.997297
            ],
            [
              -73.919881,
              41.00503
            ],
            [
              -73.920238280263604,
              41.005190375636801
            ],
            [
              -73.921784200424199,
              41.0058843068594
            ],
            [
              -73.939065148654294,
              41.013641363038502
            ],
            [
              -73.945117265213597,
              41.016358031564302
            ],
            [
              -73.945146829820601,
              41.016371302497902
            ],
            [
              -73.951879098265096,
              41.019393276977702
            ],
            [
              -73.953004064555401,
              41.019898250813398
            ],
            [
              -73.958906744099096,
              41.0225478401888
            ],
            [
              -73.966574282354003,
              41.025989637722503
            ],
            [
              -73.967056606659995,
              41.0262061430142
            ],
            [
              -73.976531,
              41.030459
            ],
            [
              -73.977283635840294,
              41.030793317294702
            ],
            [
              -73.993757093942804,
              41.038110749779698
            ],
            [
              -74.012700902975993,
              41.046525500510597
            ],
            [
              -74.013489204646106,
              41.046875660398896
            ],
            [
              -74.013493704866093,
              41.046877659375397
            ],
            [
              -74.024540512770002,
              41.051784599406403
            ],
            [
              -74.025812188386396,
              41.052349471724497
            ],
            [
              -74.029442829650804,
              41.053962185470702
            ],
            [
              -74.031383,
              41.054824
            ],
            [
              -74.037294590897005,
              41.057451118125996
            ],
            [
              -74.050819480108004,
              41.063461595207002
            ],
            [
              -74.057203776369704,
              41.066298784167401
            ],
            [
              -74.057210167665602,
              41.066301624467002
            ],
            [
              -74.067887898300199,
              41.071046820842
            ],
            [
              -74.071824082352506,
              41.072796065783301
            ],
            [
              -74.081702807747902,
              41.0771861832661
            ],
            [
              -74.0817040202177,
              41.077186722089102
            ],
            [
              -74.0912159413366,
              41.081413831309
            ],
            [
              -74.091236082459702,
              41.081422782048399
            ],
            [
              -74.092362133006006,
              41.0819232002696
            ],
            [
              -74.093057,
              41.082232
            ],
            [
              -74.096778584553206,
              41.083872995479403
            ],
            [
              -74.103981997144203,
              41.087049268201199
            ],
            [
              -74.1207554207448,
              41.094445341542901
            ],
            [
              -74.120762431309501,
              41.094448432781299
            ],
            [
              -74.127249041258295,
              41.097308638548697
            ],
            [
              -74.129496874366595,
              41.098299798071302
            ],
            [
              -74.131738,
              41.099288
            ],
            [
              -74.142362733600905,
              41.103925957122897
            ],
            [
              -74.146696651468801,
              41.105817818698
            ],
            [
              -74.149831844455605,
              41.107186407425999
            ],
            [
              -74.149932267368698,
              41.1072302444936
            ],
            [
              -74.1583290122704,
              41.1108956298377
            ],
            [
              -74.162755891783902,
              41.112828071453997
            ],
            [
              -74.182356,
              41.121384
            ],
            [
              -74.195303696008693,
              41.126809263241498
            ],
            [
              -74.2064532124094,
              41.131481064421301
            ],
            [
              -74.211326583784,
              41.133523074255599
            ],
            [
              -74.234299970671302,
              41.143149240279897
            ],
            [
              -74.212195,
              41.15927
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "STATEFP": "36",
        "COUNTYFP": "119",
        "COUNTYNS": "00974157",
        "GEOIDFQ": "0500000US36119",
        "GEOID": "36119",
        "NAME": "Westchester",
        "NAMELSAD": "Westchester County",
        "STUSPS": "NY",
        "STATE_NAME": "New York",
        "LSAD": "06",
        "ALAND": 1115811940,
        "AWATER": 179391718
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -73.772371,
                40.884793
              ],
              [
                -73.771462,
                40.887452
              ],
              [
                -73.770373,
                40.887804
              ],
              [
                -73.76707,
                40.886032
              ],
              [
                -73.768221,
                40.882624
              ],
              [
                -73.767715,
                40.881038
              ],
              [
                -73.769903,
                40.880021
              ],
              [
                -73.774013,
                40.882641
              ],
              [
                -73.772371,
                40.884793
              ]
            ]
          ],
          [
            [
              [
                -73.982532,
                41.321824
              ],
              [
                -73.926846,
                41.32764
              ],
              [
                -73.918286,
                41.328532
              ],
              [
                -73.914027,
                41.32897
              ],
              [
                -73.893433,
                41.33115
              ],
              [
                -73.893025,
                41.331184
              ],
              [
                -73.89227,
                41.331245
              ],
              [
                -73.887788,
                41.331738
              ],
              [
                -73.883367,
                41.332235
              ],
              [
                -73.875052,
                41.333023
              ],
              [
                -73.861933,
                41.334382
              ],
              [
                -73.842726,
                41.336397
              ],
              [
                -73.829958,
                41.337675
              ],
              [
                -73.822108,
                41.338456
              ],
              [
                -73.815834,
                41.339082
              ],
              [
                -73.797361,
                41.340922
              ],
              [
                -73.788183,
                41.341852
              ],
              [
                -73.780334,
                41.342647
              ],
              [
                -73.772044,
                41.343486
              ],
              [
                -73.771797,
                41.343511
              ],
              [
                -73.758296,
                41.344875
              ],
              [
                -73.753122,
                41.345342
              ],
              [
                -73.753002,
                41.345412
              ],
              [
                -73.735772,
                41.347194
              ],
              [
                -73.72749,
                41.348062
              ],
              [
                -73.725189,
                41.348299
              ],
              [
                -73.71978,
                41.348863
              ],
              [
                -73.718674,
                41.348976
              ],
              [
                -73.699944,
                41.350888
              ],
              [
                -73.694725,
                41.351421
              ],
              [
                -73.689494,
                41.351954
              ],
              [
                -73.671686,
                41.353857
              ],
              [
                -73.661625,
                41.354979
              ],
              [
                -73.660619,
                41.355026
              ],
              [
                -73.659871,
                41.355099
              ],
              [
                -73.659031,
                41.355183
              ],
              [
                -73.641248,
                41.356974
              ],
              [
                -73.628491,
                41.358181
              ],
              [
                -73.599938,
                41.360802
              ],
              [
                -73.594003,
                41.361439
              ],
              [
                -73.587065,
                41.362074
              ],
              [
                -73.585035,
                41.362407
              ],
              [
                -73.572544,
                41.363677
              ],
              [
                -73.560247,
                41.364942
              ],
              [
                -73.544707018985406,
                41.366539998047699
              ],
              [
                -73.544728,
                41.366375
              ],
              [
                -73.545242504135302,
                41.361517450709897
              ],
              [
                -73.548111037585699,
                41.334434981069101
              ],
              [
                -73.548586968617101,
                41.329941609131403
              ],
              [
                -73.548973,
                41.326297
              ],
              [
                -73.549526591311604,
                41.316748701271301
              ],
              [
                -73.549574,
                41.315931
              ],
              [
                -73.548929,
                41.307598
              ],
              [
                -73.549378124440594,
                41.304906789769099
              ],
              [
                -73.5499011747021,
                41.301772606705903
              ],
              [
                -73.550961,
                41.295422
              ],
              [
                -73.548875006924604,
                41.292943742640603
              ],
              [
                -73.548148387965597,
                41.292080485325002
              ],
              [
                -73.540537094692596,
                41.283037912849203
              ],
              [
                -73.526286891435802,
                41.266108004734697
              ],
              [
                -73.525160589949294,
                41.264769905878602
              ],
              [
                -73.518384,
                41.256719
              ],
              [
                -73.517427444949305,
                41.255540325760997
              ],
              [
                -73.5025525269551,
                41.237211341315202
              ],
              [
                -73.482709,
                41.21276
              ],
              [
                -73.484911193356893,
                41.211777574059198
              ],
              [
                -73.494008097509194,
                41.207719331583903
              ],
              [
                -73.495935931045807,
                41.206859300983098
              ],
              [
                -73.503946592569207,
                41.2032856449013
              ],
              [
                -73.509182793098105,
                41.2009497104956
              ],
              [
                -73.509186500658402,
                41.200948056506697
              ],
              [
                -73.509487,
                41.200814
              ],
              [
                -73.512593112797106,
                41.199372957415797
              ],
              [
                -73.514617,
                41.198434
              ],
              [
                -73.535927267825301,
                41.1885825956861
              ],
              [
                -73.535995955855,
                41.1885508422817
              ],
              [
                -73.554650073694404,
                41.1799273346628
              ],
              [
                -73.564758672164203,
                41.175254287313599
              ],
              [
                -73.564941,
                41.17517
              ],
              [
                -73.579154105282697,
                41.168773341342302
              ],
              [
                -73.586173757339395,
                41.1656141219311
              ],
              [
                -73.587454111164504,
                41.1650378941317
              ],
              [
                -73.597069884730601,
                41.160710280988198
              ],
              [
                -73.614464558520993,
                41.152881746091403
              ],
              [
                -73.628814858647203,
                41.146423342405797
              ],
              [
                -73.632153,
                41.144921
              ],
              [
                -73.633975019844002,
                41.144090804497203
              ],
              [
                -73.639672,
                41.141495
              ],
              [
                -73.660504402925994,
                41.131847868722097
              ],
              [
                -73.668433402128599,
                41.128176084123702
              ],
              [
                -73.695948890934702,
                41.115434129504699
              ],
              [
                -73.696006011492599,
                41.115407677946401
              ],
              [
                -73.712292625506905,
                41.107865624155203
              ],
              [
                -73.727775,
                41.100696
              ],
              [
                -73.722575,
                41.093596
              ],
              [
                -73.717815162943495,
                41.0885856452037
              ],
              [
                -73.716875,
                41.087596
              ],
              [
                -73.706163059898998,
                41.074183562832602
              ],
              [
                -73.694273,
                41.059296
              ],
              [
                -73.694263023397198,
                41.059283917069401
              ],
              [
                -73.692434786772296,
                41.057069690768301
              ],
              [
                -73.687173,
                41.050697
              ],
              [
                -73.679973,
                41.041797
              ],
              [
                -73.675786359915193,
                41.036641364909798
              ],
              [
                -73.675650243684302,
                41.036473744669699
              ],
              [
                -73.6722427528981,
                41.0322775924543
              ],
              [
                -73.670472,
                41.030097
              ],
              [
                -73.666558720383804,
                41.025280655857003
              ],
              [
                -73.666554472941201,
                41.025275428235297
              ],
              [
                -73.666439140728698,
                41.025133480896898
              ],
              [
                -73.662672,
                41.020497
              ],
              [
                -73.660412955833095,
                41.018352237556599
              ],
              [
                -73.658679,
                41.016706
              ],
              [
                -73.656117,
                41.013135
              ],
              [
                -73.655667929187203,
                41.012671863164101
              ],
              [
                -73.655662307950806,
                41.0126660658565
              ],
              [
                -73.655255,
                41.012246
              ],
              [
                -73.655241,
                41.011852
              ],
              [
                -73.656065,
                41.008923
              ],
              [
                -73.657924599289501,
                41.0051892007126
              ],
              [
                -73.658510716712598,
                41.004012363945201
              ],
              [
                -73.658517268861502,
                41.003999208202899
              ],
              [
                -73.660268,
                41.000484
              ],
              [
                -73.659309,
                40.997171
              ],
              [
                -73.659500700282095,
                40.995525863033997
              ],
              [
                -73.659639,
                40.994339
              ],
              [
                -73.657228,
                40.990914
              ],
              [
                -73.659005,
                40.988857
              ],
              [
                -73.661895,
                40.988606
              ],
              [
                -73.663111771449493,
                40.986640446120099
              ],
              [
                -73.664911,
                40.983734
              ],
              [
                -73.664259225620896,
                40.983261888847998
              ],
              [
                -73.662114,
                40.981708
              ],
              [
                -73.660494908986294,
                40.981987628065603
              ],
              [
                -73.658113,
                40.982399
              ],
              [
                -73.656297,
                40.979725
              ],
              [
                -73.659011,
                40.975241
              ],
              [
                -73.659883209190497,
                40.970400752986997
              ],
              [
                -73.660114,
                40.96912
              ],
              [
                -73.66284,
                40.966762
              ],
              [
                -73.665725,
                40.967583
              ],
              [
                -73.677615,
                40.964196
              ],
              [
                -73.679120565561504,
                40.9602089074981
              ],
              [
                -73.683113,
                40.949636
              ],
              [
                -73.685394,
                40.948835
              ],
              [
                -73.686473,
                40.945198
              ],
              [
                -73.692678,
                40.944206
              ],
              [
                -73.695413,
                40.940002
              ],
              [
                -73.69747,
                40.939493
              ],
              [
                -73.698303,
                40.940501
              ],
              [
                -73.692576,
                40.953523
              ],
              [
                -73.693223,
                40.955019
              ],
              [
                -73.693480812631606,
                40.954983460130499
              ],
              [
                -73.695392,
                40.95472
              ],
              [
                -73.697920229851206,
                40.951038287317402
              ],
              [
                -73.701128,
                40.946367
              ],
              [
                -73.704904,
                40.940344
              ],
              [
                -73.70718,
                40.939435
              ],
              [
                -73.708734,
                40.940622
              ],
              [
                -73.707885,
                40.942657
              ],
              [
                -73.708796,
                40.944738
              ],
              [
                -73.713594351931306,
                40.944588051502102
              ],
              [
                -73.715964,
                40.944514
              ],
              [
                -73.720618,
                40.940981
              ],
              [
                -73.720803710027894,
                40.939499295727103
              ],
              [
                -73.721739,
                40.932037
              ],
              [
                -73.727212,
                40.927372
              ],
              [
                -73.734353,
                40.921536
              ],
              [
                -73.73583,
                40.923743
              ],
              [
                -73.737493,
                40.928053
              ],
              [
                -73.738647593538005,
                40.927965567590697
              ],
              [
                -73.742247,
                40.927693
              ],
              [
                -73.743089550880896,
                40.925511178037397
              ],
              [
                -73.743493515623697,
                40.924465093856597
              ],
              [
                -73.743911,
                40.923384
              ],
              [
                -73.743878156742497,
                40.922133051711299
              ],
              [
                -73.743764,
                40.917785
              ],
              [
                -73.746536997557399,
                40.916679807459801
              ],
              [
                -73.747567798210099,
                40.9162689765203
              ],
              [
                -73.754884862132101,
                40.913352722793
              ],
              [
                -73.756776,
                40.912599
              ],
              [
                -73.761686898256897,
                40.9064438495177
              ],
              [
                -73.76465,
                40.90273
              ],
              [
                -73.766558,
                40.89731
              ],
              [
                -73.778023256552601,
                40.888107541374502
              ],
              [
                -73.781338,
                40.885447
              ],
              [
                -73.783076,
                40.881977
              ],
              [
                -73.783911,
                40.881683
              ],
              [
                -73.786049,
                40.882374
              ],
              [
                -73.786672,
                40.883611
              ],
              [
                -73.787084794882304,
                40.883969098391603
              ],
              [
                -73.787555,
                40.884377
              ],
              [
                -73.788809,
                40.884305
              ],
              [
                -73.789969,
                40.883685
              ],
              [
                -73.791537,
                40.88415
              ],
              [
                -73.79254,
                40.883981
              ],
              [
                -73.792977768397805,
                40.883353861939398
              ],
              [
                -73.819719,
                40.890206
              ],
              [
                -73.823244,
                40.891199
              ],
              [
                -73.822363,
                40.88964
              ],
              [
                -73.824047,
                40.889866
              ],
              [
                -73.833595,
                40.892706
              ],
              [
                -73.837337,
                40.893814
              ],
              [
                -73.838407,
                40.894061
              ],
              [
                -73.838985,
                40.895602
              ],
              [
                -73.839655,
                40.897249
              ],
              [
                -73.839649,
                40.897891
              ],
              [
                -73.839155,
                40.899226
              ],
              [
                -73.840999,
                40.902812
              ],
              [
                -73.841386,
                40.904174
              ],
              [
                -73.842374,
                40.904166
              ],
              [
                -73.84442,
                40.904172
              ],
              [
                -73.844949,
                40.905556
              ],
              [
                -73.847088,
                40.906136
              ],
              [
                -73.848653,
                40.906778
              ],
              [
                -73.850138,
                40.907496
              ],
              [
                -73.851473,
                40.9067
              ],
              [
                -73.852688,
                40.907143
              ],
              [
                -73.851123,
                40.910009
              ],
              [
                -73.852678,
                40.909899
              ],
              [
                -73.854881,
                40.908217
              ],
              [
                -73.854104,
                40.906679
              ],
              [
                -73.856324,
                40.906166
              ],
              [
                -73.857199,
                40.902878
              ],
              [
                -73.859604,
                40.902178
              ],
              [
                -73.859393,
                40.900381
              ],
              [
                -73.862643,
                40.901474
              ],
              [
                -73.864669,
                40.901793
              ],
              [
                -73.865635,
                40.902086
              ],
              [
                -73.867876,
                40.902983
              ],
              [
                -73.872913,
                40.904467
              ],
              [
                -73.877855,
                40.905922
              ],
              [
                -73.879239,
                40.906365
              ],
              [
                -73.880929,
                40.90683
              ],
              [
                -73.882993,
                40.907423
              ],
              [
                -73.885401,
                40.907977
              ],
              [
                -73.886237,
                40.908052
              ],
              [
                -73.891928,
                40.909809
              ],
              [
                -73.896634,
                40.911324
              ],
              [
                -73.897253,
                40.911655
              ],
              [
                -73.899505,
                40.911978
              ],
              [
                -73.900697,
                40.912381
              ],
              [
                -73.902454,
                40.912979
              ],
              [
                -73.910516,
                40.915282
              ],
              [
                -73.918317529127094,
                40.917705209721703
              ],
              [
                -73.917609625411998,
                40.9194912478847
              ],
              [
                -73.9154668989041,
                40.924897338055402
              ],
              [
                -73.914253,
                40.92796
              ],
              [
                -73.912025339677896,
                40.935479671398397
              ],
              [
                -73.9102427673362,
                40.941496907563597
              ],
              [
                -73.90728,
                40.951498
              ],
              [
                -73.907247953698004,
                40.951585410778002
              ],
              [
                -73.904857703310995,
                40.958105153549702
              ],
              [
                -73.898728844333505,
                40.974822474979298
              ],
              [
                -73.896144,
                40.981873
              ],
              [
                -73.893628,
                40.997165
              ],
              [
                -73.893984026368997,
                40.997170191723399
              ],
              [
                -73.893579,
                41.005297
              ],
              [
                -73.890079,
                41.022597
              ],
              [
                -73.889915,
                41.025749
              ],
              [
                -73.88938,
                41.037597
              ],
              [
                -73.89028,
                41.045196
              ],
              [
                -73.89038,
                41.045796
              ],
              [
                -73.89388,
                41.057896
              ],
              [
                -73.89448,
                41.064596
              ],
              [
                -73.894713,
                41.070023
              ],
              [
                -73.89478,
                41.070496
              ],
              [
                -73.894777,
                41.070791
              ],
              [
                -73.89488,
                41.082396
              ],
              [
                -73.89379,
                41.093193
              ],
              [
                -73.891417,
                41.107318
              ],
              [
                -73.890866,
                41.110583
              ],
              [
                -73.88758,
                41.128795
              ],
              [
                -73.88718,
                41.133095
              ],
              [
                -73.887397,
                41.136861
              ],
              [
                -73.88748,
                41.138295
              ],
              [
                -73.88948,
                41.145095
              ],
              [
                -73.892481,
                41.150595
              ],
              [
                -73.895381,
                41.153995
              ],
              [
                -73.899681,
                41.157295
              ],
              [
                -73.906581,
                41.161895
              ],
              [
                -73.909281,
                41.164395
              ],
              [
                -73.911681,
                41.167795
              ],
              [
                -73.914381,
                41.174195
              ],
              [
                -73.921697,
                41.186288
              ],
              [
                -73.925682,
                41.195194
              ],
              [
                -73.927229,
                41.198038
              ],
              [
                -73.931482,
                41.204994
              ],
              [
                -73.935982,
                41.209894
              ],
              [
                -73.936782,
                41.210814
              ],
              [
                -73.939983,
                41.214494
              ],
              [
                -73.944683,
                41.219594
              ],
              [
                -73.947965,
                41.223101
              ],
              [
                -73.950947,
                41.226346
              ],
              [
                -73.953283,
                41.228994
              ],
              [
                -73.957983,
                41.231694
              ],
              [
                -73.961383,
                41.234194
              ],
              [
                -73.960783,
                41.239394
              ],
              [
                -73.961283,
                41.241994
              ],
              [
                -73.964142,
                41.243851
              ],
              [
                -73.970784,
                41.247893
              ],
              [
                -73.971984,
                41.251493
              ],
              [
                -73.972284,
                41.256193
              ],
              [
                -73.971484,
                41.259593
              ],
              [
                -73.969684,
                41.263193
              ],
              [
                -73.966884,
                41.267193
              ],
              [
                -73.964184,
                41.269993
              ],
              [
                -73.957183,
                41.276393
              ],
              [
                -73.952045,
                41.280736
              ],
              [
                -73.947483,
                41.284593
              ],
              [
                -73.945783,
                41.287593
              ],
              [
                -73.946583,
                41.290993
              ],
              [
                -73.949083,
                41.292593
              ],
              [
                -73.955183,
                41.294993
              ],
              [
                -73.964483,
                41.299693
              ],
              [
                -73.966983,
                41.301693
              ],
              [
                -73.971784,
                41.307293
              ],
              [
                -73.977484,
                41.312093
              ],
              [
                -73.980984,
                41.314193
              ],
              [
                -73.983284,
                41.317393
              ],
              [
                -73.982532,
                41.321824
              ]
            ]
          ]
        ]
      }
    }
  ]
}